import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import * as _moment from 'node_modules/moment/moment';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { UserMultiColumnDropdownComponent } from '../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { element } from 'protractor';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { constants } from 'src/app/shared/common/contants';
import * as fs from 'fs'; 
import { RowDragEnterEvent, RowDragMoveEvent, RowDragEndEvent, RowDragLeaveEvent } from 'ag-grid-community';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { CustomCellRenderer } from '../../shared/common/CustomCellRenderer';
import { catchError, concatMap, delay, filter, finalize, map, tap } from 'rxjs/operators';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { VaultObjectgroupService } from './../vaultobject-popup-screen/vault-objectgroup.service';
import { BuildButton } from 'src/app/shared/common/BuildButton';
import { DatasetActionButtons } from 'src/app/shared/common/DatasetActionButtons';
import { VerifyMappingComponent } from 'src/app/user/attribute-mapping-config/verify-mapping/verify-mapping.component';
import { FilterspopupComponent } from '../filters/filterspopup/filterspopup.component';
import { ActionwithcheckboxComponent } from 'src/app/shared/common/Actionwithcheckbox';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { ViewResultsComponent } from 'src/app/user/attribute-mapping-config/view-results/view-results.component'
import { MatSelectChange } from '@angular/material/select';
import { UserRoutingModule } from 'src/app/user/user-routing/user-routing.module';
import { CopydatasetDialogComponent } from 'src/app/user/report-configuration/copydataset-dialog/copydataset-dialog.component';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole'
import { AccessPermissionComponent } from '../report-configuration/access-permission/access-permission.component';
import { SelectFiltersPopUpComponent } from '../report-configuration/select-filters-pop-up/select-filters-pop-up.component';
import { ExportDialogComponent } from '../report-configuration/export-dialog/export-dialog.component';
import { ImportDialogComponent } from '../report-configuration/import-dialog/import-dialog.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { UploadExcelFileComponent } from '../upload-excel-file/upload-excel-file.component';
import { CommonPopupSearchComponent } from '../common-popup-search/common-popup-search.component';
import { FieldMappingService } from 'src/app/shared/services/field-mapping.service';
import { AttributeMappingConfigService } from 'src/app/shared/services/attribute-mapping-config.service';
import { RestApi } from "src/app/shared/RestApi/restApi";
import { JMigratorService } from "../jmigrator-tools/JMigrator.Service";
import { forkJoin, of } from 'rxjs';

const moment = _moment;

export interface ConditionalOPeratorTypeWhere {
  name: string,
  value: string
}

export interface Constants {
  name: string,
  value: string
}

export interface LogicalOperatorTypeWhere {
  name: string,
  value: string
}

export interface ArrangeTypeOrderBy {
  name: string,
  value: string
}

export interface AggregateDataBy {
  name: string,
  value: string
}

export interface ArrangeMyDataBy {
  name: string,
  value: string
}

export interface ArrangeMyTypeBy {
  name: string,
  value: string
}

export interface Types {
  type: string;
}

interface Rule {
  type: 'rule';
  object?: string;
  field?: string;
  operator: string;
  value?: any;
  rhsObject?: string;
  rhsField?: string;
  availableAttributes?: string[];
  rhsAvailableAttributes?: string[];
}


interface RuleGroup {
  type: 'group';
  condition: 'AND' | 'OR';
  rules: (Rule | RuleGroup)[];
}

@Component({
    selector: 'app-stage-object',
    templateUrl: './stage-object.component.html',
    styleUrls: ['./stage-object.component.scss'],
    standalone: false
})
/**
   *@Author : Shyam
   * @Date :08-02-2025
   *@Note Stage Object component
   */
export class StageObjectComponent implements OnInit {
  // @ViewChild('codeEditor') codeEditor!: ElementRef;
  // editor: CodeMirror.EditorFromTextArea | null = null;
  expressionDetails: string = "";
  selectedObjectsAndAttributes: any[] = [
  { object: 'case_version__v', name: 'id' },
  { object: 'case_version__v', name: 'case_number__v' },
  { object: 'product__v', name: 'name__v' }
];
  sqlTables: Record<string, string[]> = {};
    rootGroup: RuleGroup = {
    type: 'group',
    condition: 'AND',
    rules: []
  };
  fields = ['age', 'status', 'name'];
  operators = [ 
  '=', '!=', '>', '<', '>=', '<=',
  'LIKE', 'IN', 'IS NULL', 'IS NOT NULL',
  '= (field)', '!= (field)', '> (field)', '< (field)'
];

  sqlWhereClause=""
navLinks = [ 
      {
        label: 'Objects',
        link: 'trnxBaseComponent?screenType=Dynamic%2FTransactions&tableName=objectmetadata&headerNameHtml=Objects',
        index: 0
      },
      {
        label: 'Stage Objects',
        link: 'stageobject',
        index: 1
      },
       {
        label: 'Objects Mapping',
        link: 'mappingconfiguration',
        index: 1
      },
      {
        label: 'Attributes Mapping',
        link: 'attributemappingconfig',
        index: 1
      },
      {
        label: 'Value Mapping',
        link: 'fieldMapping',
        index: 1
      },
       {
        label: 'Exception Queries',
        link: 'exceptionQueries',
        index: 1
      }
      
    ];
   activeLinkIndex = 1;
  jsuitepropertyValue: any;
  sharedData: any;
  autoRefreshDataset: any 
  generateDefaultTemplate: any = true;
  applyRecordFilter: any = false;
  public UserRolesWithRoleId: any[];
  private responserequest: any;
  ButtonApprove = 'Approve'
  s3DataSize

  //ngModel
  columnFilter = [];
  columnFilterData = { "name": "", "object": "", "alias": "", "filters": [] };
  columnFilterDataObject = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };

  whereData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };

  recordfilterData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };

  rollingupdata = { "parentObjectName": "", "parentattribute": "", "childObjectName": "", "childattributes": "", "parentAttributesalias": "", "childAttributesalias": "", "rollupColumnAlias": "", "rollingUpLevel": "1" };

  rollingupdatatemp = { "childattributes": [], "childAttributesalias": [] };

  barArray = { "type": "column", "xKey": "", "yKeys": "", "grouped": "true", "label": "{}", "strokeWidth": "0" };

  groupByData = { "fieldsGroupBy": "" };

  orderByData = { "objectOrderBy": "", "fieldsOrderBy": "", "arrangeOrderBy": "" };
  headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };


  //aggregateByData = { "objectAggregateBy": "", "fieldsAggregateBy": "", "arrangeaggregateBy": "" };

  aggregateByData = {
    "aggregateOn": "", "aggregateFunction": "", "partionOn": "", "distinctColumns": "", "columnAlias": "", "conditionalValue": "", "groupByNeeded": false, "groupByFunction": ""
  };
  pivotAggregateByData={
    "columnAlias":"",
    "caseColumn":"",
    "pivotColumn":"",
    "childColumns":"",
    "headerValueColumn":"",
    "orderByColumn":"",
    "parentcolumns":"",
    "headersToNull":""
    
  }
  subAggregateLevelData = { "groupByColumn": "", "groupByNeeded": true, "alias": "" };
  datasetFormByData = { "namedatasetBy": "", "typedatasetBy": "", "detailsdatasetBy": "", "accesstypedatasetBy": "" };

  formulaFieldsByData = { "labelformulafieldsBy": "", "returntypeformulafieldsBy": "", "objectformulafieldsBy": "", "functionsformulafieldsBy": "", "oprationsformulafieldsBy": "" };

  reportingObject = { "from": "", "queryArray": [], "join": [], "firstJoin": [], "secondJoin": [], "thirdJoin": [], "fourthJoin": [] };

  reportingObjectSend = { "reportMainConfigurationId": "", "object": "", "queryArray": [], "from": "", "joins": [], "where": [], "groupBy": [], "orderBy": [], "type": "", "name": "", "userAccess": "", "aggregateBy": [] };

  reportCreationDataduplicate = { "datasetname": "", "reporttemplatename": "", "details": "", "type": "", "accesstype": "", "vaultDocumentType": "", "documentsubtype": "", "vaultClasification": "", "vaultTemplate": "", "vaultbinderTemplate": "", "description": "", "objectGroup": "" };

  datasetQuickSight = { "s3Path": "", "dataSetId": "", "dataSetName": "", "dnsId": "", "filterList": [], "visualType": "", "visualId": 0 };
  
   
  reportCreationData = { "datasetname": "", "datasetObjectname": "", "datasetobjectattributes": [], "type": "", "description": "", "objectGroup": "", "filters": [], "sorting": [], "aggregate": [], "columns": [], "concatination": [], "rollingUp": [], "rollupExclusionObjects": [], "transformation": [], "columnFilters": [],"columnFiltersExpression":"", "generateDefaultTemplate": "", "autoRefreshDataset": "", "datasetAccessType": "", "dataset_rolesIds": "", "createdBy": "", "createdDateAndTime": "", "headersType": [],"pivotAggregation":[],"selectedObjectsMap": {},"transformationQuery":"","flatteningOption":"","orderId":"","reference_source":"","reference_target":"","reference_library":"","reference_global_object":"","reference_global_source_library":"","reference_vault_object":"","global_external_object":"","objectGroupName":"","objectGroupId":"","reference_Database_Object_Name":"","reference_Database_Object_Fetch_Partial":""}

  rollupExclusionObjectTemplate = { "exclusionObject": "" };

  transformationObjectData = { "object": "", "attribute": "", "referenceObjects": "", "sql": "" };

  transformationReferenceList: any;
  transformationReferenceListTemp = [];

  rollupExclusionObjects: any;


  finalReportCreation = {
    "datasets": [
      {
        "name": "",
        "datasetType": "",
        "columns": []
      }
    ],
    "reports": []
  }
  selectedValue: boolean = true;

  columnDefsForObjects;

  //columnDefsForTables;

  columnDefsForTablesFields;

  columnDefsForReportingConfiguration;

  columnDefsForWhere;

  columnDefsForAggregate;

  columnDefsForOrderBy;

  rowSelection;

  rowSelectionForTablesFields;

  //gridApi;

  gridApiForTablesFields;

  gridApiForReportingConfiguration;

  gridApiForWhere;

  gridApiForOrderBy;

  gridApiForAggregate;

  tablesFields = [];
  tableFields = [];

  defaultColDefs;

  ngModelObjectDivision = [];

  tableNames = [];
  join = [];
  firstJoin = [];
  secondJoin = [];
  thirdJoin = [];
  fourthJoin = [];
  from = [];
  insertObject:any = []
  whereValueDateFormat = moment(null)

  selectedObject;
  selectedObjectName;

  selectObjectId;
  isdisable
  isvisible = true

  //selectedTable;

  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;
  getRowStyle;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  screenNames;

  columnNames = [];

  rowsData: any = [];

  selectedObjectsMap: { [key: string]: { id: number, details: any } } = {};
  mapObject

  formValidWhere: FormGroup;
  formValidAttributes: FormGroup;
  formulaFields: FormGroup;
  datasetForm: FormGroup;
  transformationFormGroup: FormGroup;
  columnFilterFormGroup: FormGroup;

  validationMessagesWhere;

  fieldsData: any = [];

  fieldsTemp: any = [];

  aggregateArray: any = [];

  where = [];
  recordWhere = [];

  rollingUp = [];

  transformation: any = []

  formValidGroupBy: FormGroup;

  validationMessagesGroupBy;

  groupBy = [];

  formValidOrderBy: UntypedFormGroup;
  formValidHeaderType: FormGroup;

  validationMessagesOrderBy;

  xdummydata: String;

  orderBy = [];
  headersTypeArr = [];

  whereAgGrid = [];

  components: any;

  orderByAgGrid = [];

  aggregateAgGrid = [];

  aggregateBy = [];
  pivotAggregateBy=[];
  subLevelAggregateBy = [];

  showFilters: boolean = true;
  show: boolean = false;
  expand: boolean = false;
  isExpandFilters: boolean = false;
  showAggregate: boolean = false;
  showPivotAggregate: boolean = false;
  showSubLevelAggregate: boolean = false;
  isExpandAggregate: boolean = false;
  showOrderBy: boolean = false;
  showHeaderType: boolean = false;
  isExpandOrderBy: boolean = false;
  allFields: any = [];
  wherefields: any = [];
  sortingfields: any = [];
  aggregatefields: any = [];
  columnDefsForSelectedFields: any;
  gridApiForSelectedTablesFields: any;
  fieldsDataToRemove: any = [];
  selectedFieldsData: any = [];
  selectedFieldsDatatemp: any = [];
  selectedFieldsDataToPush: any = [];
  temp: any = [];
  MappingAttributes = []
  selectedFields: any = [];
  validations_form: UntypedFormGroup;
  defaultColDef
  ngModelObjectTemporary
  butttonname = "Create Stage Object"
  reportCreationUpdateid
  validation_messages
  editMyDataSet: any
  orderByShow: boolean = false;
  aggreageShow: boolean = false;
  fieldChange: boolean = true;
  dateChange: boolean = false;
  showFilter: boolean = false;
  showRollingUp: boolean = false;
  showTransform: boolean = false;
  saveButton: boolean = true;
  updateButton: boolean = false;
  showgridData: boolean = true;
  barChartData: boolean = false;
  pieChartData: boolean = false;
  showChartData: boolean = false;
  betweenField: boolean = false;
  dateField: boolean = false;
  valueField: boolean = true;
  multiselect: boolean = false;
  scheduleRange: boolean = false;

  recordBetweenField: boolean = false;
  recordDateField: boolean = false;
  recordValueField: boolean = true;
  recordMultiselect: boolean = false;
  recordMultiField: boolean = true;
  recordMultiDate: boolean = false;
  recordscheduleRange: boolean = false;

  columnBetweenField: boolean = false;
  columnDateChange: boolean = false;
  columnFieldChange: boolean = true;
  columnMultiselect: boolean = false;
  columnMultiField: boolean = false;
  columnMultiDate: boolean = false;
  columnScheduleRange: boolean = false;
  columnDateField: boolean = false;
  columnValueField: boolean = true;
  showColumnFilter: boolean = false;

  tableNamestemp = [];
  keyStrings = [];
  aggretaefields = [];
  group = [];
  aliasString
  aggregateValue
  xKeydata: any = [];
  ykeydata: any = []

  getdata: any = []

  xdata = [];

  eachBar = [];
  filterData = [];
  recordLevelFilterData = [];
  columnLevelFilterData = [];
  xAxis1;
  yAxis1;
  MappingAttributecheckbox: number[] = [];

  editresponse: any = []

  gridApi;

  options: any;

  public listItems: Array<string> = [];
  

  eachxdata
  paramstemp
  selectedTableFields
  objectGroup: boolean = false;
  datasetGroup: boolean = false;

  multiSelectVaules = [];
  columnDefsExtractTemp
  recordFilterSelectionEvent;

  dataSetObject = {
    datasetname: '',
    accesstype: '',
    fieldslist: '',
    userid: '',
    objectid: '',
    createdDate: '',
    createdBy: '',
    lastModifiedDate: '',
    lastModifiedBy: ''
  }

  filterListBody = []
  gridOptions = {
    animateRows: true,
    enableSorting: true,
    enableCellChangeFlash: true,
    components: { numericCellEditor: getNumericCellEditor() },
    onGridReady: params => {
      params.api.expandAll();
    }
  };

  backgroundColorButton = "";

  //need to remove
  dnsnames:any=[];
  name: string = '';
   defaultLoginDns:any;
  isEnabled = false;
  users
  vaultids:any=[];
  defaultId:number;
  save
  update
  barChart
  value;
  gridColumnAPI;
  overlayNoRowsTemplate;
  columnDefs
  rowData
  private gridColumnApi;
  grid

  backgroundColorScreen = "";
  buttonColor = "";
  isExpand: boolean = true
  tablefields: any = [];
  k;
  vaultGroup: any = []
  datasetGroups: any = []
  ObjectsData: any = []
  rowbindingdata;
  ObjectGrid;
  addedColumnsTemp: any = []
  addedColumnsTemps:any = []
  columnname: any = []
  columns: any = []
  dataset_rolesIds
  sortActive
  filterActive
  immutableStore: any = [];
  sortingOrder
  rollingupDatasettwo: any = []
  concatination: any = []
  finalunconcatination: any = [];
  filterObjects: any = [];
  filterObjectses:any =[];
  multiSelectKeyAttributes: any = [];
  referenceObjects: any = [];

isEditMode: boolean = false;
  datasetIdToRetrieveObjectsdata;
  tempObjectsData;
  objectAttributes;


      RunlastPage1
      RuncurrentPage1
      RunnextPage1
      RunnextPagePlusOne1
      RuntotalPages1

  refresh_params
  gridAPIValidation
  RunpageSize1
  conditionalOperatorDataWhere: ConditionalOPeratorTypeWhere[] = [
    { name: "Matches", value: "=" },
    { name: "Does Not Matches", value: "<>" },
    { name: "Matches At Least One", value: "IN" },
    { name: "Starts With", value: "Starts with" },
    { name: "Ends With", value: "Ends with" },
    { name: "Contains", value: "contains" },
    { name: "Greater Than Or Equals", value: ">=" },
    { name: "Is Greater Than", value: ">" },
    { name: "Less Than Or Equals", value: "<=" },
    { name: "Is Less Than", value: "<" },
    { name: "Between", value: "BETWEEN" },
    { name: "Current Schedule Range", value: "schedule range" }
  ];

  rollingUpconstants: Constants[] = [
    { name: "And", value: "And" },
    { name: "OR", value: "OR" },
    { name: "/", value: "/" },
    { name: "_", value: "_" },
    { name: "-", value: "-" },
    { name: ".", value: "." },
    { name: ",", value: "," }
  ];

  types: Types[] = [
    {
      type: "Object Group"
    },
    {
      type: "Dataset Group"
    }
  ]


  logicalOperatorDataWhere: LogicalOperatorTypeWhere[] = [
    { name: "And", value: "And" },
    { name: "Or", value: "Or" }
  ];

  arrangeDataOrderBy: ArrangeTypeOrderBy[] = [
    { name: "Ascending", value: "ASC" },
    { name: "Descending", value: "DESC" }
  ];

  arrangeDataBy: AggregateDataBy[] = [
    { name: "Avg", value: "avg" },
    { name: "Count", value: "count" },
    //   { name: "Group Concate", value: "group_concat" },
    { name: "Max", value: "max" },
    { name: "Min", value: "min" },
    { name: "Sum", value: "sum" },
  ];
  arrangeDataByForHeaderType: AggregateDataBy[] = [
    { name: "StringType", value: "StringType" },
    { name: "IntegerType", value: "IntegerType" },
    { name: "LongType", value: "LongType" },
    { name: "FloatType", value: "FloatType" },
    { name: "DoubleType", value: "DoubleType" },
    { name: "BooleanType", value: "BooleanType" },
    { name: "ShortType", value: "ShortType" },
    { name: "DateType", value: "DateType" },
    { name: "TimestampType", value: "TimestampType" },
    { name: "BinaryType", value: "BinaryType" },



  ];


  arrangeDatasetBy: ArrangeMyDataBy[] = [
    { name: "Public", value: "public" },
    { name: "Private", value: "private" }
  ];

  arrangeTypeBy: ArrangeMyTypeBy[] = [
    { name: "Type 1", value: "type1" },
    { name: "Type 2", value: "type2" }
  ];
  ExportObjectGroups: any;
  orderedPartitionSelection: string[] = [];
  orderedOrderBySelection: string[] = [];
  groupByColumnSelections: string[] = [];

  orderedChildColumns:string[] = [];
  orderedHeadersToNull:string[] = [];
  orderedOrderByColumn:string[] = [];
  orderedParentcolumns:string[] = [];
  selectedSourceName: any;
  selectedSource: any;
  selectedTarget: any;
  SourceId: any;
  targetId: any;
  showGrid: boolean;
   excelData: any;

   selectedReferenceSourceObjectsListNames
  selectedReferenceTargetObjectsListNames;
  selectedReferenceLibraryObjectsListNames;
  selectedReferenceGlobalObjectsListNames;
  selectedReferenceGlobalSourceObjectsListNames;
  selectedGlobalExternalObjectsListNames
  selectedReferenceValueMapping=[];
  selectedReferenceSourceObjectsList=[]
  selectedReferenceTargetObjectsList=[];
  selectedReferenceLibraryObjectsList=[];
  selectedReferenceGlobalObjectsList=[];
  selectedReferenceGlobalSourceObjectsList=[];
  selectedGlobalExternalObjectsList=[];
  selectedRefDBObjectNameFetchPartialsList=[];
  selectedRefDBObjectNameFetchPartialsListNames;
  selectedRefDBObjectNameList=[];
  selectedRefDBObjectNameListNames;
  referenceSourceObjectsList;
  referenceExternalObjectsList
  referenceTargetObjectsList;
  referenceLibraryObjectsList;
  referenceGlobalObjectsList;
  referenceSourceGlobalObjectsList
  mappingConfigurationData:any=[]
  codeListData;
referenceLibraryObjectsLookupValue;
referenceGlobalObjectsLookupValue;
  pushAllRows: boolean = false;
  objectGroupData:any=[]
  buttonIdList = []
  isViewAction: boolean = false;
  constructor(private retrieveScreenAccess: RetrieveScreenAccess, private userRoutingModule: UserRoutingModule, private msg: ErrorMessages, private validation: validationmethod, private service: ReportingServiceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private dialog: MatDialog, private fb: FormBuilder, private localStorageSettings: LocalStorageSettingsService, private formFieldsTrimer: FormFieldsTrimer, private linkservice: ReportlinksserviceService, private constants: constants, private vaultObjectService: VaultObjectgroupService, private router: Router,private location: Location, private etlService: EtlService,private commonService:CommonService,
    private cdr: ChangeDetectorRef, private etlservice:EtlService,private valueMappingservice:FieldMappingService , private mappingAttributeServices:AttributeMappingConfigService,private restApi: RestApi,private etlEtlService: EtlService,
    private migratorService: JMigratorService) {
    //messages for validations
    this.UserRolesWithRoleId = [];
    this.validation_messages = this.msg.reportConfiguration;
    this.validationMessagesGroupBy = this.msg.groupByMessages;

    this.validationMessagesGroupBy = this.msg.orderByMessages;
    
    this.components = {
      buttonRenderer: ActionwithcheckboxComponent,
      downloadbuttonRenderer: FiledownloadComponent
    }

  }

  formValidation() {
    this.validations_form = new FormGroup({
      selectdataSet: new FormControl('', [Validators.required, this.validation.specialCharacterValidator, this.validation.noWhitespaceValidator, Validators.maxLength(100)]),
    
      description: new FormControl('', [Validators.required, this.validation.specialCharacterValidator, this.validation.noWhitespaceValidator]),
      orderId: new FormControl('', []),
      flattenOptions:new FormControl('', []),
       expressionQuery: new FormControl('', []),
       selectedReferenceSourceObjectsListNamesForm: new FormControl('', []),
       selectedReferenceTargetObjectsListNamesForm: new FormControl('', []),
       selectedReferenceValueMappingForm: new FormControl('', []),
       selectedReferenceLibraryForm: new FormControl('', []),
       selectedReferenceGlobalObjectsListNamesForm: new FormControl('', []),
       selectedReferenceGlobalSourceObjectsListNamesForm: new FormControl('', []),
       selectedGlobalExternalObjectsListNamesForm: new FormControl('', []),
       selectedRefDBObjectNameListNamesForm: new FormControl('', []),
       selectedRefDBObjectNameFetchPartialsListNamesForm: new FormControl('', []),
       objectGroupName: new FormControl('', [Validators.required]),
      // access: new FormControl(' ', [Validators.required])
    });

    // Dynamically validate expressionQuery only when flattenOptions is "None"

    this.validations_form.get('flattenOptions').valueChanges.subscribe(value => {
    const expressionControl = this.validations_form.get('expressionQuery');
    if (!value) {
      expressionControl.setValidators([Validators.required, this.validation.noWhitespaceValidator]);
    } else {
      expressionControl.clearValidators();
    }
    expressionControl.updateValueAndValidity();
  });
  }

  formulaFieldsValidation() {
    this.formulaFields = new UntypedFormGroup({
      label: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100), Validators.pattern('^[a-zA-Z]+$')]),
      returntype: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      object: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      functions: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      oprations: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator])
    })
  }

  formValidationsWhere() {
    // form validations
    this.formValidWhere = new UntypedFormGroup({
      fieldsWhere: new UntypedFormControl('', []),
      conditionalOperatorWhere: new UntypedFormControl('', []),
      enterValueWhere: new UntypedFormControl('', []),
      logicalOperatorWhere: new UntypedFormControl('', []),
      fieldsOrderBy: new UntypedFormControl('', []),
      arrangeOrderBy: new UntypedFormControl('', []),
     
      objectWhere: new UntypedFormControl('', []),
      objectOrderBy: new UntypedFormControl('', []),
      
      multiselect: new UntypedFormControl('', []),
      aggregateOn: new UntypedFormControl('', []),
      aggregateFunction: new UntypedFormControl('', []),
      partionOn: new UntypedFormControl('', []),
      orderBy: new UntypedFormControl('', []),
      columnAlias: new UntypedFormControl('', []),
      conditionalValue: new UntypedFormControl('', []),
      groupBysecondary: new UntypedFormControl('', []),
      goupByColumnAlias: new UntypedFormControl('', []),
      
      pivotColumnAlias: new UntypedFormControl('', []),
      caseColumn: new UntypedFormControl('', []),
      pivotColumn: new UntypedFormControl('', []),
      childColumns:new UntypedFormControl('', []),
      headersToNull:new UntypedFormControl('', []),
      orderByColumn:new UntypedFormControl('', []),
      parentcolumns:new UntypedFormControl('', []),
      headerValueColumn: new UntypedFormControl('', [])

    });
  }

  formValidationsRollingUp() {
    this.formValidAttributes = new FormGroup({
      datasetNameone: new FormControl('', []),
      attributes: new FormControl('', []),
      constant: new FormControl('', []),
      datasetNametwo: new FormControl('', []),
      attributestwo: new FormControl('', []),
      selectedChildDataSet: new UntypedFormControl('', []),
      recordFilter: new UntypedFormControl('', []),
      recordConditionalOperatorWhere: new UntypedFormControl('', []),
      recordMultiselect: new UntypedFormControl('', []),
      fieldsWhere: new UntypedFormControl('', []),
      conditionalOperatorWhere: new UntypedFormControl('', []),
      enterValueWhere: new UntypedFormControl('', []),
      logicalOperatorWhere: new UntypedFormControl('', []),
      fieldsOrderBy: new UntypedFormControl('', []),
      arrangeOrderBy: new UntypedFormControl('', []),
      fieldsAggredateBy: new UntypedFormControl('', []),
      arrangeaggregateBy: new UntypedFormControl('', []),
      objectWhere: new UntypedFormControl('', []),
      objectOrderBy: new UntypedFormControl('', []),
      objectAggregateBy: new UntypedFormControl('', []),
      multiselect: new UntypedFormControl('', []),
      rollupExclusion: new UntypedFormControl('', []),
      aggregateOn: new UntypedFormControl('', []),
      aggregateFunction: new UntypedFormControl('', []),
      partionOn: new UntypedFormControl('', []),
      orderBy: new UntypedFormControl('', []),
      columnAlias: new UntypedFormControl('', []),


    });

  }


  datasetFormValidation() {
    this.datasetForm = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      type: new UntypedFormControl(''),
      details: new UntypedFormControl(''),
      accesstype: new UntypedFormControl('')
    })
  }

  formValidationForTranformation() {
    // form validations
    this.transformationFormGroup = new UntypedFormGroup({
      transformationObject: new UntypedFormControl('', []),
      transformationAttribute: new UntypedFormControl('', []),
      transformationReference: new UntypedFormControl('', []),
      transformationSql: new UntypedFormControl('', []),
    });
  }

  formValidationsGroupBy() {
    // form validations
    this.formValidGroupBy = new UntypedFormGroup({
      fieldsGroupBy: new UntypedFormControl('', [Validators.required])
    });
  }

  formValidationsOrderBy() {
    // form validations
    this.formValidOrderBy = new UntypedFormGroup({

    });
  }
  formValidationsHeaderType() {
    // form validations
    this.formValidHeaderType = new UntypedFormGroup({
      headerKey: new UntypedFormControl(''),
      headerKeyAlias: new UntypedFormControl(''),
      headerKeyType: new UntypedFormControl('')

    });
  }

  validateColumnFilterFormGroup() {
    this.columnFilterFormGroup = new UntypedFormGroup({
      columnObject: new UntypedFormControl('', []),
      columnAttribute: new UntypedFormControl('', []),
      columnObjectList: new UntypedFormControl('', []),
      columnObjectAttributes: new UntypedFormControl('', []),
      columnLogicalOperatorWhere: new UntypedFormControl('', []),
      columnTextfield: new UntypedFormControl('', []),
      columnDatefield: new UntypedFormControl('', []),
      columnMultiSelect: new UntypedFormControl('', []),
      objectOrderBy: new UntypedFormControl('', []),
      // objectAggregateBy: new UntypedFormControl('', []),
      multiselect: new UntypedFormControl('', []),
      aggregateOn: new UntypedFormControl('', []),
      aggregateFunction: new UntypedFormControl('', []),
      partionOn: new UntypedFormControl('', []),
      orderBy: new UntypedFormControl('', []),
      columnAlias: new UntypedFormControl('', []),


    });
  }

  toggletextbox() {
    this.selectedValue = !this.selectedValue;
  }

   ngOnInit() {
    this.isEditMode = true;
    this.linkservice.fetchUserRole(this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
      console.log(res);
      this.responserequest = res;
    });

    /* modified by Chandra R
       *  calling the Userroles method to assign the rolenames for IDs in gride
       *  30-06-2024
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.retrieveScreenAccess.find(screenPath);
    this.linkservice.screenoperationspermission(screenPath, this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      // const buttonIdList: number[] = [];
      let responsedata: any;
      responsedata = res;
      for (let i = 0; i < responsedata.length; i++) {

        this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
      }
      this.buttonIdList.push('screen');
      console.log('Button ID List:', this.buttonIdList);
      const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
      buttons.forEach(button => {
        const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
        if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
          if (!this.buttonIdList.includes(buttonId)) {
            button.setAttribute('disabled', 'true'); // Disable the button
          } else {
            button.removeAttribute('disabled'); // Enable the button
          }
        }
      });
    });


 this.spinner.start();
 forkJoin({
    group: this.getObjectGroup$(),
    roles: this.Useroles$(),
    dns: this.userDns$(),
    srcTarget: this.retrieveSourceAndTarget$(),
    mappingDetails: this.retrieveMappingDetails$(),
    mappingTypes:this.retrieveMappingTypes$()
  })
  .pipe(finalize(() => this.spinner.stop()))
  .subscribe({
    next: (res) => console.log('All services done:', res),
    error: (err) => console.error('Error:', err)
  });
   const selectedValueofDns= this.localStorageSettings.getSettings("SelectedDnsName");
   console.log(selectedValueofDns);
   const vaultIdsString = this.localStorageSettings.getSettings("vaultIds")
   const vaultIds = JSON.parse(vaultIdsString); // Convert to array
   if (Array.isArray(vaultIds)) {
       const selectedVault = vaultIds.find(vault => vault.name === selectedValueofDns);

       if (selectedVault) {
        this.recordDnsName = selectedVault.url;
           console.log(" Selected URL:", selectedVault.url);
       } else {
           console.error(" No matching DNS found in vaultIds.");
       }
   } else {
       console.error(" Invalid vaultIds format: Not an array.");
   }


  
    

    this.formValidWhere = this.fb.group({
      fieldsWhere: '',
      conditionalOperatorWhere: '',
      enterValueWhere: '',
      fieldsOrderBy: '',
      arrangeOrderBy: '',
    
      multiselect: '',
      aggregateOn: '',
      aggregateFunction: '',
      partionOn: '',
      orderBy: '',
      columnAlias: '',
      conditionalValue: '',
   


    });

    this.transformationFormGroup = this.fb.group({
      transformationObject: '',
      transformationAttribute: '',
      transformationReference: '',
      transformationSql: '',
    });

    this.formValidAttributes = this.fb.group({
      datasetNameone: "",
      attributes: "",
      constant: "",
      datasetNametwo: "",
      attributestwo: "",
      recordFilter: '',
      selectedChildDataSet: '',
      recordConditionalOperatorWhere: '',
      recordMultiselect: '',
      fieldsWhere: '',
      conditionalOperatorWhere: '',
      enterValueWhere: '',
      fieldsOrderBy: '',
      arrangeOrderBy: '',
     
      multiselect: '',
      logicalOperatorWhere: '',
      objectWhere: '',
      objectOrderBy: '',
      
      rollupExclusion: '',
      aggregateOn: '',
      aggregateFunction: '',
      partionOn: '',
      orderBy: '',
      columnAlias: '',
      conditionalValue: ''

    });

    this.datasetForm = this.fb.group({
      name: '',
      type: '',
      details: '',
      accesstype: ''
    })

    this.validations_form = this.fb.group({
      selectdataSet: '',
      
      type: '',
      objectGroup: '',
      description: ''
      
    });

    this.columnFilterFormGroup = this.fb.group({
      columnObject: '',
      columnAttribute: '',
      columnObjectList: '',
      columnObjectAttributes: '',
      columnLogicalOperatorWhere: '',
      columnTextfield: '',
      columnDatefield: '',
      columnMultiSelect: '',
     

    });
    this.formValidHeaderType = this.fb.group({
      headerKeyAlias: "",
      headerKeyType: "",

    });
    this.formValidationsWhere();
    // this.butttonname = "Save";
    this.formValidation();

    this.formulaFieldsValidation();
    this.validateColumnFilterFormGroup();
    this.datasetFormValidation();
    // this.lookupVaultGroup();

    this.butttonname = "Create Stage Object";

    this.columnDefsForObjects = [
      {
        headerName: " Objects",
        headerTooltip: "Objects",
        tooltipValueGetter: params => "Vault Objects : " + params.value,
        field: "objectlabelWithEnvName",
        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName'
      }
    ];

    this.columnDefsForTablesFields = [
      {
        headerName: "Attributes ",
        headerTooltip: "Attributes",
        tooltipValueGetter: params => "Attributes : " + params.value,
        field: "label",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];

    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Attributes",
        tooltipValueGetter: params => "Selected Attributes : " + params.value,
        field: "attributeNameWithFields",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" },
        editable: true,
        rowDrag: true
      }
    ];

    this.sortingOrder = ["asc", "desc", null]

    
    this.columnDefs = [
     {
      headerName: 'Action', filter: false, 
      cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      value : this.MappingAttributecheckbox,
      cellRendererParams: {
         values: this.buttonIdList,
        edit: this.EditIcon.bind(this),
        delete: this.deleteIcon.bind(this),
         view: this.viewIcon.bind(this), 
        onCheckboxChange:this.checkIcon.bind(this)
      }, width: 200
    },
    
      { headerName: 'Order Id', headerTooltip: 'Order Id', tooltipValueGetter: (params) => 'Order Id : ' + params.value, field: 'orderId', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Object Label', headerTooltip: 'Object Label', tooltipValueGetter: (params) => 'Object Label : ' + params.value, field: 'datasetname', filter: 'agTextColumnFilter', width: 150 },
    
      { headerName: 'Object Name', headerTooltip: 'Object Name', tooltipValueGetter: (params) => 'Object Name : ' + params.value, field: 'description', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Object Type', headerTooltip: 'Object Type', tooltipValueGetter: (params) => 'Object Type : ' + params.value, field: 'type', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Columns', headerTooltip: 'Columns', tooltipValueGetter: (params) => 'Columns : ' + params.value, field: 'columns', filter: 'agTextColumnFilter', width: 300 },
     { headerName: 'Transformation Query', headerTooltip: 'Transformation Query', tooltipValueGetter: (params) => 'Transformation Query : ' + params.value, field: 'transformationQuery', filter: 'agTextColumnFilter', width: 300 },
      { headerName: 'Object Group', headerTooltip: 'Object Group', tooltipValueGetter: (params) => 'Object Group : ' + params.value, field: 'objectGroupName', filter: 'agTextColumnFilter', width: 300 },  
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Created By', headerTooltip: 'Created By', tooltipValueGetter: (params) => 'Created By : ' + params.value, field: 'createdBy', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Created DateAndTime', headerTooltip: 'Created DateAndTime', tooltipValueGetter: (params) => 'Created DateAndTime : ' + params.value, field: 'createdDateAndTime', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Modified By', headerTooltip: 'Modified By', tooltipValueGetter: (params) => 'Modified By : ' + params.value, field: 'lastmodifiedBy', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Modified DateAndTime', headerTooltip: 'Modified DateAndTime', tooltipValueGetter: (params) => 'Modified DateAndTime : ' + params.value, field: 'lastModifiedDateAndTime', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Approved Status', headerTooltip: 'Approved Status', tooltipValueGetter: (params) => 'Approved Status : ' + params.value, field: 'approvedStatus', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Approved By', headerTooltip: 'Approved By', tooltipValueGetter: (params) => 'Approved By : ' + params.value, field: 'approvedBy', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Approved Date', headerTooltip: 'Approved Date', tooltipValueGetter: (params) => 'Approved Date : ' + params.value, field: 'approvedDate', filter: 'agTextColumnFilter', width: 150 }
      
    ]
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };
    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' }; // Inline style for deleted rows
      }
      
    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelectionForTablesFields = 'multiple';
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };


    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    // this.selectedObjectsMap = this.mapObject


    this.columnDefsExtractTemp = [
      { headerName: 'Execution Id', headerTooltip: 'Execution Id', tooltipValueGetter: (params) => 'Execution Id : ' + params.value, field: 'executionid', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'MappingTestBed Id', headerTooltip: 'MappingTestBed Id', tooltipValueGetter: (params) => 'mappingTestBedId : ' + params.value, field: 'testbedpath', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Execution StartDate', headerTooltip: 'ExecutionStartDate', tooltipValueGetter: (params) => 'executionStartDate : ' + params.value, field: 'executionStartDate', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Execution EndDate', headerTooltip: 'Execution EndDate', tooltipValueGetter: (params) => 'Execution EndDate : ' + params.value, field: 'executionEndDate', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Verificationtype', headerTooltip: 'Verificationtype', tooltipValueGetter: (params) => 'verificationtype : ' + params.value, field: 'verificationtype', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Download Log', headerTooltip: 'Download Log', filter: false, cellRenderer: 'downloadbuttonRenderer', cellRendererParams: { docdownload: this.downloadmappingfileExtract.bind(this),}, width: 180},

    ]




  }

  downloadmappingfileExtract(e) {
  debugger;
  console.log("inside");
  console.log(e);
  console.log(e.rowData);

  if (!e.rowData.testbedexecutionlogpath) {
    this.snackbar.open("Folder does not exist", "OK", {
      panelClass: 'snack'
    });
    return;
  }

  this.snackbar.open(
    "Download is underway. Please do not click again until it completes.",
    "OK",
    { duration: 8000 }
  );
  

  let safePath = e.rowData.testbedexecutionlogpath.replace(/\//g, "-");

  this.etlEtlService
    .download_zip(
      this.restApi.DOWNLOADSOURCEFILE +
        "/" +
        this.localStorageSettings.getSettings("AuthUsername") +
        "/" +
        this.localStorageSettings.getSettings("vaultDnsname") +
        "/" +
        "TestBed" +
        "/" +
        e.rowData.mappingtestbedid +
        "/" +
        safePath
    )
    .subscribe(
      (x) => {
        var newBlob = new Blob([x], { type: "application/zip" });
        console.log("Blob size (bytes):", newBlob.size);

        if (newBlob.size === 0) {
          this.spinner.stop();
          this.snackbar.open(
            "Download failed. Please try again after some time.",
            "OK",
            { panelClass: "snack" }
          );
          this.spinner.stop();
          return;
        }

        var sizeInMB = newBlob.size / (1024 * 1024);
        

        // ✅ Core download logic from your previous code
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement("a");
        link.href = data;
        link.download = "TestBedTransformer" + ".zip"; // dynamic filename
        link.dispatchEvent(
          new MouseEvent("click", { bubbles: true, cancelable: true, view: window })
        );

        setTimeout(() => {
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);

        this.snackbar.open("Download Completed", "OK", { duration: 5000 });
        this.spinner.stop();
      },
      (error) => {
        console.error(error);
        this.snackbar.open("Download failed due to an error.", "OK", {
          duration: 5000
        });
        this.spinner.stop();
      }
    );
}




  retrieveInstructionsBasedOnActivity(params){
        this.refresh_params = params
        this.gridAPIValidation = params.api;
        this.gridAPIValidation.setGridOption('rowData', [])
        this.mappingAttributeServices
  .retrivemappingtestbedexecution(this.localStorageSettings.getSettings("WorkspaceId"))
  .subscribe((response: any) => {   // use 'any' or define proper array type
    
    // response is now treated as an array
    const filteredResponse = (response as any[]).filter(row => row.verificationtype === "Stage");
    
    this.gridAPIValidation.setGridOption('rowData', filteredResponse);
  });


}

   refreshh(){
    this.spinner.start()
    this.retrieveInstructionsBasedOnActivity(this.refresh_params)
    this.spinner.stop()
   }

   onRunBtNext1() {
    console.log("next")
    this.gridAPIValidation.paginationGoToNextPage();
  }

  // below function for going to previous page
  onRunBtPrevious1() {
    console.log("previous")
    this.gridAPIValidation.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onRunBtFirst1() {
    this.gridAPIValidation.paginationGoToFirstPage();
  }

  // below function for going to last page
  onRunBtLast1() {
    this.gridAPIValidation.paginationGoToLastPage();
  }

    onRunSearchChange(searchValue: number) {
    this.gridAPIValidation.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onRunPageSizeChanged(newPageSize) {
    var value = this.RunpageSize1;
    this.gridAPIValidation.setGridOption('paginationPageSize', Number(value));
  }

   onloadPaginationChanged1(){
    if (this.gridAPIValidation) {
      this.RunlastPage1 = this.gridAPIValidation.paginationIsLastPageFound();
      this.RuncurrentPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1
      this.RunnextPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1
      this.RunnextPagePlusOne1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1 + 1
      this.RuntotalPages1 = this.gridAPIValidation.paginationGetTotalPages()
    }
  }

  
retrieveSourceAndTarget$() {
  console.log("Calling retrieveSourceAndTarget");
  // const dnsId = "27";
  const dnsId =  this.localStorageSettings.getSettings("WorkspaceId")
  // this.spinner.start();
  return this.etlservice.retrieveSourceAndTraget(dnsId, "Source").pipe(
    tap(result=>{
      if(result){
        this.selectedSourceName = result.sourceEnvName;
        this.name = this.selectedSourceName
        this.selectedTarget = result.targetEnvName
        this.SourceId = result.sourceId
        this.targetId = result.targetId
        if (this.SourceId) {
          this.showGrid = true;  // Only then render the grid
        }
      }
    }),
    concatMap(() => this.SourceId ? this.refreshGridData$() : of(null)),
     concatMap(() => this.SourceId ? this.getSourceReferenceObjects$() : of(null)),

    // then run target (only if targetId is set)
    concatMap(() => this.targetId ? this.getTargetReferenceObjects$() : of(null)),

    // optional: emit a simple marker so callers know it finished
    map(() => ({ ok: true })),

    // optional: don't blow up the whole chain on error
    catchError(err => {
      console.error('retrieveSourceAndTarget$ error', err);
      return of(null);
    })
)
}

async userDns$(){
    var userName = localStorage.getItem("AuthUsername");
    const dnsNameOflogined = localStorage.getItem("dnsName")
    console.log(dnsNameOflogined);
    this.dnsid = Number(dnsNameOflogined);

    console.log(userName);

    let userData: any =  await this.commonService.retrieveSingleRecordService("users", "username", userName);

     let userid = userData[0].userid;
    console.log("userid" + userid)
    this.dnsDropDown(userid);
    console.log(this.dnsid)
  }






  //excel export function
  onBtExport() {
    this.rowbindingdata.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.rowbindingdata.api) {
      this.lastpage = this.rowbindingdata.api.paginationIsLastPageFound();
      this.currentpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1
      this.nextpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.rowbindingdata.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.rowbindingdata.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pagesize
    this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.rowbindingdata.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.rowbindingdata.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.rowbindingdata.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.rowbindingdata.api.paginationGoToLastPage();
  }
  //pagination code ends

  refreshRun() {
    console.log("Inside the refreshmethod");
    this.spinner.start();
    this.onGridReady(this.rowbindingdata);
    this.spinner.stop();
  }

  onGridReady(params) {
    console.log("Grid Ready Triggered!", params);
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    console.log(this.dnsid)
    this.rowbindingdata = params;
    // this. retrieveSourceAndTarget()
    this.refreshGridData();
}
  refreshGridData() {
    console.log("Refreshing grid data...");
    // this.spinner.start();
   
    if(this.SourceId != undefined){
    this.linkservice.retrieveStageObject(this.SourceId).subscribe(response => {
      console.log("API Response after Insert:", response);
      
      if (this.gridApi) {
        if (response.error) {
          this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
          this.gridApi.setGridOption('rowData', []);
        } else {
          this.getdata = this.flattenResponse(response); // Assuming your data needs flattening
          this.gridApi.setGridOption('rowData', this.getdata);
        }
      } else {
        console.error("Grid API is not initialized.");
      }
  
      // this.spinner.stop();
      // this.selectedObjectsMap = {};
    });
  }
  }
  
    refreshGridData$() {
    console.log("Refreshing grid data...");
    // this.spinner.start();
    if (!this.SourceId) return of(null);
    return this.linkservice.retrieveStageObject(this.SourceId).pipe(
      tap(response =>{
        
         if (response.error) {
          this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
          if (this.gridApi) {
          this.gridApi.setGridOption('rowData', []);
          }
        } else {
          if (this.gridApi) {
          this.getdata = this.flattenResponse(response); // Assuming your data needs flattening
          this.gridApi.setGridOption('rowData', this.getdata);
          }
        }
      })
    )
  }
  
  // Method to flatten the response data
  flattenResponse(response) {
    
    // Create a new array for processed data
    const flattenedData = [];
   console.log(response)
    response.forEach((item,i) => {
      // Flatten the nested `objectattributes` field
      const objectAttributes = item.objectattributes ? JSON.parse(item.objectattributes) : {};
      let envName = "";
      if (objectAttributes.datasets && objectAttributes.datasets.length > 0) {
          envName = objectAttributes.datasets[0].envname || "";
      }
      // Extract relevant fields for the grid
      const flattenedItem = {
        id: item.id,
        orderId:item.orderId,
        status: item.status,
        createdBy: item.createdBy,
        createdDateAndTime: item.createdDate,
        lastmodifiedBy: item.lastModifiedBy,
        lastModifiedDateAndTime: item.lastModifiedDate,
        // Add other fields from `objectattributes` or any nested data
        columns:  item.objectattributes ? JSON.stringify(JSON.parse(item.objectattributes), null, 2):"",
        transformationQuery:objectAttributes.datasets[0].transformationQuery,
        description: item.objectname,
        datasetname: item.objectlabel,
        objectGroupName:item.objectGroupName,
        type:item.source,
        dnsname: envName,
        approvedStatus: item.approvedStatus,
        approvedDate:item.approvedDate,
        approvedBy:item.approvedBy,
        objectgroupid:item.objectgroupid
          
      };
  
      flattenedData.push(flattenedItem);
    });
  
    return flattenedData;
  }
  

  lookupVaultGroup() {
    
    this.vaultObjectService.retrieveAllObjectGroupForDataset(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {
      this.vaultGroup = res;
      console.log(res);
      this.spinner.stop();
    })

    this.vaultObjectService.retrieveDatasetGroup().subscribe(res => {

      this.datasetGroups = res;
      //this.vaultGroup=res;
      console.log(res);
      this.spinner.stop();
    })
  }

  valutGroupcheck(dnsid) {
    
    console.log(dnsid)
    this.onGridReadyForObjects(this.ObjectGrid, dnsid)
    // console.log(e)
  }

  onGridReadyForObjects(params, vaultgroup) {

    this.ObjectGrid = params;
    if(vaultgroup){
    // this.spinner.start();
    console.log(vaultgroup);
    this.ObjectGrid.api.setGridOption('rowData', []);
    this.paramstemp.api.setGridOption('rowData', []);
    this.refreshGridData();
  }
  this.ObjectGrid.api.setGridOption('rowData', []);
  this.paramstemp.api.setGridOption('rowData', []);
}

  onGridReadyForTablesFields(params, tableName, objectName) {
    this.tableFields = [];
    this.fieldsData = [];
    this.selectedFieldsData = [];
    this.paramstemp = params;
    console.log(tableName)
    console.log(params)
    let stageObjectCheck = objectName.toLowerCase().replace(/[^a-z0-9]/g,"")
    if (tableName === undefined) {
      this.paramstemp.api.setGridOption('rowData', []);
    } else {
       let fieldsArray = JSON.parse(tableName.attributeNameAndFields);
      
      if (fieldsArray.datasets) {
        console.log(JSON.parse(tableName.attributeNameAndFields))
        this.tablefields = fieldsArray.datasets[0].columns
        console.log(this.tablefields)
      } else {
        this.tablefields = JSON.parse(tableName.attributeNameAndFields);
      }
      console.log(this.tablefields)
      let constant = {
        "attributeNameWithFields": "Constant String",
        "isControlledVocabulary": null,
        "label": "Constant String",
        "list_column": true,
        "max_type_value": null,
        "min_type_value": null,
        "name": "Constant String",
        "required": false,
        "tempfieldindex": 1000001,
        "type": "__constant",
        "type_value": ""
      }
      
      if (true) {
        this.tablefields.forEach(fields => {
          console.log(this.tablefields.indexOf(fields))
          fields.tempfieldindex = this.tablefields.indexOf(fields)
          // console.log(fields);
          fields.label = fields.label + " (" + fields.name + ")";
          console.log(objectName + " " + fields.label);
          fields.attributeNameWithFields = objectName + " " + fields.label;
        })
        console.log(this.tablefields)
        let tempTableFields = this.tablefields;
        this.tablefields = [];
        this.tablefields.push(constant);
        console.log(tempTableFields)
        console.log(this.tablefields)
        tempTableFields.forEach(tableField => {
          this.tablefields.push(tableField);
        })
        console.log(this.tablefields)
        this.tablefields.forEach(object => {
          if (object.type != "__constant") {
            this.filterData.push(object)
          }
        });
        console.log(this.filterData);
      }
      console.log(this.tablefields)
      let objectAttributes;
      this.gridApiForTablesFields = params;
      this.paramstemp.api.setGridOption('rowData', this.tablefields);
      
    }
   

  }

  onGridReadyForWhere(params) {

    this.gridApiForWhere = params.api;

    if (this.whereAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForWhere.setGridOption('rowData', this.whereAgGrid);

    }

  }

  onGridReadyForAggregate(params) {

    this.gridApiForAggregate = params.api;

    if (this.aggregateAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForAggregate.setGridOption('rowData', this.aggregateAgGrid);

    }

  }

  onGridReadyForOrderBy(params) {

    this.gridApiForOrderBy = params.api;

    if (this.orderByAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForOrderBy.setGridOption('rowData', this.orderByAgGrid);

    }

  }

  onGridReadyForSelectedTableFields(params, tableName) {
    
    console.log(tableName)
    console.log(params)
    this.selectedTableFields = params
    this.gridColumnApi = params.columnApi
    //this.gridApiForTablesFields = params.api;
    console.log('Before setRowData:', tableName);
    if(tableName != undefined){
      
    this.selectedTableFields.api.setGridOption('rowData', tableName);
    }else{
      
    this.selectedTableFields.api.setGridOption('rowData', []);
    }
    console.log('After setRowData:', tableName);
    

  }



  cellClickedObjects(e) {
    
    console.log(e)

    console.log(e.value);
    if (true) {
      this.service.retrieveTablesFieldsForDataset(e.data.id).subscribe(res => {

        this.spinner.start();

        console.log(res);

        // checking if response is true or not
        if (res.error === true) {

          this.spinner.stop();

          this.snackbar.open(res.message, "OK", { duration: 5000 });

          this.allFields = [];

          this.selectedFieldsData = [];

          this.gridApiForTablesFields.setGridOption('rowData', []);

        } else {

          this.spinner.stop();
          console.log(e)
          this.allFields = res[0];
          console.log(this.allFields)
          this.selectedObject =e.data.objectlabel;
          console.log(this.selectedObject)
          this.selectedObjectName = e.data.objectname;
          console.log("+++++++++++++++++++++  " + this.selectedObjectName)
          console.log(this.allFields)

          this.selectObjectId = e.data.id;

          console.log(this.selectedObject)
            // Store the selected object and its details in a map
            this.selectedObjectsMap[this.selectedObject] = {
              id: this.selectObjectId,
              details: e.data // Store additional object details if needed
          };
          console.log("Updated Selected Objects Map:", this.selectedObjectsMap);
          this.onGridReadyForTablesFields(this.paramstemp, this.allFields, e.value)

          this.columnDefsForReportingConfiguration = [];

        }

      });
    } else {
      console.log(e)
      //console.log(type)
      console.log(this.datasetIdToRetrieveObjectsdata)
      if (this.datasetIdToRetrieveObjectsdata != undefined) {
        this.service.retrieveDatasetObjects(this.datasetIdToRetrieveObjectsdata).subscribe(res => {
          console.log(res)
          // checking if response is true or not
          if (res.error === true) {
            this.spinner.stop();
            this.snackbar.open(res.message, "OK", { duration: 5000 });
            this.ObjectGrid.api.setGridOption('rowData', []);
          } else {
            this.ObjectsData = res;
            console.log(res)
          }
        })
      }

      this.selectedObject = e.data.objectlabel;;
      this.selectedObjectName = e.data.value.object;
      console.log("+++++++++++++++++++++  " + this.selectedObjectName)
      this.tempObjectsData = this.ObjectsData
      console.log(this.tempObjectsData + "=========================000000")
      console.log(this.ObjectsData)
      console.log(this.selectedObject)
      console.log(this.ObjectsData[this.selectedObject]);
      this.objectAttributes = this.ObjectsData[this.selectedObject];
      console.log(typeof (this.objectAttributes[0]))
      console.log((this.objectAttributes))
      if (typeof (this.objectAttributes[0]) == "string") {
        for (let i = 0; i < this.objectAttributes.length; i++) {
          this.objectAttributes[i] = JSON.parse(this.objectAttributes[i]);
        }
      }

      this.ObjectsData = this.objectAttributes
      this.allFields = this.objectAttributes;
      this.onGridReadyForTablesFields(
        this.paramstemp,
        this.allFields,
        e.value
      );
      this.ObjectsData = this.tempObjectsData

    }
  }

  inclusionAttributes : any =[]
  whereKey(event) {
    this.filterData = []
    console.log(this.filterObjects);
    // this.wherefields=event
    // console.log(this.wherefields)
    this.whereData.fieldsWhere = "";
    var tempColumnData = this.columns;
    var filterAttributes = [];
    var objectName = "";
    let selectedObjectName
    this.filterObjects.forEach((object) => {
      console.log(object.object, ",", event.value);
      if (object.object === event.value) {
        objectName = object.object;
        selectedObjectName = object.name;
      }
    })
    console.log(objectName);
    let selectedObjectDetails = this.selectedObjectsMap[selectedObjectName];
    let selectedObjectId = selectedObjectDetails ? selectedObjectDetails.id : null;
  
    console.log("Selected Object Name:", selectedObjectName);
    console.log("Retrieved Object ID:", selectedObjectId);
    console.log(objectName);
    let stageObjectCheck = objectName.toLowerCase().replace(/[^a-z0-9]/g,"")
    this.service.retrieveTablesFieldsForDataset(selectedObjectId).subscribe(res => {
      this.spinner.start();
  
      console.log(res);
      if (res.error === true) {
        this.spinner.stop();
        this.snackbar.open(res.message, "OK", { duration: 5000 });
        this.allFields = [];
        this.selectedFieldsData = [];
        this.gridApiForTablesFields.setGridOption('rowData', []);
      } else {
        this.spinner.stop();
        let fieldsArray = JSON.parse(res[0].attributeNameAndFields);
      
      if (fieldsArray.datasets) {
          console.log(JSON.parse(res[0].attributeNameAndFields))
          this.inclusionAttributes = fieldsArray.datasets[0].columns
          console.log(this.inclusionAttributes)
        } else {
          
           this.inclusionAttributes = JSON.parse(res[0].attributeNameAndFields);
        }
        // this.inclusionAttributes = JSON.parse(res[0].attributeNameAndFields);
      
        // console.log(this.inclusionAttributes);
        // console.log("inclusion Attributes:", this.inclusionAttributes);
      }
    });
    // this.filterData = this.columnses.filter(object => 
    //   object.object === objectName && object.type !== "" && 
    //   !object.type.includes(",") && object.type !== "__constant"
    // );
    // tempColumnData.forEach((object) => {
    //   if (object.object === objectName && object.type != "" && !object.type.includes(",") && object.type != "__constant") {
    //     console.log(object);
    //     filterAttributes.push(object)
    //   }
    // })
    // this.filterData = filterAttributes;
  
  }

  sortingKey(fields) {

    this.sortingfields = fields
    console.log(this.sortingfields)
    this.orderByData.fieldsOrderBy = "";
  }



  cancel() {
      this.isEditMode = true;
      this.isViewAction = false;
console.log("VIEW MODE → isEditMode: cancle", this.isEditMode);

    this.selectedObjectsMap = {};
    this.transformation = []
    this.concatination = []
    this.rollingUp = []
    this.groupconcattemp = []
    this.rollupExclusionObjects = []
    this.columns = []
    this.butttonname = "Create Stage Object"
    this.temp = [];
    this.filterObjects = [];
    this.rollingUp = [];
    this.fieldsDataToRemove = [];
    this.selectedObjectsData = []
    this.selectedFieldsDatatemp = [];
    this.selectedFieldsDataToPush = [];
    this.selectedFieldsData = [];
    console.log(this.show)
    // this.ObjectGrid.api.setGridOption('rowData', []);
    this.paramstemp.api.setGridOption('rowData', []);
    this.tablefields = [];
    this.selectedTableFields.api.setGridOption('rowData', []);
    this.columnDefsForReportingConfiguration = [];
    this.headersTypeArr = [];

    this.reportCreationData = {
      datasetname: "",
      datasetObjectname: "",
      datasetobjectattributes: [],
      type: "",
      description: "",
      objectGroup: "",
      filters: [],
      sorting: [],
      aggregate: [],
      columns: [],
      concatination: [],
      rollingUp: [],
      rollupExclusionObjects: [],
      transformation: [],
      columnFilters: [],
      columnFiltersExpression:"",
      generateDefaultTemplate: "",
      autoRefreshDataset: "",
      datasetAccessType: "",
      dataset_rolesIds: "",
      createdBy: "",
      createdDateAndTime: "",
      headersType: [],
      pivotAggregation:[],
      selectedObjectsMap: {},
      transformationQuery:"",
      flatteningOption:"",
      orderId:"",
      reference_source:"",
      reference_target:"",
      reference_library:"",
      reference_global_object:"",
      reference_global_source_library:"",
      reference_vault_object:"",
      global_external_object:"",
      objectGroupName:"",
      objectGroupId:"",
      reference_Database_Object_Name:"",
      reference_Database_Object_Fetch_Partial:""

    }
      this.selectedReferenceSourceObjectsListNames=""
      this.selectedReferenceTargetObjectsListNames=""
       this.selectedReferenceValueMapping=[]
     this.selectedReferenceGlobalObjectsListNames=""
      this.selectedReferenceGlobalSourceObjectsListNames=""
      this.selectedReferenceLibraryObjectsListNames=""
      this.selectedGlobalExternalObjectsListNames=""
      this.selectedReferenceSourceObjectsList=[]
      this.selectedReferenceTargetObjectsList=[];
      this.selectedReferenceLibraryObjectsList=[];
      this.selectedReferenceGlobalObjectsList=[];
      this.selectedReferenceGlobalSourceObjectsList=[];
      this.selectedGlobalExternalObjectsList=[];
      this.selectedRefDBObjectNameFetchPartialsList=[];
      this.selectedRefDBObjectNameFetchPartialsListNames=""
      this.selectedRefDBObjectNameList=[];
      this.selectedRefDBObjectNameListNames=""
    this.where = [];
    this.groupBy = [];

    this.orderBy = [];

    this.fieldsData = [];

    this.aggregateBy = [];
    this.pivotAggregateBy=[];
    this.aggregateArray = [];
    this.showRollingUp = false;
    this.showTransform = false;
    this.showOrderBy = false;
    this.showFilters = false;
    this.showFilter = false;
    this.show = false;
    this.orderByShow = false;
    this.aggreageShow = false;
    this.dateChange = false;
    this.expand = false;
    this.showColumnFilter = false;
    this.showPivotAggregate=false;
   
    this.autoRefreshDataset = false;
    this.generateDefaultTemplate = true;
    this.rootGroup = {
    type: 'group',
    condition: 'AND',
    rules: []
  };
    this.formValidationsWhere();
    // this.butttonname = "Save";
    this.formValidation();
    this.formValidationsRollingUp();
    this.formulaFieldsValidation();
    this.datasetFormValidation();
    this.formValidationForTranformation();
    this.validateColumnFilterFormGroup();
    this.formValidHeaderType.reset();

    this.formValidationsHeaderType();

    this.columnFilter = [];
    this.headersTypeArr = [];
    this.headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };
    this.columnFilterData = { "name": "", "object": "", "alias": "", "filters": [] };
    this.columnFilterDataObject = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
    this.rollingupdata = { "parentObjectName": "", "parentattribute": "", "childObjectName": "", "childattributes": "", "parentAttributesalias": "", "childAttributesalias": "", "rollupColumnAlias": "", "rollingUpLevel": "1" };
    this.orderByData = { "objectOrderBy": "", "fieldsOrderBy": "", "arrangeOrderBy": "" };
    this.whereData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
    this.recordfilterData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
    this.transformationObjectData = { "object": "", "attribute": "", "referenceObjects": "", "sql": "" };
    this.finalReportCreation = {
      "datasets": [
        {
          "name": "",
          "datasetType": "",
          "columns": []
        }
      ],
      "reports": []
    }
    this.expressionDetails="";
    // this.editor.setValue(this.expressionDetails);
     this.ObjectGrid.api.setGridOption('rowData', []);
  }

  openSaveForm() {
    this.expand = true
    this.show = true
    this.ClearData()
  }


  //Excel export function.

  reportConfigurationRun() {

    //this.columnNames = this.data.columnNames;

    console.log(this.columnNames);

    console.log(this.rowsData);

    var columnsDefsAnother = [];

    for (var i = 0; i < this.columnNames.length; i++) {
      columnsDefsAnother.push({
        headerName: this.columnNames[i],
        headerTooltip: this.columnNames[i],
        tooltipValueGetter: params => params.value,
        field: this.columnNames[i],
        filter: 'agTextColumnFilter',
        width: 150
      });
    }
    console.log(this.xKeydata)
    console.log(this.ykeydata)
   
    //Array to bind data to ag-grid.
    this.columnDefsForReportingConfiguration = columnsDefsAnother;

    this.gridApiForReportingConfiguration.setGridOption('rowData', []);

    this.gridApiForReportingConfiguration.setGridOption('rowData', this.rowsData);


  }

  modifingCharts() {
    let xAxis2;
    let yAxis2;
    let data: any = [];
    this.xdata = [];
    console.log(this.rowsData)
    console.log(this.xKeydata)
    console.log(this.ykeydata)
    for (let i = 0; i <= this.rowsData.length - 1; i++) {
      let xdummy = "";
      let ydummy = "";
      console.log(Object.keys(this.rowsData[i]))
      console.log(Object.values(this.rowsData[i]))
      for (let j = 0; j <= this.xKeydata.length - 1; j++) {
        if (Object.keys(this.rowsData[i]).includes(this.xKeydata[j])) {
          this.xAxis1 = this.rowsData[i]
          xAxis2 = this.xKeydata[j]
          if (xdummy == "") {
            xdummy = this.xAxis1[xAxis2];
          } else {
            xdummy = xdummy + "," + this.xAxis1[xAxis2];
          }
        }
      }
      for (let y = 0; y <= this.ykeydata.length - 1; y++) {
        if (Object.keys(this.rowsData[i]).includes(this.ykeydata[y])) {
          this.yAxis1 = this.rowsData[i]
          yAxis2 = this.ykeydata[y]
          ydummy = this.yAxis1[yAxis2];

        }
        let tempData = { "xAxis": xdummy, "yAxis": ydummy };

        this.xdata.push(tempData);
        console.log(this.xdata)
      }



    }
    this.xdummydata = "";
  }

  pieChart() {
    this.modifingCharts()
    console.log(this.ykeydata.length)
    this.pieChartData = !this.pieChartData
    if (this.pieChartData == false) {
      this.showgridData = true;
    } else {
      this.showgridData = false;
    }
    this.barChartData = false;
    if (this.ykeydata.length > 1) {
      this.showgridData = true;
      this.pieChartData = !this.pieChartData
      this.snackbar.open("Pie chart not available", "OK", { duration: 5000 })
    } else {
      this.options = {
        data: this.xdata,
        series: [{
          type: 'pie',
          labelKey: ['xAxis'],
          angleKey: ['yAxis'],
          angleNames: [this.ykeydata]
        }],
        legend: {
          position: 'bottom',
        },
      };
    }
  }


  cellClickedFields(e) {
    console.log(e)
  }

  onselection(params) {
    console.log(params)
  }
   allFieldsData: any
  onRowSelected(event) {
    console.log(this.paramstemp)
    console.log(this.paramstemp.api.getSelectedRows())
    this.fieldsData = this.paramstemp.api.getSelectedRows();

    console.log(this.fieldsData)

    this.selectedFieldsData = this.fieldsData;
    this.allFieldsData = [];
    this.paramstemp.api.forEachNode((node) => {
        this.allFieldsData.push(node.data);
    });


    console.log(this.selectedFieldsData);
    console.log("All Fields:", this.allFieldsData);


  }

  connect() {

    console.log(this.whereData);

    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);

      this.formFieldsTrimer.clean(this.whereData);

    }

  }

  addRollingup() {
    if (!this.formValidAttributes.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidAttributes);

      this.validation.getvalidationmessage();

    } else {
      this.onRollupAliasChange(this.rollingupdata.rollupColumnAlias);
     
      if (this.rollingupdata.parentObjectName === undefined || this.rollingupdata.childObjectName === undefined ||
        this.rollingupdata.rollupColumnAlias === undefined || this.rollingupdata.rollupColumnAlias === "") {
        this.snackbar.open("Not a valid Rolling Up", "OK", { duration: 5000 });
        return;
      } else if (this.rollingupdata.parentObjectName === "" || this.rollingupdata.childObjectName === "" ||
        this.rollingupdata.rollupColumnAlias === "" || this.rollingupdata.childattributes === "") {
        this.snackbar.open("Not a valid Rolling Up", "OK", { duration: 5000 });
        return;
      } else {
        console.log(this.rollingupdata)
        this.formFieldsTrimer.trimFormfieldsData(this.rollingupdata);
        this.formFieldsTrimer.clean(this.rollingupdata);
        this.selectedTableFields.api.forEachNode((rowNode, index) => {
          console.log(rowNode.data);
          console.log(index);
        });
        
        this.rollingupdata.parentObjectName = this.replaceCharecter(this.rollingupdata.parentObjectName, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.parentattribute = this.replaceCharecter(this.rollingupdata.parentattribute, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.childObjectName = this.replaceCharecter(this.rollingupdata.childObjectName, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.childattributes = this.replaceCharecter(this.rollingupdata.childattributes, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.parentAttributesalias = this.replaceCharecter(this.rollingupdata.parentAttributesalias, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.childAttributesalias = this.replaceCharecter(this.rollingupdata.childAttributesalias, this.constants.charecterDot, this.constants.charecterUnderScore);
        let tempRolling = {
          "parentObjectName": this.rollingupdata.parentObjectName,
          "parentattribute": this.rollingupdata.parentattribute, "childObjectName": this.rollingupdata.childObjectName,
          "childattributes": this.rollingupdata.childattributes, "parentAttributesalias": this.rollingupdata.parentAttributesalias,
          "childAttributesalias": this.rollingupdata.childAttributesalias, "rollupColumnAlias": this.rollingupdata.rollupColumnAlias, "rollingUpLevel": "1", "filters": this.recordWhere
        }
        /**
       * Modified by Ashiwn M
       * 22/02/2023
       * added rollup column alias
       */
        if (this.rollingupdata.rollupColumnAlias === "") {
          tempRolling.rollupColumnAlias = tempRolling.parentAttributesalias + "(" + tempRolling.childAttributesalias + ")";
        }
        tempRolling.rollupColumnAlias = this.replaceCharecter(tempRolling.rollupColumnAlias, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.updateColumnValues(this.rollingupdata.parentAttributesalias, this.rollingupdata.childAttributesalias);

        this.rollingUp.push(tempRolling);
        this.showRollingUp = true;
        this.rollingupdatatemp = { "childattributes": [], "childAttributesalias": [] };
        this.rollingupdata = {
          "parentObjectName": "", "parentattribute": "", "childObjectName": "",
          "childattributes": "", "parentAttributesalias": "", "childAttributesalias": "", "rollupColumnAlias": "", "rollingUpLevel": "1"
        };
        tempRolling = {
          "parentObjectName": "", "parentattribute": "", "childObjectName": "", "childattributes": "",
          "parentAttributesalias": "", "childAttributesalias": "", "rollupColumnAlias": "", "rollingUpLevel": "1", "filters": []
        };
        this.recordWhere = [];
      }
      console.log(this.rollingUp);

      this.formValidAttributes.reset();

      this.formValidationsRollingUp();
      this.childattributestemp = [];
      if (this.applyRecordFilter) {
        this.applyRecordFilterSelection();
      }
    }
  }

 
  updateColumnValues(parentattributes: any, childattributes: any) {
    let childattributesArray = childattributes.split(",");
    console.log(childattributesArray.length);
    for (let arrayIndex = 0; arrayIndex < childattributesArray.length; arrayIndex++) {
      let attributeElement = childattributesArray[arrayIndex];
      if (attributeElement.includes(".")) {
        attributeElement = this.replaceCharecter(attributeElement, this.constants.charecterDot,
          this.constants.charecterUnderScore);
        childattributesArray[arrayIndex] = attributeElement
      }
      console.log("Compare -> " + attributeElement);
    }
  }

  childattributestemp = []
  changeRollingUpChildAttributes(e) {
    console.log(e)
    console.log(e.value)
    this.rollingupdata.childattributes = e.value.attributeNameWithFields;
    this.rollingupdata.childAttributesalias = e.value.attributeNameWithFields;
    this.rollingupdata.rollupColumnAlias = this.rollingupdata.parentAttributesalias + "(" + this.rollingupdata.childAttributesalias + ")";
  }
  parentattribute = "";
  changeRollingUpParentAttributes(e) {
    console.log(e)
    console.log(e.value)
    this.parentattribute = e.value;
    this.rollingupdata.parentattribute = e.value.attributeNameWithFields;
    this.rollingupdata.parentAttributesalias = e.value.attributeNameWithFields;
    console.log(this.rollingupdata)
  }

  addWhere() {
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);
      this.formFieldsTrimer.clean(this.whereData);
      if (this.whereData.objectWhere == undefined || this.whereData.fieldsWhere == undefined || this.whereData.conditionalOperatorWhere == undefined) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      } else {
        this.whereData.logicalOperatorWhere = "AND";
        console.log(this.whereData.enterValueWhereDate)
        console.log(this.whereData.enterValueWhere)
        console.log(this.whereData.fieldsWhere)
        let objectName = "";
        console.log(this.filterData)
        this.filterData.forEach(object => {
          if (object.attributeNameWithFields === this.whereData.fieldsWhere) {
            objectName = object.name;
          }
        })
        console.log(objectName)
        var whereValue;
        if (this.whereData.conditionalOperatorWhere === "IN") {
          var multipleValue;
          var multiValue = "";
          multipleValue = this.whereData.multiSelect;
          let value = multipleValue.split(",")
          if (value.length == 0) {
            this.snackbar.open("Not a valid filter. Please select value to Add filter", "OK", { duration: 5000 });
          }
          for (let index = 0; index < value.length; index++) {
            const element = value[index];
            multiValue = multiValue + "'" + element + "'";
            if (index != value.length - 1) {
              multiValue = multiValue + ",";
            }
          };
          whereValue = "(" + multiValue + ")";
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else if (this.whereData.conditionalOperatorWhere === "BETWEEN") {
          if (this.dateChange) {
            this.whereValueDateFormat = moment(this.whereData.enterValueBetweenStart)
            this.whereData.enterValueBetweenStart = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
            console.log(this.whereData.enterValueBetweenStart)
            this.whereValueDateFormat = moment(this.whereData.enterValueBetweenEnd)
            this.whereData.enterValueBetweenEnd = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
            console.log(this.whereData.enterValueBetweenEnd)
            let tempWhere = {
              "objectWhere": this.whereData.objectWhere,
              "whereKey": objectName,
              "whereKeyAlias": this.whereData.fieldsWhere,
              "whereCondition": this.whereData.conditionalOperatorWhere,
              "whereValue": "'" + this.whereData.enterValueBetweenStart + "'",
              "whereValue1": "'" + this.whereData.enterValueBetweenEnd + "'",
              "whereLogic": this.whereData.logicalOperatorWhere
            }
            this.where.push(tempWhere);
            tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
          } else {
            let tempWhere = {
              "objectWhere": this.whereData.objectWhere,
              "whereKey": objectName,
              "whereKeyAlias": this.whereData.fieldsWhere,
              "whereCondition": this.whereData.conditionalOperatorWhere,
              "whereValue": "'" + this.whereData.enterValueBetweenStart + "'",
              "whereValue1": "'" + this.whereData.enterValueBetweenEnd + "'",
              "whereLogic": this.whereData.logicalOperatorWhere
            }
            this.where.push(tempWhere);
            tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
          }
        } else if (this.whereData.conditionalOperatorWhere === "schedule range") {
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": this.whereData.conditionalOperatorWhere,
            "whereValue": "",
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }
          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else if (this.whereData.conditionalOperatorWhere === "Ends with") {
          whereValue = "'%" + this.whereData.enterValueWhere + "'";
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": "LIKE",
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" };
        } else if (this.whereData.conditionalOperatorWhere === "Starts with") {
          whereValue = "'" + this.whereData.enterValueWhere + "%'";
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": "LIKE",
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else if (this.whereData.conditionalOperatorWhere === "contains") {
          whereValue = "'%" + this.whereData.enterValueWhere + "%'";
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": "LIKE",
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else {
          if (this.dateField) {
            this.whereValueDateFormat = moment(this.whereData.enterValueWhereDate)
            whereValue = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          } else {
            whereValue = "'" + this.whereData.enterValueWhere + "'";
            this.whereData.enterValueWhere = whereValue;
          }
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" };
        }
        this.showFilter = true;
        this.whereData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
        this.dateChange = false;
        this.dateField = false;
        this.multiselect = false;
        this.fieldChange = true;
        this.scheduleRange = false;
        this.betweenField = false;

        console.log(this.where);

        this.formValidWhere.reset();

        this.formValidationsWhere();
        this.multiSelectVaules = [];
        this.filterData = [];
      }

    }

  }

  addOrderBy() {
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.orderByData);
      this.formFieldsTrimer.clean(this.orderByData);
      // this.orderByData.objectOrderBy == undefined ||
      if (this.orderByData.fieldsOrderBy == undefined || this.orderByData.arrangeOrderBy == undefined) {
        this.snackbar.open("Not a valid sort operation", "OK", { duration: 5000 });
      } else {
        if (this.orderByData.arrangeOrderBy == undefined) {
          this.orderByData.arrangeOrderBy = "AND"
        }
        console.log(this.orderByData.fieldsOrderBy)
        console.log(this.orderByData.fieldsOrderBy)
        let objectName = "";
        let valutObject = "";
        console.log("DataLength", this.filterData.length);
        this.columns.forEach(object => {
          if (object.alias === this.orderByData.fieldsOrderBy) {
            objectName = object.name;
            valutObject = object.object;
          }
        })
        let tempOrder = {
          "orderObject": valutObject,
          "objectOrderBy": this.orderByData.objectOrderBy,
          "orderKey": objectName,
          "orderKeyAlias": this.orderByData.fieldsOrderBy,
          "orderAllign": this.orderByData.arrangeOrderBy
        }

        this.orderBy.push(tempOrder);
        this.showOrderBy = true;
        this.orderByData = { "objectOrderBy": "", "fieldsOrderBy": "", "arrangeOrderBy": "" };

        tempOrder = { "orderObject": "", "objectOrderBy": "", "orderKey": "", "orderKeyAlias": "", "orderAllign": "", }

        console.log(this.orderBy);

        this.formValidWhere.reset();

        this.formValidationsWhere();
      }

    }
  }
  addHeaderType() {
    console.log(this.columns);
    console.log(this.headerTypeObj);
    console.log(this.headersTypeArr)

    if (!this.formValidHeaderType.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidHeaderType);

      this.validation.getvalidationmessage();

    }

    else {


      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.headerTypeObj);
      this.formFieldsTrimer.clean(this.headerTypeObj);
      // this.orderByData.objectOrderBy == undefined ||
      // headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };

      if (this.headerTypeObj.headerKeyAlias == undefined || this.headerTypeObj.headerKeyType == undefined) {
        this.snackbar.open("Not a valid Header", "OK", { duration: 5000 });
      } else {


        console.log(this.headerTypeObj.headerKey);

        let headerKeyAliasArr = this.headerTypeObj.headerKeyAlias.split(",");
        for (let j = 0; j < headerKeyAliasArr.length; j++) {
          let filteredArr = this.headersTypeArr.filter(item => item.headerKeyAlias == headerKeyAliasArr[j])
          console.log(filteredArr)
          if (filteredArr.length > 0) {
            this.snackbar.open("Header Key Alias [" + filteredArr[0].headerKeyAlias + "] Already Exists", "OK", { duration: 5000 });
            this.headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };
            this.formValidHeaderType.reset();

            this.formValidationsHeaderType();

            return;
          }
        }
        for (let a = 0; a < headerKeyAliasArr.length; a++) {
          this.columns.forEach(object => {

            if (object.alias === headerKeyAliasArr[a]) {

              let tempHeader = {
                "headerKey": object.name,
                "headerKeyObject": object.object,
                "headerKeyType": this.headerTypeObj.headerKeyType,
                "headerKeyAlias": headerKeyAliasArr[a],

              }
              this.headersTypeArr.push(tempHeader)
              tempHeader = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" }

            }
          })
        }




        // this.mofifyHeadersTypeObjects(this.headersTypeArr)
        if (this.headersTypeArr.length > 0) {
          this.showHeaderType = true;
        }
        // this.orderByData = { "objectOrderBy": "", "fieldsOrderBy": "", "arrangeOrderBy": "" };
        this.headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };


        // tempHeader = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" }

        console.log(this.orderBy);

        this.formValidHeaderType.reset();

        this.formValidationsHeaderType();
      }

    }


  }


  addAggregate() {
    console.log(this.aggregateByData);
    console.log(this.aggregateByData.aggregateOn);
    console.log(this.aggregateByData.aggregateFunction);
    console.log(this.aggregateByData.partionOn);
    console.log(this.aggregateByData.distinctColumns);
    console.log(this.aggregateByData.columnAlias);
    console.log(this.aggregateByData.distinctColumns);

    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.aggregateByData);
      this.formFieldsTrimer.clean(this.aggregateByData);
      if (this.aggregateByData.aggregateOn == undefined || this.aggregateByData.aggregateFunction == undefined || this.aggregateByData.partionOn == undefined ||  this.aggregateByData.columnAlias == undefined) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      } else {
        // Update aggregateByData with ordered selections
        this.aggregateByData.partionOn = this.orderedPartitionSelection.join(',');
        this.aggregateByData.distinctColumns = this.orderedOrderBySelection.join(',');

        if (this.aggregateByData.aggregateFunction == undefined) {
          this.aggregateByData.aggregateFunction = "AND"
        }
        let tempAggregate = { "aggregateColumn": this.aggregateByData.aggregateOn, "aggregateFunction": this.aggregateByData.aggregateFunction, "partitionByColumn": this.aggregateByData.partionOn, "reporting": "Y", "distinctColumns": this.aggregateByData.distinctColumns, "alias": this.aggregateByData.columnAlias, "conditionalValue": this.aggregateByData.conditionalValue, "groupByFunction": this.aggregateByData.groupByFunction, "groupByNeeded": false };

        if (this.aggregateByData.conditionalValue == undefined) {
          tempAggregate = { "aggregateColumn": this.aggregateByData.aggregateOn, "aggregateFunction": this.aggregateByData.aggregateFunction, "partitionByColumn": this.aggregateByData.partionOn, "reporting": "Y", "distinctColumns": this.aggregateByData.distinctColumns, "alias": this.aggregateByData.columnAlias, "conditionalValue": "", "groupByFunction": this.aggregateByData.groupByFunction, "groupByNeeded": false };

        }
        if (this.aggregateBy.length > 0) {
          for (let i = 0; i < this.aggregateBy.length; i++) {
            if (this.aggregateBy[i].alias === tempAggregate.alias) {
              this.snackbar.open("Please enter Unique Alias for Aggregate", "OK", { duration: 5000 });

              return;
            }
          }
        }
        //   let tempAggregate = { "aggregateObject": this.aggregateByData.objectAggregateBy, "aggregateKey": this.aggregateByData.fieldsAggregateBy, "aggregate": this.aggregateByData.arrangeaggregateBy }
        this.aggregateBy.push(tempAggregate);
        if (this.aggregateBy.length > 0) {
          this.showAggregate = true;

        }
        this.aggregateByData = { "aggregateOn": "", "aggregateFunction": "", "partionOn": "", "distinctColumns": "", "columnAlias": "", "conditionalValue": "", "groupByNeeded": false, "groupByFunction": "" };

        tempAggregate = { "aggregateColumn": "", "aggregateFunction": "", "partitionByColumn": "", "distinctColumns": "", "reporting": "Y", "alias": "", "conditionalValue": "", "groupByFunction": "", "groupByNeeded": false };



        console.log(this.aggregateBy);

        this.formValidWhere.reset();

        this.formValidationsWhere();
      }
    }

  }


  addPivotAggregate(){
    if (!this.formValidWhere.valid) {
      this.validation.validateAllFormFields(this.formValidWhere);
      this.validation.getvalidationmessage();
    }else {
      this.formFieldsTrimer.trimFormfieldsData(this.pivotAggregateByData);
      this.formFieldsTrimer.clean(this.pivotAggregateByData);

      if (this.pivotAggregateByData.columnAlias == undefined || this.pivotAggregateByData.caseColumn == undefined || this.pivotAggregateByData.pivotColumn == undefined || this.pivotAggregateByData.childColumns == undefined ||  this.pivotAggregateByData.headersToNull == undefined ||  this.pivotAggregateByData.orderByColumn == undefined ||  this.pivotAggregateByData.parentcolumns == undefined ||  this.pivotAggregateByData.headerValueColumn == undefined) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      } else {
        console.log(this.orderedChildColumns);
        this.pivotAggregateByData.childColumns= this.orderedChildColumns.join(',');
        this.pivotAggregateByData.headersToNull= this.orderedHeadersToNull.join(',');
        this.pivotAggregateByData.orderByColumn= this.orderedOrderByColumn.join(',');
        this.pivotAggregateByData.parentcolumns= this.orderedParentcolumns.join(',');

        let tempPivotAggregate={
          "alias":this.pivotAggregateByData.columnAlias,
          "caseColumn":this.pivotAggregateByData.caseColumn,
          "pivotColumn":this.pivotAggregateByData.pivotColumn,
          "childColumns":this.pivotAggregateByData.childColumns,
          "headersToNull":this.pivotAggregateByData.headersToNull,
          "orderByColumn":this.pivotAggregateByData.orderByColumn,
          "parentcolumns":this.pivotAggregateByData.parentcolumns,
          "headerValueColumn":this.pivotAggregateByData.headerValueColumn
        }
        console.log(this.pivotAggregateByData);

        if (this.pivotAggregateBy.length > 0) {
          for (let i = 0; i < this.pivotAggregateBy.length; i++) {
            if (this.pivotAggregateBy[i].alias === tempPivotAggregate.alias) {
              this.snackbar.open("Please enter Unique Alias for Pivot Aggregate", "OK", { duration: 5000 });

              return;
            }
          }
        }

        this.pivotAggregateBy.push(tempPivotAggregate);

        if (this.pivotAggregateBy.length > 0) {
          this.showPivotAggregate = true;

        }
        this.pivotAggregateByData={
          "columnAlias":"",
          "caseColumn":"",
          "pivotColumn":"",
          "childColumns":"",
          "headerValueColumn":"",
          "orderByColumn":"",
          "parentcolumns":"",
          "headersToNull":""
          
        }

        tempPivotAggregate={
          "alias":"",
          "caseColumn":"",
          "pivotColumn":"",
          "childColumns":"",
          "headerValueColumn":"",
          "orderByColumn":"",
          "parentcolumns":"",
          "headersToNull":""
          
        }

        this.formValidWhere.reset();

        this.formValidationsWhere();
      }
    }
  }

  addSubAggregateLevel() {
    console.log("===================================");
    console.log(this.subAggregateLevelData);
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      this.formFieldsTrimer.trimFormfieldsData(this.subAggregateLevelData);
      this.formFieldsTrimer.clean(this.subAggregateLevelData);



      // Push a copy of the data to avoid reference issues

      if (this.subAggregateLevelData.groupByColumn == "" || this.subAggregateLevelData.groupByColumn == null || this.subAggregateLevelData.groupByColumn == undefined || this.subAggregateLevelData.alias == "" || this.subAggregateLevelData == null) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });

      } else {

        console.log("groupByColumnSelections before update: ", this.groupByColumnSelections);
        this.subAggregateLevelData.groupByColumn = this.orderedOrderBySelection.join(',');
        console.log("groupByColumn after update: ", this.subAggregateLevelData.groupByColumn);


        let subAggregateLevelDataCopy = { "groupByColumn": this.subAggregateLevelData.groupByColumn, "groupByNeeded": true, "alias": this.subAggregateLevelData.alias }
        this.subLevelAggregateBy.push(subAggregateLevelDataCopy);

        this.showSubLevelAggregate = true;
        this.subAggregateLevelData = { "groupByColumn": "", "groupByNeeded": true, "alias": "" }
        subAggregateLevelDataCopy = { "groupByColumn": "", "groupByNeeded": true, "alias": "" }

        // Now reset the form
        this.formValidWhere.reset();
        this.formValidationsWhere();

        console.log(this.subLevelAggregateBy);

      }
    }
  }
  

  createreport() {
     this.spinner.start();
    console.log(this.reportCreationData.datasetname)
    console.log(this.reportCreationData.description)
    console.log(this.columns)
    console.log(this.dnsid)
    if (!this.validations_form.valid || !this.name) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();
      this.spinner.stop();
    } else {
     
      let parentKey = 0;
      // console.log(this.getSQL());
      // console.log(this.getJson());
      this.columns.forEach(column => {
        if (column.type === "__constant") {
           const separatorIndex = column.alias.indexOf("Seperator");
          // column.name = column.alias.substring(0, column.alias.indexOf("Seperator"));
            // column.name = column.alias.includes("Seperator") ? column.alias.substring(0, column.alias.indexOf("Seperator")) : column.alias;
          if(separatorIndex !== -1){
             column.name = column.alias.substring(0, column.alias.indexOf("Seperator"));
             console.log("Separator existed",column.name)
          }else{
            const match = column.alias.match(/\(([^)]+)\)/);
            column.name = match ? match[1] : column.alias;
            console.log("Separator not existed",column.name)
          }
          // column.object = "constants";
        }
      })
      console.log(this.subLevelAggregateBy)
      if (this.subLevelAggregateBy.length > 0) {
       
        for (let a = 0; a < this.subLevelAggregateBy.length; a++) {
          this.aggregateBy.push(this.subLevelAggregateBy[a]);
        }
      }
      console.log(this.aggregateBy);



      if (this.headersTypeArr == null || this.headersTypeArr == undefined) {
        this.headersTypeArr = [];
      }


      this.reportCreationData.headersType = this.headersTypeArr;
      this.reportCreationData.filters = this.where
      this.reportCreationData.sorting = this.orderBy
      this.reportCreationData.aggregate = this.aggregateBy
      this.reportCreationData.columns = this.columns
      this.reportCreationData.concatination = this.concatination
      this.reportCreationData.rollingUp = this.rollingUp
      this.reportCreationData.generateDefaultTemplate = this.generateDefaultTemplate;
      this.reportCreationData.pivotAggregation=this.pivotAggregateBy
     
      console.log(this.reportCreationData.autoRefreshDataset)
      this.reportCreationData.transformation = this.transformation;
      if(this.getSQL()){
        let columnFilterDetails:RuleGroup =this.stripUiFields(this.rootGroup)
        let columnFilterArray=[]
        columnFilterArray.push(columnFilterDetails)
        this.reportCreationData.columnFilters=columnFilterArray;
        this.reportCreationData.columnFiltersExpression=this.getAbstractedSQL();
        console.log(this.getAbstractedSQL());
      }else{
        this.reportCreationData.columnFilters = [];
        this.reportCreationData.columnFiltersExpression=""
      }
      this.reportCreationData.selectedObjectsMap = this.selectedObjectsMap;
      this.reportCreationData.transformationQuery=this.expressionDetails;
      console.log(this.recordDnsName)
      console.log(this.reportCreationData)
      if (this.butttonname === "Update Stage Object") {
        parentKey = this.reportCreationUpdateid
      }
      this.reportCreationData.objectGroup= this.recordDnsName

      this.reportCreationData.reference_source=this.selectedReferenceSourceObjectsListNames
      this.reportCreationData.reference_target=this.selectedReferenceTargetObjectsListNames
      this.reportCreationData.reference_library=""
       if(this.selectedReferenceValueMapping){
          this.reportCreationData.reference_library=this.selectedReferenceValueMapping.join(',');
        }else{
          this.reportCreationData.reference_library=""
        }
      this.reportCreationData.reference_global_object=this.selectedReferenceGlobalObjectsListNames
      this.reportCreationData.reference_global_source_library=this.selectedReferenceGlobalSourceObjectsListNames
      this.reportCreationData.reference_vault_object=this.selectedReferenceLibraryObjectsListNames
      this.reportCreationData.global_external_object=this.selectedGlobalExternalObjectsListNames
      this.reportCreationData.reference_Database_Object_Name=this.selectedRefDBObjectNameListNames
      this.reportCreationData.reference_Database_Object_Fetch_Partial=this.selectedRefDBObjectNameFetchPartialsListNames
      
      this.linkservice.insertStageObject(this.reportCreationData, parentKey,this.SourceId).subscribe(response => {
        console.log(response);
        this.snackbar.open(response.statusMessage + response.data, "OK", {
          duration: 5000,
        });
        
        if (!response.error) {
          this.showRollingUp = false;
          this.objectGroup = false;
          this.datasetGroup = false;
          // this.onGridReady(this.rowbindingdata);
          this.refreshGridData(); 
          this.cancel();
          this.butttonname === "create Stage Object"
           this.aggregateBy = []
            this.pivotAggregateBy=[]
            this.subLevelAggregateBy = [];
            this.subAggregateLevelData = { "groupByColumn": "", "groupByNeeded": true, "alias": "" };
            this.headersTypeArr = [];
            this.headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };
             this.selectedObjectsMap = {};
              this.showAggregate = false;
              this.showHeaderType = false;
              this.showSubLevelAggregate = false;
              this.showPivotAggregate=false;
              // this.cancel();
            this.butttonname === "create Stage Object"
            this.spinner.stop();
        }else{
          this.spinner.stop();
        }
       this.selectedReferenceSourceObjectsListNames=""
      this.selectedReferenceTargetObjectsListNames=""
       this.selectedReferenceValueMapping=[]
     this.selectedReferenceGlobalObjectsListNames=""
      this.selectedReferenceGlobalSourceObjectsListNames=""
      this.selectedReferenceLibraryObjectsListNames=""
      this.selectedGlobalExternalObjectsListNames=""
      this.selectedReferenceSourceObjectsList=[]
      this.selectedReferenceTargetObjectsList=[];
      this.selectedReferenceLibraryObjectsList=[];
      this.selectedReferenceGlobalObjectsList=[];
      this.selectedReferenceGlobalSourceObjectsList=[];
      this.selectedGlobalExternalObjectsList=[];
      this.selectedRefDBObjectNameFetchPartialsList=[];
      this.selectedRefDBObjectNameFetchPartialsListNames=""
      this.selectedRefDBObjectNameList=[];
      this.selectedRefDBObjectNameListNames=""
      });
     
    }






    this.spinner.stopAll();

  }

  addGroupBy() {

    if (!this.formValidGroupBy.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidGroupBy);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.groupByData);

      this.formFieldsTrimer.clean(this.groupByData);

      console.log(this.groupByData.fieldsGroupBy);

      this.groupBy.push(this.groupByData.fieldsGroupBy);

      console.log(this.groupBy);

      this.groupByData = { "fieldsGroupBy": "" };

      console.log(this.groupByData);

      this.formValidGroupBy.reset();

      this.formValidationsGroupBy();

    }

  }

   Useroles$(){
    const dnsid = this.localStorageSettings.getSettings("dnsName");
    if (dnsid) {
      return this.service.getUserRoles(dnsid).pipe(
        tap(response=>{
          if(response){
            this.UserRolesWithRoleId = response;
          }
        })
      )
    }
  }


  access_permission(data) {



    console.log(data)
    this.sharedData = data.rowData;

    if (data.rowData.status === "No") {
      this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
      return;
    }


    if (this.responserequest.roleName !== data.rowData.dataset_ownerRoleid) {
      this.snackbar.open(this.constants.Access_Denied, "OK", { duration: 5000 });
      return;
    }





    let dialogRef = this.dialog.open(AccessPermissionComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      autoFocus: false,
      data: { edata: this.sharedData },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((message: string) => {

      if (message === 'updated') {
        this.refreshRun();
      }
    });



  }


  public sharerowData() {
    console.log(this.sharedData);
    return this.sharedData;
  }



  analysis(data) {


    console.log(data);


    let dialogRef = this.dialog.open(SelectFiltersPopUpComponent, {
      width: "80%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "96%",
      disableClose: true,
      data: { dataSetId: data.rowData.reportcreationid, objectGroup: data.rowData.objectGroup, columnsData: data.rowData.columns, datasetData: data.rowData, showVisualDropDowns: true }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);


      let getdata = result.selectedFiltersListString
      if (getdata) {
        let filterList = JSON.parse(getdata);
        console.log(filterList);
        let dnsId = localStorage.getItem("dnsName");
        this.etlService.retrieveJsuiteProperty(dnsId, "UIDateFormat").subscribe(res => {
          this.spinner.start();
          console.log("Test string");
          console.log(res)
          if (res) {
            this.jsuitepropertyValue = res.propertyvalue;
            console.log(this.jsuitepropertyValue);
            this.filterListBody = []
            for (let i = 0; i < filterList.length; i++) {
              if(filterList[i].whereCondition !== "CalculatedFieldForReports"){
              console.log(filterList[i].whereValue.length);
              let filterValue;
              let showInQuicksightVisuals: any = "";
              if (filterList[i].showInQuicksightVisuals) {
                showInQuicksightVisuals = filterList[i].showInQuicksightVisuals
              } else {
                showInQuicksightVisuals = false
              }
              let displayCalculatedFieldsIn = "columns"
              if (filterList[i].displayCalculatedFieldsIn) {
                displayCalculatedFieldsIn = filterList[i].displayCalculatedFieldsIn
              } else {
                displayCalculatedFieldsIn = "columns"
              }
              if (filterList[i].whereCondition == "IN") {
                // filterValue = this.convertArrayToString(filterList[i].whereValue)
                filterValue = JSON.stringify(filterList[i].whereValue);
              } else if (filterList[i].whereCondition == "BETWEEN") {

                if (filterList[i].type == "DateTime" || filterList[i].type == "Date") {

                  if (filterList[i].whereValue.length > 0) {
                    const parsedDate = moment(filterList[i].whereValue, 'YYYY-MM-DD').startOf('day');
                    filterList[i].whereValue = parsedDate.format(this.jsuitepropertyValue)
                  } else {
                    filterList[i].whereValue = ""
                  }

                  if (filterList[i].whereValue1.length > 0) {
                    const parsedDate2 = moment(filterList[i].whereValue1, 'YYYY-MM-DD').startOf('day');
                    filterList[i].whereValue1 = parsedDate2.format(this.jsuitepropertyValue)
                  }


                }
                filterValue = [this.removeSingleQuotes(filterList[i].whereValue), this.removeSingleQuotes(filterList[i].whereValue1)]
                filterValue = JSON.stringify(filterValue);
              } else {
                filterValue = this.removeSingleQuotes(filterList[i].whereValue)
                if (filterList[i].type == "DateTime" || filterList[i].type == "Date") {

                  if (filterList[i].whereValue.length > 0) {
                    const parsedDate = moment(filterList[i].whereValue, 'YYYY-MM-DD').startOf('day');
                    filterValue = parsedDate.format(this.jsuitepropertyValue);
                  } else {
                    filterValue = ""
                  }


                }
              }
              console.log(filterList[i].whereValue.length);
              console.log(filterValue);
              console.log(filterList[i].excludeNull);

              if (filterList[i].excludeNull == undefined) {
                let listObject = {
                  label: filterList[i].label,
                  columnName: filterList[i].whereKeyAlias,
                  matchOperator: filterList[i].whereCondition,
                  filterValue: filterValue,
                  filterType: "String",
                  excludeNull: false,
                  showOnlyNulls: false,
                  showInQuicksightVisuals: showInQuicksightVisuals,
                  displayCalculatedFieldsIn: displayCalculatedFieldsIn

                }
                if (filterList[i].type == "DateTime" || filterList[i].type == "Date") {
                  listObject.filterType = filterList[i].type
                }
                this.filterListBody.push(listObject)
              } else if ((filterList[i].whereValue.length > 0 && filterValue != "undefined") || filterList[i].excludeNull || filterList[i].showOnlyNulls) {
                let listObject = {
                  label: filterList[i].label,
                  columnName: filterList[i].whereKeyAlias,
                  matchOperator: filterList[i].whereCondition,
                  filterValue: filterValue,
                  filterType: "String",
                  excludeNull: filterList[i].excludeNull,
                  showOnlyNulls: filterList[i].showOnlyNulls,
                  showInQuicksightVisuals: showInQuicksightVisuals,
                  displayCalculatedFieldsIn: displayCalculatedFieldsIn

                }
                if (filterList[i].type == "DateTime" || filterList[i].type == "Date") {
                  listObject.filterType = filterList[i].type
                }
                this.filterListBody.push(listObject)
              }
            }
            }
            this.datasetQuickSight.filterList = this.filterListBody
            console.log(this.datasetQuickSight);
            // this.spinner.stop();

            if (data.rowData.status === "No") {
              this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
              return;
            }
            this.datasetQuickSight.dataSetId = data.rowData.reportcreationid;
            this.datasetQuickSight.dataSetName = data.rowData.datasetname;
            this.datasetQuickSight.dnsId = this.localStorageSettings.getSettings("dnsName");
            this.datasetQuickSight.s3Path = data.rowData.dataSets3Path;
            if (result.visualType) {
              this.datasetQuickSight.visualType = result.visualType;
            } else {
              this.datasetQuickSight.visualType = "Tabular"
            }

            if (result.visualId > 0) {
              this.datasetQuickSight.visualId = result.visualId
            } else {
              this.datasetQuickSight.visualId = 0
            }
            console.log(this.datasetQuickSight);

            this.linkservice.generateDatasetAnalysis(this.datasetQuickSight).subscribe(result => {
              this.snackbar.open(result.data, "OK", {
                duration: 5000,
              });
              this.spinner.stop();
              if (result.data === "Analysis Generated") {
                const analysisReference = data.rowData.analysisreference;
                const url = this.router.serializeUrl(
                  this.router.createUrlTree(['/user/Menubar/quickSight'], { queryParams: { analysis: analysisReference } })
                );
                window.open(url, '_blank');
                // this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
                //   this.router.navigate(["/user/Menubar/quickSight"], { queryParams: { analysis: data.rowData } }));
              }
            });
          }
        });
      } else {
        this.filterListBody = []
      }




    });



  }

  convertArrayToString(array: string[]): string {
    // Join the array elements with "','" and add parentheses and single quotes
    let result = "('" + array.join("','") + "')";
    return result;
  }
  removeSingleQuotes(str) {
    console.log(str);

    return str.replace(/['%]/g, "");
  }

  EditIcon(updatedata,isViewMode?:boolean) {
    if(isViewMode){
      this.isViewAction = true;
    }else{
      this.isViewAction = false;
    }
    this.isEditMode = true;
console.log("VIEW MODE → isEditMode: edit", this.isEditMode);

    if(!this.isViewAction ||updatedata.rowData.approvedBy === this.localStorageSettings.getSettings("AuthUsername") || updatedata.rowData.approvedStatus != 'Approved'){
    if (updatedata.rowData.status === "No") {
      this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
      return;
    }




    console.log(updatedata)
    this.sharedData = updatedata.rowData;
    
      this.spinner.start();
      this.butttonname = "Update Stage Object"
      this.editData(updatedata)
      const el = document.getElementById('topContentDiv');
      el?.scrollTo({ top: 0, behavior: 'smooth' });
  }else{
     this.cancel();
     this.snackbar.open("Unauthorized to perform this operation for approved Stage Object.", "OK", { duration: 5000 });
  }  
  // this.isViewAction = false;
  }



  editData(updatedata) {
    console.log(updatedata);
    
    // this.spinner.start();
    this.where = [];
    this.recordWhere = [];
    this.orderBy = [];
    this.aggregateBy = [];
    this.pivotAggregateBy=[];
    this.transformation = [];
    this.columns = [];
    this.temp = [];
    this.concatination = [];
    this.rollingUp = [];
    this.groupconcattemp = [];
    this.filterObjects = [];
    this.headersTypeArr = [];
    let columnstemp = [];
    let concatinationtemp = [];
    let rollingUptemp = [];
    let filters = [];
    let rollupExclusionObjects = [];
    let sorting = [];
    let transformationTemp = [];
    let columnFilterTemp:RuleGroup;
    this.selectedFieldsData = []
    let headersTypeArr = [];
    this.showHeaderType = false;
    this.expressionDetails=""
    this.reportCreationUpdateid = updatedata.rowData.id;
    console.log(updatedata.rowData.id)
    console.log(this.reportCreationUpdateid);
    this.reportCreationData.datasetname = updatedata.rowData.datasetname
    this.reportCreationData.description = updatedata.rowData.description
    this.reportCreationData.type = updatedata.rowData.type
    this.reportCreationData.createdBy = updatedata.rowData.createdBy
    this.reportCreationData.createdDateAndTime = updatedata.rowData.createdDateAndTime
   this.reportCreationData.orderId =   updatedata.rowData.orderId
   
    console.log(this.reportCreationData)
    // this.onGridReadyForObjects(this.ObjectGrid, this.dnsid);
    const parsedColumns = JSON.parse(updatedata.rowData.columns);
    const datasets = parsedColumns.datasets || [];
    const firstDataset = datasets[0] || {};
    console.log(firstDataset);
    
    columnstemp = firstDataset.columns || [];
    concatinationtemp =firstDataset.concatination || [];
    rollingUptemp = firstDataset.rollingUp || [];
    filters =  firstDataset.filters || [];
    sorting = firstDataset.sorting || [];
    this.selectedObjectsMap = firstDataset.selectedObjectDetails || {};
    this.recordDnsName = firstDataset.envname;
    this.name= firstDataset.envname;
    this.expressionDetails=firstDataset.transformationQuery
    this.reportCreationData.flatteningOption=firstDataset.flatteningOption
    // if(this.expressionDetails){
    //  this.editor.setValue(this.expressionDetails);
    // }else{
    //    this.editor.setValue("");
    // }
    console.log("name",this.name)
    
   
      this.selectedReferenceSourceObjectsListNames=firstDataset.reference_source
    this.selectedReferenceTargetObjectsListNames=firstDataset.reference_target
this.selectedReferenceLibraryObjectsListNames=firstDataset.reference_vault_object
  this.selectedReferenceGlobalObjectsListNames=firstDataset.reference_global_object
  this.selectedReferenceGlobalSourceObjectsListNames=firstDataset.reference_global_source_library
  this.selectedGlobalExternalObjectsListNames=firstDataset.global_external_object
   this.selectedRefDBObjectNameFetchPartialsListNames=firstDataset.reference_Database_Object_Fetch_Partial
   this.selectedRefDBObjectNameListNames=firstDataset.reference_Database_Object_Name
  
    if(firstDataset.reference_library){
      this.selectedReferenceValueMapping=firstDataset.reference_library.split(',');
    }
   
    if(this.selectedReferenceSourceObjectsListNames){
this.selectedReferenceSourceObjectsList=this.selectedReferenceSourceObjectsListNames.split(',');
    }else{
      this.selectedReferenceSourceObjectsList=[]
    }
    if(this.selectedReferenceTargetObjectsListNames){
     this.selectedReferenceTargetObjectsList=this.selectedReferenceTargetObjectsListNames.split(',');
    }else{
      this.selectedReferenceTargetObjectsList=[]
    }



     if(this.selectedReferenceLibraryObjectsListNames){
     this.selectedReferenceLibraryObjectsList=this.selectedReferenceLibraryObjectsListNames.split(',');
    }else{
      this.selectedReferenceLibraryObjectsList=[]
    }
    
     if(this.selectedReferenceGlobalObjectsListNames){
     this.selectedReferenceGlobalObjectsList=this.selectedReferenceGlobalObjectsListNames.split(',');
    }else{
      this.selectedReferenceGlobalObjectsList=[]
    }

     if(this.selectedReferenceGlobalSourceObjectsListNames){
     this.selectedReferenceGlobalSourceObjectsList=this.selectedReferenceGlobalSourceObjectsListNames.split(',');
    }else{
      this.selectedReferenceGlobalSourceObjectsList=[]
    }

    if(this.selectedGlobalExternalObjectsListNames){
     this.selectedGlobalExternalObjectsList=this.selectedGlobalExternalObjectsListNames.split(',');
    }else{
      this.selectedGlobalExternalObjectsList=[]
    }

    if(this.selectedRefDBObjectNameFetchPartialsListNames){
     this.selectedRefDBObjectNameFetchPartialsList=this.selectedRefDBObjectNameFetchPartialsListNames.split(',');
    }else{
      this.selectedRefDBObjectNameFetchPartialsList=[]
    }

    if(this.selectedRefDBObjectNameListNames){
     this.selectedRefDBObjectNameList=this.selectedRefDBObjectNameListNames.split(',');
    }else{
      this.selectedRefDBObjectNameList=[]
    }

   
    this.selectDns(this.recordDnsName)
    // this.recordDnsName = firstDataset.dnsName


    if (updatedata.rowData.headersType != undefined || updatedata.rowData.headersType != null) {
      headersTypeArr = firstDataset.headersType || [];
    } else {
      headersTypeArr = [];
    }



    rollupExclusionObjects = firstDataset.rollupExclusionObjects || [];
    transformationTemp =  firstDataset.transformation || [];
    
    this.aggregateBy = firstDataset.aggregate || [];
    if(updatedata.rowData.pivotAggregation){
      this.pivotAggregateBy=firstDataset.pivotAggregation || [];
    }
    
    console.log(this.aggregateBy)
    if (this.aggregateBy.length > 0) {
      this.showAggregate = true;

    }
    if(this.pivotAggregateBy.length > 0){
      this.showPivotAggregate=true
    }
    this.subLevelAggregateBy = [];
    // Temporary array to hold items to keep
    const remainingAggregateBy = [];
    for (let a = 0; a < this.aggregateBy.length; a++) {
      if (this.aggregateBy[a].groupByNeeded === true) {
        this.subLevelAggregateBy.push(this.aggregateBy[a]);
      } else {
        remainingAggregateBy.push(this.aggregateBy[a]);
      }
    }
    this.aggregateBy = remainingAggregateBy;
    console.log(this.subLevelAggregateBy);
    console.log(this.aggregateBy)
    if (this.subLevelAggregateBy.length > 0) {
      this.showSubLevelAggregate = true;

    }
    console.log(columnstemp)

    for (let columnstempindex = 0; columnstempindex < columnstemp.length; columnstempindex++) {
      columnstemp[columnstempindex].attributeNameWithFields = columnstemp[columnstempindex].alias;
      this.selectedFieldsData.push(columnstemp[columnstempindex]);
    }

    for (let rollingUptempindex = 0; rollingUptempindex < rollingUptemp.length; rollingUptempindex++) {
      const rollingupData = rollingUptemp[rollingUptempindex];
      this.rollingUp.push(rollingupData);
      this.showRollingUp = true;
    }
    console.log(concatinationtemp)
    for (let concatinationtempindex = 0; concatinationtempindex < concatinationtemp.length; concatinationtempindex++) {
      let concat = {
        "objectId": "",
        "object": "",
        "attributeNameWithFields": "",
        "name": "",
        "label": "",
        "type": ""
      };
      for (let concatinationtempchildindex = 0; concatinationtempchildindex < concatinationtemp[concatinationtempindex].columns.length; concatinationtempchildindex++) {
        if (concat.name === "") {
          concat.name = concatinationtemp[concatinationtempindex].columns[concatinationtempchildindex]
        } else {
          concat.name = concat.name + "/" + concatinationtemp[concatinationtempindex].columns[concatinationtempchildindex];
        }
      }
      concat.label = concatinationtemp[concatinationtempindex].label;
      concat.type = concatinationtemp[concatinationtempindex].type;
      concat.object = concatinationtemp[concatinationtempindex].object
      concat.attributeNameWithFields = concatinationtemp[concatinationtempindex].alias;
      this.groupconcattemp.push(concat)
    }

    for (let tranformationIndex = 0; tranformationIndex < transformationTemp.length; tranformationIndex++) {
      const tranformationObject = transformationTemp[tranformationIndex];
      console.log(tranformationObject);
      this.showTransform = true;
      this.transformation.push(tranformationObject);
    }
    console.log(this.transformation)

    this.concatination = concatinationtemp;
    console.log(this.concatination)
    this.groupconcattemp.forEach(concat => {
      this.temp.push(concat);
    })
    console.log(this.temp)

    for (let filterIndex = 0; filterIndex < filters.length; filterIndex++) {
      const filter = filters[filterIndex];
      this.showFilter = true;
      this.where.push(filter);
    }

    for (let sortingIndex = 0; sortingIndex < sorting.length; sortingIndex++) {
      const sort = sorting[sortingIndex];
      this.showOrderBy = true;
      this.orderBy.push(sort);
    }
    //let modifiedHeaders = groupHeadersByType(headersTypeArr);

    for (let headerIndex = 0; headerIndex < headersTypeArr.length; headerIndex++) {
      const sort = headersTypeArr[headerIndex];
      this.showHeaderType = true;
      this.headersTypeArr.push(sort);
    }
    if (this.headersTypeArr.length <= 0) {
      this.showHeaderType = false;
    }


    this.rollupExclusionObjects = [];
    for (let exclusionIndex = 0; exclusionIndex < rollupExclusionObjects.length; exclusionIndex++) {
      const element = rollupExclusionObjects[exclusionIndex];
      this.rollupExclusionObjects.push(element.exclusionObject);
    }
    console.log(columnFilterTemp);
    // this.rootGroup=columnFilterTemp;
    console.log(this.rootGroup);
    console.log(this.selectedFieldsData)
    console.log(this.columns)
    // for (let columnFilterIndex = 0; columnFilterIndex < columnFilterTemp.length; columnFilterIndex++) {
    //   const element = columnFilterTemp[columnFilterIndex];
    //   this.columnFilter.push(element);
    //   this.showColumnFilter = true;
    // }
    this.rollupExclusionObjectSelection();
    this.spinner.stop();
    console.log(this.selectedFieldsData)
    console.log(this.temp)
    this.pushDataToSelectedFieldsGrid("update");

    // this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)


    
    this.getObjectsData(this.dnsid);
    if(firstDataset.columnFilters.length > 0){
      columnFilterTemp = firstDataset.columnFilters[0];
       this.rootGroup=columnFilterTemp
       this.enrichUiFieldsForEdit(this.rootGroup);
    }
    console.log(this.columns)
    if(updatedata.rowData.objectgroupid){
      this.reportCreationData.objectGroupId=updatedata.rowData.objectgroupid;
      let event={
        value:this.reportCreationData.objectGroupId
      }
      // this.reportCreationData.objectGroupName=updatedata.rowData.objectGroupName;
      this.onObjectGroupChange(event); 
    }else{
      this.reportCreationData.objectGroupName=""
      this.reportCreationData.objectGroupId=""
       this.ObjectGrid.api.setGridOption('rowData', []);
    }
  }
  
  getObjectsData(vaultgroup) {
    
    if (this.objectGroup) {
      this.service.retrieveObjectGroupObject(vaultgroup).subscribe((res) => {
        console.log(res);
        this.spinner.start();
        // checking if response is true or not
        if (res.error === true) {
          this.snackbar.open(res.message, "OK", { duration: 5000 });
        } else {
          this.ObjectsData = res;
          this.pushDataToSelectedFieldsGrid("update");
        }
        this.spinner.stop();
      });
    } else if (this.datasetGroup) {
      this.service.retrieveDatasetObjects(vaultgroup).subscribe(res => {
        console.log(res)
        // checking if response is true or not
        if (res.error === true) {
          this.spinner.stop();

          this.snackbar.open(res.message, "OK", { duration: 5000 });

          this.ObjectGrid.api.setGridOption('rowData', []);
        } else {


          this.ObjectsData = res;
          console.log(res)

          let response = JSON.parse(JSON.stringify(res));

          const keys = Object.keys(res);
          const objects = keys.map(key => ({ objectlabel: key, value: JSON.parse(response[key][0]) }));
          objects.sort((a, b) => a.objectlabel.localeCompare(b.objectlabel));
          console.log(objects)
          //this.ObjectsData = objects;   
          this.tempObjectsData = objects;
          console.log(this.ObjectsData)
          console.log(this.tempObjectsData)
          this.pushDataToSelectedFieldsGrid("update");
          // this.ObjectGrid.api.setGridOption('rowData', objects);
          // this.paramstemp.api.setGridOption('rowData', []);
          this.spinner.stop();
        }
      })

    }
  }

  deleteRollingUp(k) {
    console.log(k)
    this.rollingUp.splice(k, 1);
    if (this.rollingUp.length == 0) {
      this.showRollingUp = false;
    }
    console.log(this.rollingUp)
  }

  deleteColumnFilter(k) {
    console.log(k)
    this.columnFilter.splice(k, 1);
    if (this.columnFilter.length == 0) {
      this.showColumnFilter = false;
    }
  }

  deleteWhere(k) {
    console.log(k)
    this.where.splice(k, 1);
    if (this.where.length == 0) {
      this.showFilter = false;
    }
  }
  deleteOrder(k) {
    console.log(k)
    this.orderBy.splice(k, 1);
    if (this.orderBy.length == 0) {
      this.showOrderBy = false;
    }
  }
  deleteHeader(k) {
    console.log(k)
    this.headersTypeArr.splice(k, 1);
    if (this.headersTypeArr.length == 0) {
      this.showHeaderType = false;
    }
  }
  deleteAggregate(k) {
    console.log(k)
    this.aggregateBy.splice(k, 1);
    if (this.aggregateBy.length == 0) {
      this.showAggregate = false;
      this.subLevelAggregateBy = [];
      this.subAggregateLevelData = { "groupByColumn": "", "groupByNeeded": true, "alias": "" };
    }
  }
  deletePivotAggregate(k){
    this.pivotAggregateBy.splice(k,1);
    if(this.pivotAggregateBy.length == 0){
      this.showPivotAggregate=false
    }
  }
  deleteSubLevelAggregate(k) {
    console.log(k)
    this.subLevelAggregateBy.splice(k, 1);
    if (this.subLevelAggregateBy.length == 0) {
      this.showSubLevelAggregate = false;
    }
    for (let a = 0; a < this.aggregateBy.length; a++) {
      if (this.aggregateBy[a].groupByNeeded == true) {
        this.aggregateBy.splice(a, 1);
      }
    }
  }

  deleteTransformation(k) {
    this.transformation.splice(k, 1);
    if (this.transformation.length === 0) {
      this.showTransform = false;
    }
  }

  ClearData() {
    this.transformation = []
    this.concatination = []
    this.groupconcattemp = []
    this.columns = []
    this.selectedFieldsDataToPush.length = 0
    this.temp.length = 0
    this.dataSetObject.objectid = ""
    this.dataSetObject.datasetname = ""
    this.editMyDataSet = ""
    this.dataSetObject.accesstype = "public"
    this.ObjectGrid.api.setGridOption('rowData', []);
    this.temp = [];
    this.rollingUp = [];
    this.fieldsDataToRemove = [];
    this.selectedObjectsData = []
    this.selectedFieldsDatatemp = [];
    this.selectedFieldsDataToPush = [];
    this.selectedFieldsData = [];
    console.log(this.show)
    this.paramstemp.api.setGridOption('rowData', []);
    this.tablefields = [];
    this.selectedTableFields.api.setGridOption('rowData', []);
    this.columnDefsForReportingConfiguration = [];
    this.reportCreationData = {
      datasetname: "",
      datasetObjectname: "",
      datasetobjectattributes: [],
      type: "",
      description: "",
      objectGroup: "",
      filters: [],
      sorting: [],
      aggregate: [],
      columns: [],
      concatination: [],
      rollingUp: [],
      rollupExclusionObjects: [],
      transformation: [],
      columnFilters: [],
      columnFiltersExpression:"",
      generateDefaultTemplate: "",
      autoRefreshDataset: "",
      dataset_rolesIds: "",
      datasetAccessType: "",
      createdBy: "",
      createdDateAndTime: "",
      headersType: [],
      pivotAggregation:[],
      selectedObjectsMap :{},
      transformationQuery:"",
      flatteningOption:"",
      orderId:"",
      reference_source:"",
      reference_target:"",
      reference_library:"",
      reference_global_object:"",
      reference_global_source_library:"",
      reference_vault_object:"",
      global_external_object:"",
      objectGroupName:"",
      objectGroupId:"",
      reference_Database_Object_Name:"",
      reference_Database_Object_Fetch_Partial:""

    }
    this.where = [];

    this.groupBy = [];

    this.orderBy = [];

    this.fieldsData = [];

    this.aggregateBy = [];
    this.pivotAggregateBy=[]
    this.aggregateArray = [];
    this.orderByShow = false;
    this.aggreageShow = false;
    this.dateChange = false;
    this.expand = false;
    this.formValidationsWhere();
    // this.butttonname = "Save";
    this.formValidation();

    this.formulaFieldsValidation();
    this.datasetFormValidation();
    this.finalReportCreation = {
      "datasets": [
        {
          "name": "",
          "datasetType": "",
          "columns": []
        }
      ],
      "reports": []
    }
    this.butttonname = "Create Stage Object"

  }

  selectedObjectsData = []
  selectedObjects(value) {
    this.selectedObjectsData = value
  }

  allFieldsDatatemp: any
  allFieldsDataToPush:any
  typeOfOperation:any
  //forward Icon Function decleation
  pushDataToSelectedFieldsGrid(type) {
    this.typeOfOperation =type
    console.log(this.tempObjectsData)
    if (this.datasetGroup) {
      this.ObjectsData = this.tempObjectsData
    }
    console.log(this.ObjectsData)
    console.log(type)
    this.fieldsDataToRemove = [];
    this.allFieldsDataToPush = [];  
    this.selectedFieldsDatatemp.length = 0;
    this.selectedFieldsDataToPush.length = 0;
    this.selectedFieldsDatatemp = this.selectedFieldsData;
    this.allFieldsDatatemp = this.allFieldsData; 
     
    let uniq = {}
    console.log(this.selectedFieldsData);
    console.log(this.selectedFieldsDatatemp);
    console.log("All Fields Data:", this.allFieldsData);
    // this.processFieldsData(this.allFieldsDatatemp, type, this.allFieldsDataToPush);
    for (let i = 0; i < this.selectedFieldsDatatemp.length; i++) {
      var addColumn = true;
      var objectData =
      {
        "name": "",
        "object": "",
      }
      this.addedColumnsTemp =
      {
        "name": "",
        "alias": "",
        "object": "",
        "type": "",
        "label": "",
        "reporting": "",
        "objectLabel": ""
      }
      var alias;
      if (type === "insert") {
        console.log(this.selectedFieldsDatatemp)
        console.log(this.selectedFieldsDatatemp[i].object)
        console.log(this.selectedObject)
        this.addedColumnsTemp.objectLabel = this.selectedObject
        console.log(this.addedColumnsTemp.objectLabel)
        this.selectedFieldsDatatemp[i].object = this.selectedObject;
        if (this.selectedFieldsDatatemp[i].type == "__constant") {
          this.selectedFieldsDatatemp[i].attributeNameWithFields = this.selectedFieldsDatatemp[i].label;
          this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].attributeNameWithFields;
        } else {
          this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].name;
          this.selectedFieldsDatatemp[i].attributeNameWithFields = this.selectedObject + " " + this.selectedFieldsDatatemp[i].label;
        }
        alias = this.selectedFieldsDatatemp[i].attributeNameWithFields;
      } else {
        console.log(this.selectedFieldsDatatemp[i].object);
        if (this.selectedFieldsDatatemp[i].type == "__constant") {
          console.log(this.selectedFieldsDatatemp[i].alias);
           const alias = this.selectedFieldsDatatemp[i].alias;
          const separatorIndex = alias.indexOf("Seperator");
          this.selectedFieldsDatatemp[i].attributeNameWithFields =
          separatorIndex !== -1 ? alias.substring(0, separatorIndex) : alias;
          this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].attributeNameWithFields;
          console.log(this.selectedFieldsDatatemp[i].alias);
        } else {
          this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].name;
          this.selectedFieldsDatatemp[i].attributeNameWithFields = this.selectedFieldsDatatemp[i].alias;
        }
        alias = this.selectedFieldsDatatemp[i].alias;
      }
      if (alias.includes(".")) {
        alias = alias.replace(".", "_");
      }
      var label = this.selectedFieldsDatatemp[i].label;
      if (label.includes(".")) {
        label = label.replace(".", "_");
      }
      let objectName = "";
      let objectAlias = this.selectedFieldsDatatemp[i].object;
      this.selectedFieldsDataToPush.push(this.selectedFieldsDatatemp[i]);
      this.addedColumnsTemp.alias = alias;
      if (type === "insert") {
        console.log(this.ObjectsData)
        if (this.datasetGroup) {
          console.log(this.objectAttributes)
          this.ObjectsData = this.objectAttributes
        }
        console.log(this.ObjectsData)
        this.ObjectsData.forEach(object => {

          if (this.datasetGroup) {
            if (object.objectLabel === objectAlias) {
              objectName = object.name;
            }
          } else {
            if (object.objectlabel === objectAlias) {
              objectName = object.objectname;
            }
          }
        })
        console.log(objectName);
        console.log(this.selectedObjectName)
        this.addedColumnsTemp.object = objectName;
        if (this.datasetGroup) {
          this.addedColumnsTemp.object = this.selectedObjectName;
        }
      } else {

        this.ObjectsData.forEach(object => {

          // if(this.datasetGroup){
          //   if (object.objectLabel === objectAlias) {
          //     console.log(object, objectAlias);
          //     objectName = object.name;
          //   }
          // }else {
          if (object.objectname === objectAlias) {
            objectName = object.objectlabel;
          }
          if (this.datasetGroup) {
            objectName = object.objectlabel;
            console.log(objectName)
          }
          // }
        })
        console.log(objectName);
        this.addedColumnsTemp.object = objectAlias;
        this.addedColumnsTemp.objectLabel = objectName;
      }
      this.addedColumnsTemp.type = this.selectedFieldsDatatemp[i].type
      this.addedColumnsTemp.label = label
      this.addedColumnsTemp.reporting = "Y"
      console.log(this.addedColumnsTemp);

      this.columns.forEach((eachcolumn) => {
        if (eachcolumn.alias === this.addedColumnsTemp.alias) {
          console.log(eachcolumn.alias);
          eachcolumn.reporting = "Y";
          addColumn = false;
        }
      })
      if (addColumn) {
        this.columns.push(this.addedColumnsTemp)
      }
      if (this.filterObjects.length == 0) {
        var addvalue = true;
      } else {
        var addvalue = true;
        this.filterObjects.forEach((filterobject) => {
          console.log(filterobject.object, this.addedColumnsTemp.object, objectName);
          if (filterobject.object === this.addedColumnsTemp.object || filterobject.object === objectName) {
            addvalue = false;
          }
        })
      }

      if (addvalue && this.addedColumnsTemp.object != 'constants') {
        if (type === "insert") {
          objectData.name = objectAlias;
          objectData.object = this.addedColumnsTemp.object;
        } else {
          objectData.name = objectName;
          objectData.object = this.addedColumnsTemp.object;
        }
        this.filterObjects.push(objectData)
        console.log(this.filterObjects)
      }
      console.log(this.filterObjects);
      console.log(this.columns)
    }
    console.log(this.columns)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp.push(...this.selectedFieldsDataToPush)
    this.temp = this.temp.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)
     const labelOrder = this.temp.map((t) => t.attributeNameWithFields);
     console.log(labelOrder)
     this.columns = this.columns.sort(
    (a, b) => labelOrder.indexOf(a.alias) - labelOrder.indexOf(b.alias)
  );
  console.log(this.columns)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedObjectsData = this.temp.filter(obj => !uniq[obj.object] && (uniq[obj.object] = true));
    console.log(this.selectedObjectsData)
    this.selectedObjects(this.selectedObjectsData)
    this.paramstemp.api.deselectAll();
    if (this.datasetGroup) {
      this.ObjectsData = this.tempObjectsData
    }
  }

  /**
 * Helper function to process fields data for selectedFieldsData and allFieldsData
 */
  columnses : any = [];
// 

  // //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    console.log( this.selectedObjectName);
    //this.fieldsDataToRemove=[];
    let uniq = {}
    console.log(this.tablefields);
    for (let i = 0; i < this.tablefields.length; i++) {
      var addColumn = true;
      this.addedColumnsTemp =
      {
        "name": "",
        "alias": "",
        "object": "",
        "type": "",
        "label": "",
        "reporting": "",
        "objectLabel": ""
      }
    
      var alias = this.replaceCharecter(this.selectedObject + " " + this.tablefields[i].label, this.constants.charecterDot, this.constants.charecterUnderScore);
      console.log(alias)
      var label = this.replaceCharecter(this.tablefields[i].label, this.constants.charecterDot, this.constants.charecterUnderScore);
      console.log(label)
      if (this.tablefields[i].type == "__constant") {
        // console.log(this.tableFields[i].label)
        this.tablefields[i].attributeNameWithFields =label;  
        alias = label
      } else {
        this.tablefields[i].attributeNameWithFields = alias;
      }
      this.addedColumnsTemp.name = this.tablefields[i].name
      this.addedColumnsTemp.alias = alias;
      this.addedColumnsTemp.object = this.selectedObjectName
      this.addedColumnsTemp.type = this.tablefields[i].type
      this.addedColumnsTemp.label = label
      this.addedColumnsTemp.reporting = "Y"
      this.tablefields[i].object = this.selectedObject;
      this.tablefields[i].alias = alias;
      this.tablefields[i].label = label
      this.addedColumnsTemp.objectLabel = this.tablefields[i].object
      this.columns.forEach((eachcolumn) => {
        if (eachcolumn.alias === this.addedColumnsTemp.alias) {
          console.log(eachcolumn.alias);
          eachcolumn.reporting = "Y";
          addColumn = false;
        }
      })
      if (addColumn) {
        this.columns.push(this.addedColumnsTemp)
      }
      
      this.selectedFieldsDataToPush.push(this.tablefields[i]);
    }
    console.log(this.columns)
    console.log(this.selectedFieldsDataToPush)
    var objectData = {
      "name": this.selectedObject,
      "object": this.selectedObjectName
    }
    console.log(objectData);
    let addFilterObject = true;
    console.log(this.filterObjects)
    this.filterObjects.forEach(object => {
      if (object.name === objectData.name && object.object === objectData.object) {
        addFilterObject = false;
      }
    })
    if (addFilterObject) {
      this.filterObjects.push(objectData);
    }
    console.log(this.addedColumnsTemp)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp.push(...this.selectedFieldsDataToPush)
    this.temp = this.temp.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)  
     const labelOrder = this.temp.map((t) => t.attributeNameWithFields);
     console.log(labelOrder)
     this.columns = this.columns.sort(
    (a, b) => labelOrder.indexOf(a.alias) - labelOrder.indexOf(b.alias)
  );
  console.log(this.columns)
 
  console.log(this.columns)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    //this.pushDataToSelectedFieldsGrid();
    this.selectedObjectsData = this.temp.filter(obj => !uniq[obj.object] && (uniq[obj.object] = true));
    this.selectedObjects(this.selectedObjectsData)
    this.paramstemp.api.deselectAll();
  }


  // //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedFieldsDataToPush.length = 0
    this.temp.length = 0
    this.addedColumnsTemp =
    {
      "name": "",
      "alias": "",
      "object": "",
      "type": "",
      "label": ""
    }
    this.filterData = [];
    this.filterObjects = [];
    console.log(this.addedColumnsTemp)
    this.columns = [];
    this.concatination = [];
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, [])
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
    this.selectedFieldsData = []
    this.selectedObjectsData = [];
    this.selectedObjects(this.selectedObjectsData)
  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    this.addedColumnsTemp = [];
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    console.log(this.temp)
    let columntemp = [];
    let concattemp = [];
    // this.columns.forEach(eachtemp => {
    //   this.fieldsDataToRemove.forEach(eachfield => {
    //     if (eachtemp.alias === eachfield.attributeNameWithFields || eachtemp.alias == (eachfield.attributeNameWithFields + 'Seperator') || (eachtemp.type == "__constant" && eachfield.type=="__constant")) {
    //       console.log(eachtemp)
    //       columntemp.push(this.columns.indexOf(eachtemp))
    //     }
    //   })
    // });
     this.columns.forEach((col, colIndex) => {
        this.fieldsDataToRemove.forEach(field => {
          let isMatch = false;
      if (field.type === "__constant" && col.type === "__constant") {
        console.log("Inside of constant removal")
        isMatch =(col.alias === field.attributeNameWithFields + "Seperator" ||  col.alias === field.attributeNameWithFields) &&col.object === field.object;
      } else {
        console.log(col.alias ===field.attributeNameWithFields )
        isMatch = col.alias === field.attributeNameWithFields ;
        console.log(isMatch)
      }

      if (isMatch && !columntemp.includes(colIndex)) {
        console.log(colIndex)
        columntemp.push(colIndex);
      }
      });
     });
    this.concatination.forEach(eachtemp => {
      this.fieldsDataToRemove.forEach(eachfield => {
        if (eachtemp.alias === eachfield.attributeNameWithFields) {
          console.log(eachtemp)
          concattemp.push(this.concatination.indexOf(eachtemp))
        }
      })
    });
    
    this.columns = this.columns.filter(eachtemp => !columntemp.includes(this.columns.indexOf(eachtemp)));
    this.concatination = this.concatination.filter(eachtemp => !concattemp.includes(this.concatination.indexOf(eachtemp)))
    console.log(this.temp)
    console.log(this.addedColumnsTemp)
    console.log(this.columns)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedFieldsDataToPush = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    this.selectedFieldsData = [];
    this.fieldsDataToRemove = [];
    let uniq = {}
    this.selectedObjectsData = this.temp.filter(obj => !uniq[obj.object] && (uniq[obj.object] = true));
    this.selectedObjects(this.selectedObjectsData)
  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    console.log(ev.rowIndex);
    if (ev.node.isSelected() === true) {
      var newKey = "rowIndex";
      var newValue = ev.rowIndex;
      ev.api.getColumn('attributeNameWithFields').editable = true;
      ev.api.getColumn('attributeNameWithFields').rowDrag = true;
      ev.node.data[newKey] = newValue
      this.fieldsDataToRemove.push(ev.node.data)
    } else {
      this.fieldsDataToRemove.forEach(eachunselecteddata => {
        if (eachunselecteddata.rowIndex === ev.rowIndex) {
          let index = this.fieldsDataToRemove.indexOf(eachunselecteddata)
          this.fieldsDataToRemove.splice(index, 1)
        }
      })
    }
    console.log(this.fieldsDataToRemove);
    this.fieldsDataToRemove.forEach(eachconcat => {
      this.concatination.forEach(eachalias => {
        if (eachalias.label === eachconcat.label) {
          eachalias.alias = eachconcat.attributeNameWithFields
          console.log(eachalias.alias)
          console.log(eachconcat.attributeNameWithFields)
        }
      })
    })
    console.log(this.concatination)
  }

  previousAlias: any;

  onCellEditingStarted(event) {
    this.previousAlias = this.replaceCharecter(event.data.attributeNameWithFields, ".", "_");
    console.log(event.data.attributeNameWithFields);
  }


  onCellValueChanged(e) {
    console.log(e)
    this.selectedTableFields.api.deselectAll();
    this.changealisaname(e)
  }
  changealias = []
  changealisaname(e) {
    console.log(this.columns)
    this.changealias = []
    this.changealias.push(e.data)
    for (let changealiasIndex = 0; changealiasIndex < this.changealias.length; changealiasIndex++) {
      let duplicateObjectData: any;
      const eachalias = this.changealias[changealiasIndex];
      var duplicate = false;
      for (let concatIndex = 0; concatIndex < this.concatination.length; concatIndex++) {
        const eachconcat = this.concatination[concatIndex];
        console.log(eachconcat);
        if (eachconcat.alias === eachalias.attributeNameWithFields) {
          duplicate = true;
          duplicateObjectData = eachalias.attributeNameWithFields;
        }
      }
      for (let columnIndex = 0; columnIndex < this.columns.length; columnIndex++) {
        const eachcolumn = this.columns[columnIndex];
        if (eachcolumn.type != "__constant") {
          if (eachcolumn.alias === eachalias.attributeNameWithFields) {
            duplicate = true;
            duplicateObjectData = eachalias.attributeNameWithFields;
          }
        } else {
          if (eachcolumn.alias.substring(0, eachcolumn.alias.indexOf("Seperator")) === eachalias.attributeNameWithFields) {
            duplicate = true;
            duplicateObjectData = eachcolumn.alias.substring(0, eachcolumn.alias.indexOf("Seperator"));
          }
        }
      }
      for (let rollupIndex = 0; rollupIndex < this.rollingUp.length; rollupIndex++) {
        const rollup = this.rollingUp[rollupIndex];
        if (rollup.rollupColumnAlias === eachalias.attributeNameWithFields) {
          duplicate = true;
          duplicateObjectData = eachalias.attributeNameWithFields;
          break;
        }
      }
      for (let aggregateByIndex = 0; aggregateByIndex < this.aggregateBy.length; aggregateByIndex++) {
        console.log(this.aggregateBy[aggregateByIndex])
        const agree = this.aggregateBy[aggregateByIndex];
        console.log(agree.columnAlias + "==-=================" + eachalias.attributeNameWithFields)
        if (agree.alias === eachalias.attributeNameWithFields) {
          duplicate = true;
          duplicateObjectData = eachalias.attributeNameWithFields;
          break;
        }
      }
      console.log(duplicate);
      if (!duplicate) {
        let objecName = "";
        this.ObjectsData.forEach(object => {
          if (eachalias.object === object.objectlabel || eachalias.object === object.objectname) {
            objecName = object.objectname;
          }
        })
        console.log(objecName);
        for (let concatIndex = 0; concatIndex < this.concatination.length; concatIndex++) {
          const eachconcat = this.concatination[concatIndex];
          if (eachalias.label === eachconcat.label) {
            this.concatination[concatIndex].alias = eachalias.attributeNameWithFields
            console.log(eachconcat.alias)
            console.log(eachalias.attributeNameWithFields)
            break;
          }
        }
        for (let columnIndex = 0; columnIndex < this.columns.length; columnIndex++) {
          const eachcolumn = this.columns[columnIndex];
          let label = this.replaceCharecter(eachalias.label, ".", "_");
          console.log(label, eachcolumn.label, eachcolumn.object, objecName);
          if (eachcolumn.type === "__constant") {
            if (eachcolumn.alias.includes("Seperator")) {
              if (eachcolumn.alias.substring(0, eachcolumn.alias.indexOf("Seperator")) === this.previousAlias) {
                this.columns[columnIndex].alias = eachalias.attributeNameWithFields + "Seperator";
              }
            } else{
              // this.columns[columnIndex].alias = eachalias.attributeNameWithFields + "Seperator";
               if (eachcolumn.name === e.data.name && eachcolumn.label === e.data.label) {
                 eachcolumn.alias = e.data.attributeNameWithFields + "Seperator";
                }
            }
          } else {
            if (eachcolumn.alias === this.previousAlias) {
              this.columns[columnIndex].alias = eachalias.attributeNameWithFields;
              console.log(eachcolumn.alias);
              console.log(eachalias.attributeNameWithFields);
            }
          }
        }
      } else {
        let oldAliasName = [];
        let tempIndex = e.rowIndex;
        console.log(this.temp[tempIndex]);
        const object = this.temp[tempIndex];
        let updateColumnData: any;
        if (object.attributeNameWithFields === duplicateObjectData) {
          console.log(this.butttonname);
          let objectName = this.temp[tempIndex].object;
          if (this.temp[tempIndex].type != "__constant") {
            this.ObjectsData.forEach(objectData => {
              if (objectData.objectname === objectName) {
                objectName = objectData.object;
              }
            })
            this.temp[tempIndex].attributeNameWithFields = objectName + " " + this.temp[tempIndex].label
            oldAliasName.push(objectName + " " + this.temp[tempIndex].label);
          } else {
            this.temp[tempIndex].attributeNameWithFields = this.temp[tempIndex].label;
            oldAliasName.push(this.temp[tempIndex].label);
          }
          updateColumnData = this.temp[tempIndex];
        }
        this.columns.forEach(column => {
          console.log(column);
          let objectName = "";
          if (column.alias === this.previousAlias) {
            if (column.type != "__constant") {
              this.ObjectsData.forEach(objectData => {
                if (objectData.objectname === column.object) {
                  objectName = objectData.object;
                }
              })
              column.alias = objectName + " " + column.label;
            } else {
              column.alias = column.label;
            }
          }
        })
        this.concatination.forEach(column => {
          let objectName = "";
          if (column.alias === duplicateObjectData) {
            if (this.butttonname === "Update Stage Object") {
              this.ObjectsData.forEach(objectData => {
                if (objectData.objectname === column.object) {
                  objectName = objectData.object;
                }
              })
            }
            column.alias = objectName + " " + column.label;
            oldAliasName.push(column.alias);
          }
        })
        this.snackbar.open("Please enter Unique name for " + oldAliasName + " Attribute ", "OK", {
          duration: 10000,
        });
      }

      console.log(this.temp);
      this.selectedObjects(this.temp);
      this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp);
      if (this.selectedObject != undefined) {
        this.cellClickedObjectsforValueChange(this.selectedObject)
      }
    }
    console.log(this.temp)
    console.log(this.concatination)
  }

  cellClickedObjectsforValueChange(e) {

    console.log(e);
    console.log(this.selectObjectId);


    this.service.retrieveTablesFieldsForDataset(this.selectObjectId).subscribe(res => {

      this.spinner.start();

      console.log(res);

      // checking if response is true or not
      if (res.error === true) {

        this.spinner.stop();

        this.snackbar.open(res.message, "OK", { duration: 5000 });

        this.allFields = [];

        this.selectedFieldsData = [];

        this.gridApiForTablesFields.setGridOption('rowData', []);

      } else {

        this.spinner.stop();

        this.allFields = res[0];

        console.log(this.selectedObject)

        this.onGridReadyForTablesFields(this.paramstemp, this.allFields, e)

        this.columnDefsForReportingConfiguration = [];

      }

    });

  }

  groupconcattemp = []
  groupConcat() {
    
    let concat = {
      "objectId": "",
      "object": "",
      "attributeNameWithFields": "",
      "name": "",
      "label": "",
      "type": ""
    };

    this.columnname = {
      "columns": [],
      "label": "",
      "alias": "",
      "object": "",
      "type": "",
      "objectId": "",
      "reporting": ""
    }
    this.groupconcattemp = []
    console.log(this.fieldsDataToRemove)
    for (let i = 0; i < this.fieldsDataToRemove.length; i++) {
      if (concat.attributeNameWithFields === "") {
        let attributeElement = this.replaceCharecter(this.fieldsDataToRemove[i].attributeNameWithFields,
          this.constants.charecterDot, this.constants.charecterUnderScore);
        concat.attributeNameWithFields = attributeElement
        concat.label = this.fieldsDataToRemove[i].label;
        this.columnname.label = this.fieldsDataToRemove[i].label;
        if (this.fieldsDataToRemove[i].type === "__constant") {
          console.log("true");
          this.columnname.columns.push(this.fieldsDataToRemove[i].alias);
          concat.name = this.fieldsDataToRemove[i].attributeNameWithFields + "Seperator";
        } else {
          concat.name = this.fieldsDataToRemove[i].attributeNameWithFields;
          this.columnname.columns.push(concat.attributeNameWithFields)
        }

        this.columnname.alias = concat.attributeNameWithFields
        this.columnname.type = this.fieldsDataToRemove[i].type;
      } else {
       
        let attributeElement = this.replaceCharecter(this.fieldsDataToRemove[i].attributeNameWithFields,
          this.constants.charecterDot, this.constants.charecterUnderScore);
        concat.attributeNameWithFields = concat.attributeNameWithFields + attributeElement
        concat.label = concat.label + "," + this.fieldsDataToRemove[i].label;
        this.columnname.label = this.columnname.label + "," + this.fieldsDataToRemove[i].label;
        if (this.fieldsDataToRemove[i].type === "__constant") {
          this.columnname.columns.push(this.fieldsDataToRemove[i].attributeNameWithFields + "Seperator")
        } else {
          concat.name = concat.name + "," + this.fieldsDataToRemove[i].attributeNameWithFields;
          this.columnname.columns.push(this.fieldsDataToRemove[i].attributeNameWithFields)
        }
        this.columnname.alias = concat.attributeNameWithFields;
        this.columnname.type = this.columnname.type + "," + this.fieldsDataToRemove[i].type;
      }
    }
    let objectName__v = "";
    if (this.butttonname === "Update Stage Object") {
      objectName__v = this.fieldsDataToRemove[0].object;
    } else {
      this.ObjectsData.forEach(object => {
        if (object.object === this.fieldsDataToRemove[0].object) {
          objectName__v = object.objectname;
        }
      })
    }
    console.log(this.fieldsDataToRemove[0]);
    console.log(objectName__v, this.fieldsDataToRemove[0].object);
    this.columnname.objectId = this.fieldsDataToRemove[0].objectId;
    this.columnname.object = objectName__v;
    this.columnname.reporting = "Y";
    concat.objectId = this.fieldsDataToRemove[0].objectId;
    concat.object = objectName__v;
    concat.type = this.fieldsDataToRemove[0].type;
    console.log(concat)
    let addConcat = true;
    this.concatination.forEach(eachConcat => {
      if (eachConcat.alias === this.columnname.alias) {
        addConcat = false;
      }
    })
    if (addConcat) {
      this.groupconcattemp.push(concat)
      console.log(this.groupconcattemp)
      this.concatination.push(this.columnname);
      console.log(this.concatination)
      this.temp.push(...this.groupconcattemp)
    } else {
      this.snackbar.open("Selected Concatination is already present", "OK", { "duration": 5000 });
    }
    this.selectedObjects(this.temp);
    console.log(this.temp)
    console.log(this.columns)
    console.log(this.concatination)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    this.fieldsDataToRemove = []
    this.groupconcattemp = []
  }

  replaceCharecter(field: any, charecterToReplace, chrecterToReplcaeWith) {
    if (field === undefined || field === "") {
      return "";
    }
    if (field.includes(charecterToReplace)) {
      field = field.replace(charecterToReplace, chrecterToReplcaeWith);
    }
    return field;
  }

  unGroupConcat() {
    this.finalunconcatination = [];
    console.log(this.fieldsDataToRemove)
    this.fieldsDataToRemove.forEach(eachconcat => {
      this.concatination.forEach(eachspliceconcat => {
        if (eachspliceconcat.label = eachconcat.label) {
          this.concatination.splice(this.concatination.indexOf(eachspliceconcat), 1)
        }
      })
    })
    this.temp.forEach(eachtemp => {
      this.fieldsDataToRemove.forEach(eachfield => {
        if (eachtemp.attributeNameWithFields === eachfield.attributeNameWithFields) {
          console.log(eachtemp)
          let index = this.temp.indexOf(eachtemp)
          this.temp.splice(index, 1);
        }
      })
    })
    console.log(this.temp)
    this.pushDataToUnconcatinateToGrid(this.finalunconcatination)
  }

  pushDataToUnconcatinateToGrid(selectedFieldsData) {
    this.fieldsDataToRemove = [];
    this.selectedObjectsData = []
    this.selectedFieldsDatatemp = [];
    this.selectedFieldsDataToPush = [];
    this.selectedFieldsDatatemp = selectedFieldsData;
    let uniq = {}
    console.log(this.selectedFieldsDatatemp);
    for (let i = 0; i < this.selectedFieldsDatatemp.length; i++) {
      this.addedColumnsTemp =
      {
        "name": "",
        "alias": "",
        "object": "",
        "type": "",
        "reporting": ""
      }
      this.selectedFieldsDataToPush.push(this.selectedFieldsDatatemp[i]);
      this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].name
      this.addedColumnsTemp.alias = this.selectedFieldsDatatemp[i].attributeNameWithFields
      this.addedColumnsTemp.object = this.selectedFieldsDatatemp[i].object
      this.addedColumnsTemp.type = this.selectedFieldsDatatemp[i].type
      this.addedColumnsTemp.reporting = "Y"
      this.columns.push(this.addedColumnsTemp)
      console.log(this.columns)
    }
    console.log(this.columns)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp.push(...this.selectedFieldsDataToPush)
    //this.temp = this.temp.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)
    this.selectedFieldsData = [];
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedObjectsData = this.temp.filter(obj => !uniq[obj.object] && (uniq[obj.object] = true));
    console.log(this.selectedObjectsData)
    this.selectedObjects(this.selectedObjectsData)
    this.fieldsDataToRemove = []
  }


  onRowDragEnter(e: RowDragEnterEvent) {
    console.log('onRowDragEnter', e);
    console.log(this.temp)
    this.temp.splice(e.overIndex, 1)
    console.log(this.temp)

  }

  // onRowDragEnd(e: RowDragEndEvent) {

  //   console.log('onRowDragEnd', e);
  //   let index = e.overIndex;
  //   this.temp.splice(index, 0, e.node.data);
  //   console.log(this.temp);
  //   this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)

  // }
   onRowDragEnd(e: RowDragEndEvent) {
  console.log('onRowDragEnd', e);

  // remove dragged row first
  const movingData = e.node.data;
  this.temp = this.temp.filter(t => t.attributeNameWithFields !== movingData.attributeNameWithFields);

  // insert at new index
  let index = e.overIndex;
  this.temp.splice(index, 0, movingData);

  console.log("Reordered temp:", this.temp);

  // reorder columns to match temp

      const order = this.temp.map(t => t.attributeNameWithFields.replace(/\./g, "_"));
      this.columns = this.columns.sort((a, b) => {
      const removeSeparator = (alias: string) => alias.replace(/Seperator$/, ""); // remove "Seperator" if present
      const aliasA = removeSeparator(a.alias);
      const aliasB = removeSeparator(b.alias);

      return order.indexOf(aliasA) - order.indexOf(aliasB);
    });


    
  console.log("Reordered columns:", this.columns);

  this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp);
}

  onRowDragMove(e: RowDragMoveEvent) {
    console.log('onRowDragMove', e);
    console.log(this.temp)
  }

  onRowDragLeave(e: RowDragLeaveEvent) {
    console.log('onRowDragLeave', e);
    console.log(this.temp)
  }

  addicon() {
    this.isExpand = !this.isExpand;
  }

  changeGroupTypes(e) {
    if (e.value === "Object Group") {
      this.objectGroup = true;
      this.datasetGroup = false;
      this.spinner.start();
      this.vaultObjectService.retrieveAllObjectGroupForDataset(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {
        this.vaultGroup = res;
        console.log(res);
        this.spinner.stop();
      })
    } else if (e.value === "Dataset Group") {
      this.objectGroup = false;
      this.datasetGroup = true;
      this.vaultObjectService.retrieveDatasetGroup().subscribe(res => {
        this.datasetGroups = res;
      })
    } else {
      this.objectGroup = false;
      this.datasetGroup = false;
    }

  }

  datasetOneAttributes: any = []
  objectChildData: any = []
  changeRollingUpDatasetNameOne(e) {
    this.datasetOneAttributes = []
    this.objectChildData = []
    console.log(e.value)
    let objectAlias = "";
    console.log(this.ObjectsData)
    this.ObjectsData.forEach(object => {
      if (object.objectname === e.value || object.objectlabel === e.value) {
        if (object.object != undefined) {
          objectAlias = object.object;
        } else if (object.objectlabel != undefined) {
          objectAlias = object.objectlabel;
        }
      }
    })
    console.log(objectAlias);

    this.temp.forEach(obj => {
      console.log(obj);
      if (obj.type != "__constant" && (obj.object === objectAlias || obj.object === e.value)) {
        this.datasetOneAttributes.push(obj)
      }
    })
  }

  datasetTwoAttributes = []
  changeRollingUpDatasetNameTwo(e) {
    console.log(e)
    this.datasetTwoAttributes = []
    if (e.value === this.rollingupdata.parentObjectName || this.rollingupdata.childObjectName === "" || this.rollingupdata.childObjectName === undefined) {
      this.rollingupdata.childObjectName = undefined;
      this.snackbar.open("Cannot apply rollup on same object. Please select a Child object", "OK", {
        duration: 5000
      })
      return;
    }
    this.reportCreationData.rollupExclusionObjects.forEach(object => {
      if (object.exclusionObject == e.value) {
        this.rollingupdata.childObjectName = undefined;
        this.snackbar.open("Cannot apply rollup on Exclusion objects. Please select a valid Child object", "OK", {
          duration: 5000
        })
        return;
      }
    })
    let objectAlias = "";
    this.ObjectsData.forEach(object => {
      if (object.objectname === e.value || object.objectlabel === e.value) {
        if (object.object != undefined) {
          objectAlias = object.object;
        } else if (object.objectlabel != undefined) {
          objectAlias = object.objectlabel;
        }
      }
    })
    console.log(objectAlias);
    this.temp.forEach(obj => {
      if (obj.type != "__constant" && (obj.object === objectAlias || obj.object === e.value)) {
        this.datasetTwoAttributes.push(obj)
      }
    })

  }

  filterCondition(event) {
    this.scheduleRange = false;
    if (event.value === "BETWEEN") {
      this.fieldChange = false;
      this.betweenField = true;
      if (this.dateField) {
        this.dateChange = true;
        this.dateField = false;
      } else {
        this.valueField = true;
      }
      this.multiselect = false;
    } else if (event.value === "IN") {
      if (this.dateField || this.dateChange) {
        console.log(this.dateField, ",", this.dateChange);

      } else {
        this.multiselect = true;
        this.betweenField = false;
        this.dateField = false;
        this.fieldChange = false;
      }
    } else if (event.value === "schedule range") {
      this.multiselect = false;
      this.betweenField = false;
      this.dateField = false;
      this.fieldChange = false;
      this.dateChange = false;
      this.valueField = false;
      this.scheduleRange = true;
    } else {
      this.multiselect = false;
      if (this.dateField) {
        this.fieldChange = false;
        this.dateField = true;
      } else {
        if (this.dateChange) {
          this.fieldChange = false;
          this.dateField = true;
          this.dateChange = false;
        } else {
          this.fieldChange = true;
          this.dateField = false;
        }
      }
      this.betweenField = false;
    }
  }

  attrbuteSelection(event) {
    this.betweenField = false;
    this.dateChange = false;
    this.dateField = false;
    this.multiselect = false;
    this.fieldChange = true;
    console.log(event.value);
    let objectName = "";
    this.inclusionAttributes.forEach(object => {
      if (object.label === this.whereData.fieldsWhere) {
        console.log(object);
        objectName = object.object + "_" + object.name.replace(".", "_");
      }
    })
    console.log(objectName);
    var multiselectElement = false;
    this.multiSelectKeyAttributes.forEach(value => {
      if (value === objectName) {
        multiselectElement = true;
      }
    });
    for (let objectIndex = 0; objectIndex < this.columns.length; objectIndex++) {
      const object = this.columns[objectIndex];
      if (object.alias === event.value) {
        this.dateField = (object.type == "DateTime" || object.type == "Date")
        break;
      } else {
        this.dateField = false;
      }
    }
    if (this.dateField) {
      this.valueField = false;
      this.fieldChange = false;
      this.multiselect = false;
    } else {
      this.fieldChange = true;
      this.dateField = false;
      this.dateChange = false;
    }
    this.betweenField = false;
    this.whereData.conditionalOperatorWhere = "";
    if (multiselectElement) {
      if (objectName === undefined || objectName === '' || objectName.length === 0) {
        return;
      }
      this.spinner.start();
      this.betweenField = false;
      this.dateField = false;
      this.fieldChange = false;
      this.scheduleRange = false;
      this.multiselect = true;
      let event = { value: "IN" }
      this.whereData.conditionalOperatorWhere = "IN";
      this.recordFilterCondition(event);
      this.multiSelectVaules = [];
      console.log(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, objectName);
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, objectName).subscribe(response => {
        console.log(response);
        if (response != null) {
          var sampleData = response;
          var data = sampleData[0].split(",");
          for (let elementIndex = 0; elementIndex < data.length; elementIndex++) {
            let element = data[elementIndex];
            if (element.includes("[")) {
              element = element.replace("[", "");
            }
            if (element.includes("]")) {
              element = element.replace("]", "");
            }
            if (element.includes("\"")) {
              element = element.replace("\"", "");
              element = element.replace("\"", "");
            }
            let dataTemplate = { "alias": "" };
            dataTemplate.alias = element;
            this.multiSelectVaules.push(dataTemplate);
          }
          console.log(this.multiSelectVaules);
        } else {
          this.snackbar.open("No Facet declared for selected attribute", "OK", { duration: 5000 });
        }
      });
      this.spinner.stop();
    }
  }

  recordFilterCondition(event) {
    this.recordscheduleRange = false;
    if (event.value === "BETWEEN") {
      this.recordValueField = false;
      this.recordBetweenField = true;
      if (this.recordDateField) {
        this.recordMultiDate = true;
        this.recordDateField = false;
      } else {
        this.recordMultiField = true;
      }
      this.recordMultiselect = false;
    } else if (event.value === "IN") {
      if (this.recordDateField || this.recordMultiDate) {
        console.log(this.recordDateField, ",", this.recordMultiDate);

      } else {
        this.recordMultiselect = true;
        this.recordBetweenField = false;
        this.recordDateField = false;
        this.recordValueField = false;
      }
    } else if (event.value === "schedule range") {
      this.recordValueField = false;
      this.recordBetweenField = false;
      this.recordMultiselect = false;
      this.recordDateField = false;
      this.recordMultiDate = false;
      this.recordMultiField = false;
      this.recordscheduleRange = true;
    } else {
      this.recordMultiselect = false;
      if (this.recordDateField) {
        this.recordValueField = false;
        this.recordDateField = true;
      } else {
        if (this.recordMultiDate) {
          this.recordValueField = false;
          this.recordDateField = true;
          this.recordMultiDate = false;
        } else {
          this.recordValueField = true;
          this.recordDateField = false;
        }
      }
      this.recordBetweenField = false;
    }
  }

  recordLevelAttrbuteSelection(event) {
    this.recordfilterData.fieldsWhere = event.value;
    console.log(this.recordfilterData.fieldsWhere);
    let filedName = "";
    this.recordLevelFilterData.forEach(object => {
      if (object.alias === this.recordfilterData.fieldsWhere) {
        filedName = object.object + "_" + object.filedName.replace(".", "_");
      }
    })
    console.log(filedName);
    console.log(this.multiSelectKeyAttributes);
    var multiselectElement = false;
    this.multiSelectKeyAttributes.forEach(value => {
      if (value === filedName) {
        multiselectElement = true;
      }
      if (event.value.includes("country")) {
        multiselectElement = true;
      }
    });
    console.log(multiselectElement);
    if (multiselectElement) {
      this.spinner.start();
      this.multiSelectVaules = [];
      console.log(filedName.includes("country") || filedName.includes("Country"));
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, filedName).subscribe(response => {
        if (response != null) {
          var sampleData = response;
          var data = sampleData[0].split(",");
          for (let elementIndex = 0; elementIndex < data.length; elementIndex++) {
            let element = data[elementIndex];
            if (element.includes("[")) {
              element = element.replace("[", "");
            }
            if (element.includes("]")) {
              element = element.replace("]", "");
            }
            if (element.includes("\"")) {
              element = element.replace("\"", "");
              element = element.replace("\"", "");
            }
            let dataTemplate = { "alias": "" };
            dataTemplate.alias = element;
            this.multiSelectVaules.push(dataTemplate);
          }
          console.log(this.multiSelectVaules);
        }
      });
      this.spinner.stop();
    }
    for (let objectIndex = 0; objectIndex < this.recordLevelFilterData.length; objectIndex++) {
      const object = this.recordLevelFilterData[objectIndex];
      if (object.alias === event.value) {
        console.log(object.type);
        this.recordDateField = (object.type == "DateTime" || object.type == "Date")
        break;
      } else {
        this.recordDateField = false;
      }
    }
    console.log(this.recordDateField);
    if (this.recordDateField) {
      this.recordBetweenField = false;
      this.recordDateField = true;
      this.recordMultiDate = false;
      this.recordMultiField = false;
      this.recordMultiselect = false;
      this.recordValueField = false;
      this.recordscheduleRange = false;
    } else {
      this.recordBetweenField = false;
      this.recordDateField = false;
      this.recordMultiDate = false;
      this.recordMultiField = false;
      this.recordMultiselect = false;
      this.recordValueField = true;
      this.recordscheduleRange = false;
    }
    this.recordfilterData.conditionalOperatorWhere = "";
  }

  applyRecordFilterSelection() {
    if (this.applyRecordFilter) {
      this.applyRecordFilter = false;
    } else {
      this.applyRecordFilter = true;
      this.spinner.start();
      this.recordLevelFilterData = [];
      this.multiSelectKeyAttributes = [];
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, "Keys").subscribe(response => {
        if (response != null) {
          this.multiSelectKeyAttributes = response;
          console.log(this.multiSelectKeyAttributes);
        }
      });
      this.recordLevelFilterData = [];
      let objectName = this.rollingupdata.childObjectName;
      console.log(objectName);
      let recordFilter = [];
      this.columns.forEach(object => {
        if (object.object === objectName && object.type != "" && !object.type.includes(",")) {
          recordFilter.push(object);
        }
      });
      this.recordLevelFilterData = recordFilter;
      this.spinner.stop();
    }
  }

  addRecordFilter() {
    this.recordfilterData.objectWhere = this.rollingupdata.childObjectName;

    //api call to insert data
    // this.formFieldsTrimer.trimFormfieldsData(this.whereData);
    // this.formFieldsTrimer.clean(this.recordfilterData);
    if (this.recordfilterData.objectWhere == undefined || this.recordfilterData.fieldsWhere == undefined || this.recordfilterData.conditionalOperatorWhere == undefined) {
      this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
    } else {
      this.recordfilterData.logicalOperatorWhere = "AND";
      console.log(this.recordfilterData.enterValueWhereDate)
      console.log(this.recordfilterData.enterValueWhere)
      let filedName = "";
      this.recordLevelFilterData.forEach(object => {
        if (object.alias === this.recordfilterData.fieldsWhere) {
          console.log(object);
          console.log(object.name);
          filedName = object.name;
        }
      })
      var whereValue = "";
      if (this.recordfilterData.conditionalOperatorWhere === "IN") {
        var multipleValue;
        var multiValue = "";
        multipleValue = this.recordfilterData.multiSelect;
        let value = multipleValue.split(",");
        if (value.length == 0) {
          this.snackbar.open("Not a valid filter. Please select value to Add filter", "OK", { duration: 5000 });
        } else {
          for (let index = 0; index < value.length; index++) {
            const element = value[index];
            multiValue = multiValue + "'" + element + "'";
            if (index != value.length - 1) {
              multiValue = multiValue + ",";
            }
          };
          whereValue = "(" + multiValue + ")";
          let tempWhere = {
            "objectWhere": this.recordfilterData.objectWhere,
            "whereKey": filedName,
            "whereKeyAlias": this.recordfilterData.fieldsWhere,
            "whereCondition": this.recordfilterData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.recordfilterData.logicalOperatorWhere
          }

          this.recordWhere.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        }
      } else if (this.recordfilterData.conditionalOperatorWhere === "BETWEEN") {
        if (this.dateChange) {
          this.whereValueDateFormat = moment(this.recordfilterData.enterValueBetweenStart)
          this.recordfilterData.enterValueBetweenStart = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          console.log(this.recordfilterData.enterValueBetweenStart)
          this.whereValueDateFormat = moment(this.recordfilterData.enterValueBetweenEnd)
          this.recordfilterData.enterValueBetweenEnd = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          console.log(this.recordfilterData.enterValueBetweenEnd)
          let tempWhere = {
            "objectWhere": this.recordfilterData.objectWhere,
            "whereKey": filedName,
            "whereKeyAlias": this.recordfilterData.fieldsWhere,
            "whereCondition": this.recordfilterData.conditionalOperatorWhere,
            "whereValue": "'" + this.recordfilterData.enterValueBetweenStart + "'",
            "whereValue1": "'" + this.recordfilterData.enterValueBetweenEnd + "'",
            "whereLogic": this.recordfilterData.logicalOperatorWhere
          }
          this.recordWhere.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else {
          let tempWhere = {
            "objectWhere": this.recordfilterData.objectWhere,
            "whereKey": filedName,
            "whereKeyAlias": this.recordfilterData.fieldsWhere,
            "whereCondition": this.recordfilterData.conditionalOperatorWhere,
            "whereValue": "'" + this.recordfilterData.enterValueBetweenStart + "'",
            "whereValue1": "'" + this.recordfilterData.enterValueBetweenEnd + "'",
            "whereLogic": this.recordfilterData.logicalOperatorWhere
          }
          this.recordWhere.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        }
      } else if (this.recordfilterData.conditionalOperatorWhere === "schedule range") {
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": this.recordfilterData.conditionalOperatorWhere,
          "whereValue": "",
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }
        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.recordfilterData.conditionalOperatorWhere === "Ends with") {
        whereValue = "'%" + this.recordfilterData.enterValueWhere + "'";
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }

        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.recordfilterData.conditionalOperatorWhere === "Starts with") {
        whereValue = "'" + this.recordfilterData.enterValueWhere + "%'";
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }

        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.recordfilterData.conditionalOperatorWhere === "contains") {
        whereValue = "'%" + this.recordfilterData.enterValueWhere + "%'";
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }

        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else {
        if (this.dateField) {
          this.whereValueDateFormat = moment(this.recordfilterData.enterValueWhereDate)
          whereValue = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
        } else {
          whereValue = "'" + this.recordfilterData.enterValueWhere + "'";
        }
        console.log(filedName);
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": this.recordfilterData.conditionalOperatorWhere,
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }
        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      }
      console.log(this.recordWhere);
      // this.showFilter = true;
      this.recordfilterData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
      this.recordBetweenField = false;
      this.recordMultiField = false;
      this.recordMultiDate = false;
      this.recordDateField = false;
      this.recordValueField = true;
      this.recordMultiselect = false;
      this.recordscheduleRange = false;
    }
  }

  downloadDataset(event) {
    let data = event.rowData
    if (data.dataSets3Path === undefined || data.dataSets3Path === "") {
      this.snackbar.open(data.datasetname + " file not present in S3", "OK", {
        duration: 5000
      })
    } else {
      let fileName = data.templateS3Path.substring(data.templateS3Path.lastIndexOf("/") + 1);
      this.service.downloadDatasetTemplate(data.reportcreationid,"excelTemplate").subscribe(response => {
        console.log(response);
        var dataBlob = new Blob([response]);
        const fileData = window.URL.createObjectURL(dataBlob);
        let link = document.createElement('a');
        link.href = fileData;
        link.download = fileName;
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      })
    }

  }

  rollupExclusionObjectSelection() {
    this.reportCreationData.rollupExclusionObjects = [];
    console.log(this.rollupExclusionObjects);
    for (let exclusionIndex = 0; exclusionIndex < this.rollupExclusionObjects.length; exclusionIndex++) {
      this.rollupExclusionObjectTemplate = { "exclusionObject": "" }
      const element = this.rollupExclusionObjects[exclusionIndex];
      if (this.reportCreationData.rollupExclusionObjects.length === 0) {
        this.rollupExclusionObjectTemplate.exclusionObject = element;
        this.reportCreationData.rollupExclusionObjects.push(this.rollupExclusionObjectTemplate);
      } else {
        this.reportCreationData.rollupExclusionObjects.forEach(object => {
          if (object.exclusionObject != element) {
            this.rollupExclusionObjectTemplate.exclusionObject = element;
            this.reportCreationData.rollupExclusionObjects.push(this.rollupExclusionObjectTemplate);
          }
        })
      }
    }
    console.log(this.reportCreationData.rollupExclusionObjects);
  }

  onRollupAliasChange(updatedRollupAlias) {
    console.log(updatedRollupAlias);
    let duplicate = false;
    for (let concatIndex = 0; concatIndex < this.concatination.length; concatIndex++) {
      const eachconcat = this.concatination[concatIndex];
      if (eachconcat.alias === updatedRollupAlias) {
        duplicate = true;
        break;
      }
    }
    console.log(duplicate);
    for (let columnIndex = 0; columnIndex < this.columns.length; columnIndex++) {
      const eachcolumn = this.columns[columnIndex];
      if (eachcolumn.alias === updatedRollupAlias) {
        duplicate = true;
        break;
      }
    }
    console.log(duplicate);
    for (let rollupIndex = 0; rollupIndex < this.rollingUp.length; rollupIndex++) {
      const rollup = this.rollingUp[rollupIndex];
      if (rollup.rollupColumnAlias === updatedRollupAlias) {
        duplicate = true;
        break;
      }
    }
    for (let aggregateByIndex = 0; aggregateByIndex < this.aggregateBy.length; aggregateByIndex++) {
      const agree = this.aggregateBy[aggregateByIndex];
      if (agree.alias === updatedRollupAlias) {
        duplicate = true;
        break;
      }
    }
    console.log(duplicate);
    if (duplicate) {
      this.rollingupdata.rollupColumnAlias = undefined;
      this.rollingupdata.rollupColumnAlias = this.rollingupdata.parentAttributesalias + "(" + this.rollingupdata.childAttributesalias + ")";
      this.snackbar.open("Please enter Unique Alias for Rollup", "OK", {
        duration: 10000,
      });
    }
  }
  duplicate = false

  onColumnAliasChange(columnAlias) {
    console.log(columnAlias);
    let duplicate = false;
    for (let columnIndex = 0; columnIndex < this.columns.length; columnIndex++) {
      const eachcolumn = this.columns[columnIndex];
      console.log(eachcolumn.alias);
      if (eachcolumn.alias === columnAlias) {
        duplicate = true;
        break;
      }
    }
    console.log(this.aggregateBy.length)
    for (let aggregateByIndex = 0; aggregateByIndex < this.aggregateBy.length; aggregateByIndex++) {
      console.log(this.aggregateBy[aggregateByIndex])
      const agree = this.aggregateBy[aggregateByIndex];
      console.log(agree.columnAlias + "==-=================" + columnAlias)
      if (agree.alias === columnAlias) {
        duplicate = true;
        break;
      }
    }
    for (let rollupIndex = 0; rollupIndex < this.rollingUp.length; rollupIndex++) {
      const rollup = this.rollingUp[rollupIndex];
      if (rollup.rollupColumnAlias === columnAlias) {
        duplicate = true;
        break;
      }
    }

    // if (duplicate) {
    //   this.snackbar.open("Please enter Unique Alias for Aggregate", "OK", {
    //     duration: 10,
    //   });




    // }

  }

  onTransformationObjectSelection(event) {
    console.log("transformation working.............")
    this.spinner.start();
    this.service.retrieveAllObjects(this.localStorageSettings.getSettings("dnsName")).subscribe(result => {
      console.log(result);
      this.referenceObjects = result;
    })
    console.log(this.filterObjects);
    this.filterData = []
    var tempColumnData = this.columns;
    var filterAttributes = [];
    var objectName = "";
    this.filterObjects.forEach((object) => {
      console.log(object.object);
      if (object.object === event.value) {
        objectName = object.object;
      }
    })
    console.log(objectName);
    tempColumnData.forEach((object) => {
      if (object.object === objectName && !object.type?.includes(",") && object.type != "__constant") {
        console.log(object);
        filterAttributes.push(object)
      }
    })
    this.filterData = filterAttributes;
    console.log(this.filterData);
    this.spinner.stop();
  }

  onTransformationReferenceObjectSelection(event) {
    console.log(event.value);
    this.transformationReferenceListTemp = event.value;
    console.log(this.transformationReferenceListTemp);
    console.log(this.columns, "===========ccccccccccccccccccccccccccccc======")


  }

  onPartitionChangeSelection(event: MatSelectChange) {

    this.orderedPartitionSelection = this.updateOrderedSelection(this.orderedPartitionSelection, event.value);
  }
  filteredColumns = [...this.columns];

  onHeaderChangeSelection(event: MatSelectChange) {
    // console.log(this.filteredColumns)
    // const selectedValues = this.headerTypeObj.headerKey;
    // this.filteredColumns = this.columns.filter(
    //   (col) => !selectedValues.includes(col.alias)
    // );
  }
  onOrderByChangeSelection(event) {
    console.log(event);
    console.log(this.subAggregateLevelData);
    this.orderedOrderBySelection = this.updateOrderedSelection(this.orderedOrderBySelection, event.value);
  }

  onOrderByChildColumns(event){
    this.orderedChildColumns=this.updateOrderedSelection(this.orderedChildColumns, event.value);
  }
  onOrderByorderedHeadersToNull(event){
    this.orderedHeadersToNull=this.updateOrderedSelection(this.orderedHeadersToNull, event.value);
  }

  onOrderByorderedOrderByColumn(event){
    this.orderedOrderByColumn=this.updateOrderedSelection(this.orderedOrderByColumn, event.value);
  }
  onOrderByorderedParentcolumns(event){
    this.orderedParentcolumns=this.updateOrderedSelection(this.orderedParentcolumns, event.value);
  }
  

  

  private updateOrderedSelection(currentSelection: string[], newSelection: string[]): string[] {
    const updatedSelection = [];


    currentSelection.forEach((value) => {
      if (newSelection.includes(value)) {
        updatedSelection.push(value);
      }
    });

    newSelection.forEach((value) => {
      if (!updatedSelection.includes(value)) {
        updatedSelection.push(value);
      }
    });

    return updatedSelection;
  }


  addTransformation() {
    if (this.transformationObjectData.object === "" || this.transformationObjectData.attribute === "" ||
      this.transformationReferenceList === undefined || this.transformationObjectData.sql === "") {
      this.snackbar.open("Not a valid Transformation", "OK", { duration: 5000 })
      return;
    } else {
      this.showTransform = true;
      let tempReference = "";
      let attributeAlias = "";
      this.filterData.forEach(filter => {
        if (filter.name === this.transformationObjectData.attribute && filter.object === this.transformationObjectData.object) {
          attributeAlias = filter.alias;
        }
      })
      this.transformationReferenceList.forEach(object => {
        if (tempReference === "") {
          tempReference = object;
        } else {
          tempReference = tempReference + "," + object;
        }
      });
      let transformationTemp = {
        "object": this.transformationObjectData.object,
        "attribute": this.transformationObjectData.attribute,
        "alias": attributeAlias,
        "referenceObjects": tempReference,
        "sql": this.transformationObjectData.sql
      };
      this.transformation.push(transformationTemp);
      this.formValidationForTranformation();
    }
  }
  allfieldArrayForAttributes:any=[]
  tablefieldses:any
  objectWhereKey(event) {
   
    console.log("selectedObjectsMap:", this.selectedObjectsMap);

    console.log("Available keys in selectedObjectsMap:", Object.keys(this.selectedObjectsMap));
    console.log(event);
    this.columnLevelFilterData = [];
    this.tablefieldses = [];
    // this.columnFilterDataObject.fieldsWhere = "";
    let objectName = "";
    console.log(this.filterObjectses);
    let selectedObjectName 

  
    this.filterObjects.forEach((object) => {
      console.log(object.object, ",", event.value);
      if (object.object === event.value) {
        objectName = object.object;
        selectedObjectName = object.name;
        
      }
    });
  console.log("Object name form map",this.selectedObjectsMap[selectedObjectName])
    // let selectedObjectDetails = this.selectedObjectsMap[selectedObjectName];
    let selectedObjectDetails = this.selectedObjectsMap[
      Object.keys(this.selectedObjectsMap).find(
          key => key.trim().toLowerCase() === selectedObjectName?.trim().toLowerCase()
      ) || ''
  ];
  
    let selectedObjectId = selectedObjectDetails ? selectedObjectDetails.id : null;
    console.log("Available keys in selectedObjectsMap:", Object.keys(this.selectedObjectsMap));
    console.log("Trying to access key:", selectedObjectName);
  
    console.log("Selected Object Name:", selectedObjectName);
    console.log("Retrieved Object ID:", selectedObjectId);
    console.log(objectName);
    let stageObjectCheck = objectName.toLowerCase().replace(/[^a-z0-9]/g,"")
    this.service.retrieveTablesFieldsForDataset(selectedObjectId).subscribe(res => {
      this.spinner.start();
  
      console.log(res);
      if (res.error === true) {
        this.spinner.stop();
        this.snackbar.open(res.message, "OK", { duration: 5000 });
        this.allFields = [];
        this.selectedFieldsData = [];
        this.gridApiForTablesFields.setGridOption('rowData', []);
      } else {
        this.spinner.stop();
          let fieldsArray = JSON.parse(res[0].attributeNameAndFields);
      
      if (fieldsArray.datasets) {
          console.log(JSON.parse(res[0].attributeNameAndFields))
          this.allfieldArrayForAttributes = fieldsArray.datasets[0].columns
          console.log(this.allfieldArrayForAttributes)
        } else {
          
           this.allfieldArrayForAttributes = JSON.parse(res[0].attributeNameAndFields);
        }
      
      }
    });
  }

 onObjectSelectionChange(event: any, rule: Rule,side) {
  console.log(this.columns);
  console.log(this.selectedTableFields);
  
  const selectedObject = event.value;
  console.log(selectedObject);
  
  const matchingAttributes = this.columns
    .filter(attr => attr.object === selectedObject)
    .map(attr => attr.name);

  if (side === 'lhs') {
    rule.availableAttributes = [...matchingAttributes];
    rule.field = '';
  } else {
    console.log(matchingAttributes);
    console.log("*****************");
    
    rule.rhsAvailableAttributes = [...matchingAttributes];
    rule.rhsField = '';
  }
}

  onColumnFilterAttributeSelection(event) {
    console.log(event)
    this.columnFilterData.name = "";
    console.log(this.allfieldArrayForAttributes)
    this.allfieldArrayForAttributes.forEach(object => {
      if (object.label === event.value) {
        console.log(object);
        this.columnFilterData.name = object.name;
      }
    })
  }

  columnFilterAttribute:any = []
  onColumnObjectSelection(event) {
    
    this.filterData = [];
    this.columnFilterDataObject.fieldsWhere = "";
    // var tempColumnData = this.columns;
    var filterAttributes = [];
    var objectName = "";
    let selectedObjectName
    this.filterObjects.forEach((object) => {
      console.log(object.object, ",", event.value);
      if (object.object === event.value) {
        objectName = object.object;
        selectedObjectName = object.name;
      }
    })
    console.log(objectName);
    let selectedObjectDetails = this.selectedObjectsMap[selectedObjectName];
    let selectedObjectId = selectedObjectDetails ? selectedObjectDetails.id : null;
  
    console.log("Selected Object Name:", selectedObjectName);
    console.log("Retrieved Object ID:", selectedObjectId);
    console.log(objectName);
    let stageObjectCheck = objectName.toLowerCase().replace(/[^a-z0-9]/g,"")
    this.service.retrieveTablesFieldsForDataset(selectedObjectId).subscribe(res => {
      this.spinner.start();
  
      console.log(res);
      if (res.error === true) {
        this.spinner.stop();
        this.snackbar.open(res.message, "OK", { duration: 5000 });
        this.allFields = [];
        this.selectedFieldsData = [];
        this.gridApiForTablesFields.setGridOption('rowData', []);
      } else {
        this.spinner.stop();
         let fieldsArray = JSON.parse(res[0].attributeNameAndFields);
      
      if (fieldsArray.datasets) {
          console.log(JSON.parse(res[0].attributeNameAndFields))
          this.columnFilterAttribute = fieldsArray.datasets[0].columns
          console.log(this.columnFilterAttribute)
        } else {
          
           this.columnFilterAttribute = JSON.parse(res[0].attributeNameAndFields);
        }
        // this.columnFilterAttribute = JSON.parse(res[0].attributeNameAndFields);
      
        // console.log(this.columnFilterAttribute);
        // console.log("allfieldArrayForAttributes:", this.columnFilterAttribute);
      }
    });
   
  }

  onColumnAttrbuteSelection(event) {
    console.log(event)
    this.columnFilterDataObject.conditionalOperatorWhere = '';
    this.columnFilterFormGroup.controls['columnLogicalOperatorWhere'].setValue('');
    console.log(event.value);
    let objectName = "";
    console.log(this.columnFilterAttribute)
    console.log(this.columnFilterDataObject.fieldsWhere)
    this.columnFilterAttribute.forEach(object => {
      if (object.label === this.columnFilterDataObject.fieldsWhere) {
        console.log(object);
        objectName = object.object + "_" + object.name.replace(".", "_");
      }
    })
    console.log(objectName);
    var multiselectElement = false;
    this.multiSelectKeyAttributes.forEach(value => {
      if (value === objectName) {
        multiselectElement = true;
      }
    });
    if (multiselectElement) {
      this.spinner.start();
      this.multiSelectVaules = [];
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, objectName).subscribe(response => {
        if (response != null || response.length < 0) {
          var sampleData = response;
          var data = sampleData[0].split(",");
          for (let elementIndex = 0; elementIndex < data.length; elementIndex++) {
            let element = data[elementIndex];
            if (element.includes("[")) {
              element = element.replace("[", "");
            }
            if (element.includes("]")) {
              element = element.replace("]", "");
            }
            if (element.includes("\"")) {
              element = element.replace("\"", "");
              element = element.replace("\"", "");
            }
            let dataTemplate = { "alias": "" };
            dataTemplate.alias = element;
            this.multiSelectVaules.push(dataTemplate);
          }
          console.log(this.multiSelectVaules);
        } else {
          this.snackbar.open("No Facet deplcared for selected attribute", "OK", { duration: 5000 });
        }
      });
      this.spinner.stop();
    }
    for (let objectIndex = 0; objectIndex < this.columns.length; objectIndex++) {
      const object = this.columns[objectIndex];
      if (object.alias === event.value) {
        this.columnDateField = (object.type == "DateTime" || object.type == "Date")
        break;
      } else {
        this.columnDateField = false;
        this.columnDateChange = false;
      }
    }
    if (this.columnDateField) {
      this.columnValueField = false;
      this.columnFieldChange = false;
      this.columnMultiselect = false;
     
    } else if (multiselectElement) {
      let event = { value: "IN" }
      this.columnFilterDataObject.conditionalOperatorWhere = "IN";
      this.columnFilterFormGroup.controls['columnLogicalOperatorWhere'].setValue("IN");
      this.onColumnFilterConditionSelection(event);
    } else {
      this.columnFieldChange = true;
      this.columnDateField = false;
      this.columnDateChange = false;
    }
    this.columnBetweenField = false;
    this.columnFilterDataObject.conditionalOperatorWhere = "";
  }

  onColumnFilterConditionSelection(event) {
    this.columnScheduleRange = false;
    if (event.value === "BETWEEN") {
      this.columnFieldChange = false;
      this.columnBetweenField = true;
      if (this.columnDateField) {
        this.columnDateChange = true;
        this.columnDateField = false;
      } else {
        this.columnValueField = true;
      }
      this.columnMultiselect = false;
    } else if (event.value === "IN") {
      if (this.columnDateField || this.columnDateChange) {
        console.log(this.columnDateField, ",", this.columnDateChange);

      } else {
        this.columnMultiselect = true;
        this.columnBetweenField = false;
        this.columnDateField = false;
        this.columnFieldChange = false;
      }
    } else if (event.value === "schedule range") {
      this.columnMultiselect = false;
      this.columnBetweenField = false;
      this.columnDateField = false;
      this.columnFieldChange = false;
      this.columnDateChange = false;
      this.columnValueField = false;
      this.columnScheduleRange = true;
    } else {
      this.columnMultiselect = false;
      if (this.columnDateField) {
        this.columnFieldChange = false;
        this.columnDateField = true;
      } else {
        if (this.columnDateChange) {
          this.columnFieldChange = false;
          this.columnDateField = true;
          this.columnDateChange = false;
        } else {
          this.columnFieldChange = true;
          this.columnDateField = false;
        }
      }
      this.columnBetweenField = false;
    }
  }

  addFilterForColumn() {
    if (this.columnFilterDataObject.objectWhere == undefined) {
      this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
    } else {
      this.columnFilterDataObject.logicalOperatorWhere = "AND";
      console.log(this.columnFilterDataObject.enterValueWhereDate)
      console.log(this.columnFilterDataObject.enterValueWhere)
      let objectName = "";
      this.filterData.forEach(object => {
        if (object.alias === this.columnFilterDataObject.fieldsWhere) {
          objectName = object.name;
        }
      })
      var whereValue;
      if (this.columnFilterDataObject.conditionalOperatorWhere === "IN") {
        var multipleValue;
        var multiValue = "";
        multipleValue = this.columnFilterDataObject.multiSelect;
        let value = multipleValue.split(",")
        if (value.length == 0) {
          this.snackbar.open("Not a valid filter. Please select value to Add filter", "OK", { duration: 5000 });
        }
        for (let index = 0; index < value.length; index++) {
          const element = value[index];
          multiValue = multiValue + "'" + element + "'";
          if (index != value.length - 1) {
            multiValue = multiValue + ",";
          }
        };
        whereValue = "(" + multiValue + ")";
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "BETWEEN") {
        if (this.columnDateChange) {
          this.whereValueDateFormat = moment(this.columnFilterDataObject.enterValueBetweenStart)
          this.columnFilterDataObject.enterValueBetweenStart = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          console.log(this.columnFilterDataObject.enterValueBetweenStart)
          this.whereValueDateFormat = moment(this.columnFilterDataObject.enterValueBetweenEnd)
          this.columnFilterDataObject.enterValueBetweenEnd = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          console.log(this.columnFilterDataObject.enterValueBetweenEnd)
          let tempWhere = {
            "objectWhere": this.columnFilterDataObject.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
            "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
            "whereValue": "'" + this.columnFilterDataObject.enterValueBetweenStart + "'",
            "whereValue1": "'" + this.columnFilterDataObject.enterValueBetweenEnd + "'",
            "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
          }
          this.columnFilterData.filters.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else {
          let tempWhere = {
            "objectWhere": this.columnFilterDataObject.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
            "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
            "whereValue": "'" + this.columnFilterDataObject.enterValueBetweenStart + "'",
            "whereValue1": "'" + this.columnFilterDataObject.enterValueBetweenEnd + "'",
            "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
          }
          this.columnFilterData.filters.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        }
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "schedule range") {
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
          "whereValue": "",
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }
        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "Ends with") {
        whereValue = "'%" + this.columnFilterDataObject.enterValueWhere + "'";
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" };
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "Starts with") {
        whereValue = "'" + this.columnFilterDataObject.enterValueWhere + "%'";
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "contains") {
        whereValue = "'%" + this.columnFilterDataObject.enterValueWhere + "%'";
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else {
        if (this.columnDateField) {
          this.whereValueDateFormat = moment(this.columnFilterDataObject.enterValueWhereDate)
          whereValue = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
        } else {
          whereValue = "'" + this.columnFilterDataObject.enterValueWhere + "'";
          this.columnFilterDataObject.enterValueWhere = whereValue;
        }
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" };
      }
      this.columnFilterDataObject = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
      this.columnDateChange = false;
      this.columnDateField = false;
      this.columnMultiselect = false;
      this.columnFieldChange = true;
      this.columnScheduleRange = false;
      this.columnBetweenField = false;

      console.log(this.columnFilterData);
      this.multiSelectVaules = [];
      this.filterData = [];
    }
  }

  addColumnFilter() {
    if (this.columnFilterData.object === undefined || this.columnFilterData.name === undefined || this.columnFilterData.alias === undefined || this.columnFilterData.filters.length === 0) {
      this.snackbar.open("Not a valid Column Filter", "OK", { duration: 5000 });
    } else {
      this.columnFilter.push(this.columnFilterData);
      this.columnFilterData = { "name": "", "object": "", "alias": "", "filters": [] };
      this.columnFilterDataObject = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
      this.showColumnFilter = true;
      this.columnFilterFormGroup.reset();
      this.validateColumnFilterFormGroup();
    }
  }

  deleteIcon(updatedata) {
    if(updatedata.rowData.approvedBy === this.localStorageSettings.getSettings("AuthUsername") || updatedata.rowData.approvedStatus != 'Approved'){
    console.log(updatedata)
    if (updatedata.rowData.status === "No") {
      this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
      return;
    }
    console.log(updatedata)
    this.sharedData = updatedata.rowData;
      if (confirm("Are you sure you want to delete stage object?")) {
        this.spinner.start();
        this.service.deleteStageObject(updatedata.rowData.id).subscribe({
          next: (result) => {
            if (result.statusMessage === "Successfully record is deleted") {
              this.refreshGridData(); 
              this.snackbar.open(result.statusMessage, "OK", { duration: 5000 });
            } else if(result.statusMessage === "This stage object has reference object mapping, deletion is not allowed") {
              this.snackbar.open("This stage object has reference object mapping, deletion is not allowed", "OK", { duration: 5000 });
            }else{
               this.snackbar.open("Cannot delete selected stage object", "OK", { duration: 5000 });
            }
            this.refreshRun();
          },
          error: (error) => {
            console.error("Delete API Error: ", error);
            this.snackbar.open("Error occurred while deleting", "OK", { duration: 5000 });
          },
          complete: () => {
            this.spinner.stop(); // Ensures spinner stops no matter what
            this.refreshRun();
          }
        });
      }
    }else{
      this.snackbar.open("Unauthorized to perform this operation for approved Stage Object.", "OK", { duration: 5000 });
    }
  }

  
  refreshDataset(selectedDataset) {

    if (selectedDataset.rowData.status === "No") {
      this.snackbar.open("Cannot refersh deleted Dataset", "OK", { duration: 5000 });
      return;
    }
    
    if (selectedDataset.rowData.generationStatus == "In Progress") {
      this.snackbar.open("Dataset Generation is in Progress try Later", "OK", { duration: 5000 });
      return;
    }

    if (confirm("Are you sure you want to refresh dataset?")) {
      this.spinner.start();
      this.service.refreshDataset(selectedDataset.rowData.reportcreationid).subscribe(result => {
        if (result.error) {
          this.snackbar.open(result.statusMessage + result.data, "OK", { duration: 5000 });
        } else {
          this.snackbar.open(result.statusMessage, "OK", { duration: 5000 });
        }
        this.refreshRun();
        this.spinner.stop();
      });
    }
  }
  exportData(): void {
    this.spinner.start();
    let dialogRef: any;

    this.vaultObjectService.retrieveAllObjectGroupForDataset(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {
      this.ExportObjectGroups = res;
      console.log(res);
      let width = "70%";
      // Open dialog with proper configurations
      dialogRef = this.dialog.open(ExportDialogComponent, {
        maxWidth: '100vw',
        height: '500px', // Set a fixed height
        width: '800px', // Set a fixed width
        data: { datasets: this.getdata, ObjectGroups: this.ExportObjectGroups },
        disableClose: true,
      });


      this.spinner.stop();

      // Handle dialog close
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // this.snackbar("Datasets exported as zip file. Please check.", "OK", { duration: 3000 });
          console.log('Selected datasets for export:', result);
          // Example: Pass the selected datasets to an export function
          // this.performExport(result);
        }
      });
    }, error => {
      this.spinner.stop();
      console.error('Error retrieving object groups:', error);
      //this.snackbar("Failed to retrieve data. Please try again.", "OK", { duration: 3000 });
    });
  }


  importData(): void {

    this.spinner.start();
    let dialogRef: any;
    this.vaultObjectService.retrieveAllObjectGroupForDataset(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {
      this.ExportObjectGroups = res;
      console.log(res);
      let width = "90%";

      dialogRef = this.dialog.open(ImportDialogComponent, {
        maxWidth: '100vw',
        height: "80%",
        width: width,

        data: { ObjectGroups: this.ExportObjectGroups },
        disableClose: true,

      });
      this.spinner.stop();
    })


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle the export logic here with selected datasets
        console.log('Selected datasets for export:', result);
        
      }
    });
  }


  copyDatasetandupdate(params) {
    console.log("Inside copy dataset...")



    console.log(this)
    console.log(params.data)

    this.sharedData = params.data;

    if (params.data.status === "No") {
      this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
      return;
    }

    console.log(params.data.dataset_ownerRoleid)
    if (this.responserequest.roleName !== params.data.dataset_ownerRoleid) {
      this.snackbar.open(this.constants.Access_Denied, "OK", { duration: 5000 });
      return;
    }

    let dialogRef = this.dialog.open(CopydatasetDialogComponent, {
      maxWidth: "100vw",
      height: "30%",
      width: "40%",
      data: { data: params },
      disableClose: true,
    });

  }




  copyDataset(params) {
    console.log("Inside copy dataset...")
    console.log(params)
    this.spinner.start();
    let parentKey = 0;

    const reportCreationData = {
      "datasetname": "", "datasetObjectname": "", "datasetobjectattributes": [], "type": "",
      "description": "", "objectGroup": "", "filters": [], "sorting": [], "aggregate": [], "columns": [], "concatination": [],
      "rollingUp": [], "rollupExclusionObjects": [], "transformation": [], "columnFilters": [],"columnFiltersExpression":"","headersType": [], "generateDefaultTemplate": "",
      "autoRefreshDataset": "", "datasetAccessType": "", "dataset_rolesIds": "", "createdBy": "", "createdDateAndTime": "","pivotAggregate":[],"flatteningOption":"Flatten Data"
    }


    console.log(params.rowData.datasetname)

    reportCreationData.datasetname = params.rowData.datasetname
    reportCreationData.datasetObjectname = params.rowData.datasetObjectname;
    reportCreationData.datasetobjectattributes = JSON.parse(params.rowData.datasetobjectattributes);
    reportCreationData.type = params.rowData.type;
    reportCreationData.description = params.rowData.description;
    reportCreationData.flatteningOption=params.rowData.flatteningOption
    reportCreationData.objectGroup = params.rowData.objectGroup;
    reportCreationData.filters = JSON.parse(params.rowData.filters);
    reportCreationData.sorting = JSON.parse(params.rowData.sorting);
    reportCreationData.aggregate = JSON.parse(params.rowData.aggregate);
    reportCreationData.columns = JSON.parse(params.rowData.columns);
    reportCreationData.concatination = JSON.parse(params.rowData.concatination);
    reportCreationData.rollingUp = JSON.parse(params.rowData.rollingUp);
    reportCreationData.rollupExclusionObjects = JSON.parse(params.rowData.rollupExclusionObjects);
    reportCreationData.transformation = JSON.parse(params.rowData.transformation);
    if(this.getSQL()){ 
      let columnFilterDetails:RuleGroup =this.stripUiFields(this.rootGroup)
        let columnFilterArray=[]
        columnFilterArray.push(columnFilterDetails)
        reportCreationData.columnFilters=columnFilterArray;
        reportCreationData.columnFiltersExpression=this.getAbstractedSQL();
      }else{
        reportCreationData.columnFilters = [];
        reportCreationData.columnFiltersExpression=""
      }
    reportCreationData.generateDefaultTemplate = this.generateDefaultTemplate;
    reportCreationData.autoRefreshDataset = "false";
    reportCreationData.datasetAccessType = params.rowData.datasetAccessType;
    reportCreationData.dataset_rolesIds = params.rowData.dataset_rolesIds;
    reportCreationData.pivotAggregate = JSON.parse(params.rowData.pivotAggregate);
    

    if (params.rowData.headersType != null || params.rowData.headersType != undefined) {
      reportCreationData.headersType = JSON.parse(params.rowData.headersType);
    }
    console.log(reportCreationData.aggregate)
    console.log(typeof reportCreationData.aggregate)

    for (let a = 0; a < reportCreationData.aggregate.length; a++) {
      const currentItem = reportCreationData.aggregate[a];
      if (currentItem.groupByNeeded === undefined || currentItem.groupByNeeded === null) {
        currentItem.groupByNeeded = false;
      }
    }


    console.log(reportCreationData)

    this.linkservice.insertreportlinks(reportCreationData, parentKey).subscribe(response => {
      console.log(response);
      this.snackbar.open(response.statusMessage + response.data, "OK", {
        duration: 5000,
      });
      this.spinner.stop();
      if (!response.error) {
        this.showRollingUp = false;
        this.objectGroup = false;
        this.datasetGroup = false;
        this.onGridReady(this.rowbindingdata);
        this.cancel();
      }
      this.aggregateBy = []
      this.pivotAggregateBy=[]
    });

  }

  dnsid:number
  recordDnsName
  dnsEvnName
  selectDns(event) {
    console.log(this.defaultLoginDns);
    console.log(event);
    let tempdnschange = event
    this.spinner.start();	
    this.commonService.getTenantidBasedEnvname(tempdnschange).toPromise()
    .then(dnsvalue => {
        console.log("Inside Response:", dnsvalue);
        this.dnsid = Number(dnsvalue);
        
        this.recordDnsName = this.dnsid;
        this.refreshGridData();
    })
    .catch(error => {
        console.error(" Error:", error);
    })
    .finally(() => {
        this.spinner.stop();
    });
  
  }
  
    
  dnsDropDown(userid) {
    console.log(userid);
    this.dnsnames = [];

    // Return the entire promise chain
    return this.commonService.retrieveSourceDnsWithDetails(userid).toPromise()
        .then(dnsList => {
            console.log(" DNS List with Additional Details from API:", dnsList);

            this.vaultids = dnsList;  // Store retrieved vaults in the component state
            console.log(" Updated Vault IDs:", this.vaultids);

            // Extract vault names
            let vaultNames = this.vaultids.map(vault => vault.envname);
            console.log(" Vault Names:", vaultNames);

            // Check which vaults are sources
            return this.commonService.checkIfSource(vaultNames).toPromise();
        })
        .then(sourceMap => {
            this.dnsnames = this.vaultids.filter(vault => sourceMap[vault.envname]);

            this.dnsnames.forEach(vault => {
                console.log(`${vault.envname} is a source and added to the list.`);
               
            });
            console.log(this.dnsnames)
            if (this.dnsnames.length > 0) {
                let defaultDns = this.dnsnames[0]; // Set first DNS as default
                this.name = defaultDns.evnname;
                this.defaultLoginDns = defaultDns;
            }

            console.log(" Final DNS list:", this.dnsnames);
        })
        .catch(error => {
            console.error(" Error:", error);
        });
}

   

  async updateButtonsPermission(screenPath) {
    var buttonIdList: any = await this.retrieveScreenAccess.find(screenPath);
    console.log('Button ID List:', buttonIdList);
    const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
    buttons.forEach(button => {
      const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
      if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
        if (!buttonIdList.includes(buttonId)) {
          button.setAttribute('disabled', 'true'); // Disable the button
        } else {
          button.removeAttribute('disabled'); // Enable the button
        }
      }
    });
  }

  ngAfterViewInit() {
  //   this.editor = CodeMirror.fromTextArea(this.codeEditor.nativeElement, {
  //     mode: 'text/x-mysql', // ✅ Set SQL mode
  //     theme: 'material-darker',
  //     lineNumbers: true,
  //     extraKeys: { 'Ctrl-Space': 'autocomplete' } // ✅ Trigger autocomplete with Ctrl+Space
  //   });
  
  //   this.editor.setValue(this.expressionDetails);
  
  //     // ✅ Set CodeMirror editor height
  //     this.editor.setSize(null, '200px');
  
  //   // ✅ Show hints when typing 
  //   this.editor.on('inputRead', (cm) => {
  //     if (!cm.state.completionActive) { // Prevent multiple popups
  //       CodeMirror.showHint(cm, this.customHint, { completeSingle: false });
  //     }
  //   });
  
  //   this.editor.on('change', (cm) => {
  //     this.expressionDetails = cm.getValue();
  //      this.validations_form.get('expressionQuery').setValue(this.expressionDetails);
  //     this.validations_form.get('expressionQuery').markAsTouched();

  //   });

  //   this.editor.on('blur', () => {
  //   this.validations_form.get('expressionQuery').markAsTouched();
  // });
  
  }
  
//   customHint = (editor: CodeMirror.Editor): CodeMirror.Hints | Promise<CodeMirror.Hints> => {
//     this.buildSqlTableHints();
//     const cursor = editor.getCursor();
//     const token = editor.getTokenAt(cursor);
//     const input = token.string.toLowerCase();

//     const sql = editor.getValue();
//     const aliasMap = this.extractAliasMap(sql);

//     const lineBeforeCursor = editor.getLine(cursor.line).slice(0, cursor.ch);
//     const aliasMatch = lineBeforeCursor.match(/(\b\w+)\.$/);
//     const alias = aliasMatch ? aliasMatch[1] : null;
//     console.log(this.sqlTables);
    
//     let aliasHints: any[] = [];
//     if (alias && aliasMap[alias]) {
//         const actualTable = aliasMap[alias];
//         if (this.sqlTables[actualTable]) {
//           const startCh = lineBeforeCursor.lastIndexOf(alias);
//           aliasHints = this.sqlTables[actualTable].map(col => ({
//             text: `${alias}.${col}`, // ✅ full insertion text (e.g., stg.id)
//             displayText: `${alias}.${col}`,
//             from: CodeMirror.Pos(cursor.line, startCh),
//             to: CodeMirror.Pos(cursor.line, cursor.ch)
//           }));
//         }
// }


//     const matchingFields = Object.entries(this.sqlTables).flatMap(([table, fields]) =>
//       fields
//         .filter(field => field.toLowerCase().startsWith(input))
//         .map(field => ({
//           text: `${table}.${field}`,
//           displayText: `${table}.${field}`,
//           from: CodeMirror.Pos(cursor.line, token.start),
//           to: CodeMirror.Pos(cursor.line, token.end)
//         }))
//     );


    
//     const sqlHintResult = !alias ? CodeMirror.hint.sql(editor, { tables: this.sqlTables }) : [];


//     const buildFinalList = (resultList: any[] = []) => {
//       const seen = new Set();
//       return [...aliasHints, ...matchingFields, ...resultList].filter(hint => {
//         const key = `${hint.displayText}-${hint.text}`;
//         if (seen.has(key)) return false;
//         seen.add(key);
//         return true;
//       });
//     };

//     if (sqlHintResult instanceof Promise) {
//       return sqlHintResult.then(result => {
//         const list = result && 'list' in result ? result.list : [];
//         return {
//           list: buildFinalList(list),
//           from: CodeMirror.Pos(cursor.line, token.start),
//           to: CodeMirror.Pos(cursor.line, token.end)
//         };
//       });
//     }

//     const list = sqlHintResult && 'list' in sqlHintResult ? sqlHintResult.list : [];
//     return {
//       list: buildFinalList(list),
//       from: CodeMirror.Pos(cursor.line, token.start),
//       to: CodeMirror.Pos(cursor.line, token.end)
//     };
//   };

  buildSqlTableHints(): void {
    this.sqlTables = this.temp.reduce((acc, item) => {
      if (!acc[item.object]) acc[item.object] = [];
      acc[item.object].push(item.name);
      return acc;
    }, {} as Record<string, string[]>);
  }

  extractAliasMap(sql: string): Record<string, string> {
  const aliasMap: Record<string, string> = {};

  // Matches both "FROM table AS alias" and "FROM table alias"
  const regex = /\b(?:FROM|JOIN)\s+(`?[\w\d_]+`?)\s+(?:AS\s+)?(\w+)/gi;
  let match;

  while ((match = regex.exec(sql)) !== null) {
    const table = match[1].replace(/`/g, '').trim();
    const alias = match[2];
    aliasMap[alias] = table;
  }

  return aliasMap;
}

 getRouterLink(event): any[] {
  if (event.label === 'Objects') {
    return ['/user/Menubar/trnxBaseComponent'];
  } else {
    return [`/user/Menubar/${event.link}`];
  }
}

getQueryParams(label: string): any {
  if (label === 'Objects') {
    return {
      screenType: 'Dynamic/Transactions',
      tableName: 'objectmetadata',
      headerNameHtml: 'Objects'
    };
  }
  return null;
  
}

checkIcon(event) {
    console.log(this.MappingAttributecheckbox)
    console.log("------------------------")
    console.log(event)
    const id = event.rowData.id;
    const index = this.MappingAttributecheckbox.indexOf(id);
    console.log(index)

    //retrieving the index of already inserted one to remove from the insertobject in case of uncheck
    const indexOfInsertObject = this.insertObject.findIndex(obj => obj.id === id);
    console.log(indexOfInsertObject)
    if (index > -1) {
      // ID exists, so remove it
      this.MappingAttributecheckbox.splice(index, 1);
      this.MappingAttributes.splice(index,1);
      if (indexOfInsertObject !== -1) {
          console.log("Deleting object with id:", event.rowData.id);
          this.insertObject.splice(indexOfInsertObject, 1);
          }
     
      let allApproved = true;

       for (let i = 0; i < this.MappingAttributes.length; i++) {

        if (this.MappingAttributes[i].approvedStatus !== 'Approved'){
          allApproved = false;
          break; 
        }
      }

      if(this.MappingAttributes.length === 0){
        this.ButtonApprove = 'Approve';
        this.isvisible = true
      }

      if (this.MappingAttributes.length > 0 && allApproved) {
        this.ButtonApprove = 'Disapprove';
      }
      else{
        this.ButtonApprove = 'Approve';
      }
      
    } else {

      // ID does not exist, so add it
      this.MappingAttributecheckbox.push(id);
      this.MappingAttributes.push(event.rowData)
      //checking the selected object already present or not if not present in insertobject then add it
      if (!this.insertObject.some(obj => obj.id === event.rowData.id)) {
           console.log("#--------------#")
           this.insertObject.push(event.rowData);
        }

      if(event.rowData.approvedStatus === 'Approved'){
         this.ButtonApprove = 'Disapprove'
      }


      if(event.rowData.approvedStatus === null){
         this.ButtonApprove = 'Approve'
      }

      if(event.rowData.approvedStatus === 'Draft'){
         this.ButtonApprove = 'Approve'
      }
      console.log(this.MappingAttributes.length)
      if(this.MappingAttributes.length != 0){
      this.isvisible = false
      }
      
    }

    console.log("testing -"+ this.MappingAttributecheckbox);
    console.log( this.MappingAttributes);
    console.log( this.insertObject);
  }


Viewresults(){
  if (this.MappingAttributecheckbox.length > 0) {
  let dialogRef = this.dialog.open(ViewResultsComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: '80%',
        autoFocus: false,
        data: { edata: this.MappingAttributecheckbox,screen:"Verify Stage"},
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((description: string) => {
          this.MappingAttributecheckbox = []
          this.MappingAttributes = []
          this.insertObject = []
          this.refreshRun()
        });
    

    
      }
      else{
  this.snackbar.open("Select Atleast One Mapping Attribute", "OK", { duration: 5000 });
 }
 this.isvisible = true;
 
 
}




 Mappingverify(){

   //  NEW VALIDATION (ONLY HERE)
  if (this.insertObject.length !== 1) {
    this.snackbar.open("Please select exactly one record", "OK", {
      duration: 5000
    });
    return;
  }
    if (this.MappingAttributes.length > 0) {
      let dialogRef = this.dialog.open(VerifyMappingComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: '80%',
        autoFocus: false,
        data: { edata: this.insertObject,screen:"Verify Stage"},
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((description: string) => {
          this.MappingAttributecheckbox = []
          this.MappingAttributes = []
          this.insertObject = []
          this.refreshRun()
        });
    }else{
      this.snackbar.open("Select Atleast One Mapping Attribute", "OK", { duration: 5000 });
    }
      
    
 }




 ApproveAttribute() {
  if (this.MappingAttributes.length > 0) {
  
  this.isvisible = true;
  let firstStatus = this.MappingAttributes[0].approvedStatus;


  let allSame = this.MappingAttributes.every(attr => {
  return (firstStatus === null || firstStatus === 'Draft')
    ? (attr.approvedStatus === null || attr.approvedStatus === 'Draft')
    : (attr.approvedStatus === firstStatus);
  });

  if (!allSame) {
  this.snackbar.open("Please select only one combination of mapping attributes for approval or disapproval.", "OK", { duration: 5000 });
  return;
  }



  let approvedStatus = this.ButtonApprove === 'Approve' ? 'Approved' :
                       this.ButtonApprove === 'Disapprove' ? 'Draft' : null;

  if (!approvedStatus) {
    this.snackbar.open("Invalid action. Please select Approve or Disapprove.", "OK", { duration: 5000 });
    return;
  }

  let response = {
    approvedStatus: approvedStatus,
    approvedBy: this.localStorageSettings.getSettings("AuthUsername")
  };
  this.spinner.start();
  this.linkservice.updateAttibuteSatus(response, this.MappingAttributecheckbox,this.SourceId).subscribe(response => {
    this.MappingAttributecheckbox = [];
    this.MappingAttributes = []
    this.refreshRun()
    this.ButtonApprove = 'Approve'
    this.spinner.stop()
    this.snackbar.open(response.data, "OK", { duration: 5000 });
  });
}else{
  this.snackbar.open("Select Atleast One Mapping Attribute", "OK", { duration: 5000 });
}
this.refreshRun()
}

 addRule(group: RuleGroup) {
    group.rules.push({
    type: 'rule',
    object: '',                  // left-hand side object
    field: '',                   // left-hand side field
    operator: '=',               // default operator
    value: '',                   // used if comparing with value
    rhsObject: '',               // right-hand side object (if comparing fields)
    rhsField: '',                // right-hand side field
    availableAttributes: [],     // left-side attributes (based on object)
    rhsAvailableAttributes: []   // right-side attributes (based on object)
  });
  }

  addGroup(group: RuleGroup) {
    group.rules.push({
      type: 'group',
      condition: 'AND',
      rules: []
    });
  }

  removeRule(group: RuleGroup, index: number) {
    group.rules.splice(index, 1);
  }

  getJson() {
    return JSON.stringify(this.rootGroup, null, 2);
  }

buildWhereClause(group: RuleGroup): string {
 
  const clauses = group.rules
    .map(rule => {
      if (rule.type === 'group') {
        const innerClause = this.buildWhereClause(rule);
        return innerClause ? `(${innerClause})` : '';
      } else {
        const object = rule.object;
        const field = rule.field;
        const operator = rule.operator?.replace(' (field)', '').trim();

        // Skip if object or field is missing
        if (!object || !field || !operator) return '';

        // Quote field name: object.'field'
        const left = `${object}.'${field}'`;

        // Field-to-field comparison
        if (rule.operator.includes('(field)')) {
          if (rule.rhsObject && rule.rhsField) {
            const right = `${rule.rhsObject}.'${rule.rhsField}'`;
            return `${left} ${operator} ${right}`;
          }
          return '';
        }

        // Handle IS NULL / IS NOT NULL
        if (operator === 'IS NULL' || operator === 'IS NOT NULL') {
          return `${left} ${operator}`;
        }

        // IN operator
        if (operator === 'IN') {
          if (!rule.value) return '';
          const values = rule.value
            .split(',')
            .map(v => `'${v.trim()}'`)
            .join(', ');
          return `${left} IN (${values})`;
        }

        // LIKE operator
        if (operator === 'LIKE') {
          if (!rule.value) return '';
          return `${left} LIKE '%${rule.value}%'`;
        }

        // Default case
        // if (rule.value === undefined || rule.value === null || rule.value === '') return '';
        const safeValue = typeof rule.value === 'string' ? `'${rule.value}'` : rule.value;
        return `${left} ${operator} ${safeValue}`;
      }
    })
    .filter(clause => clause && clause.trim() !== '') // remove blanks

  return clauses.length ? clauses.join(` ${group.condition} `) : '';
}



buildAbstractedWhereClause(group: RuleGroup): string {
  const clauses = group.rules
    .map(rule => {
      if (rule.type === 'group') {
        const inner = this.buildAbstractedWhereClause(rule);
        return inner ? `(${inner})` : '';
      } else {
        const field = rule.field;
        const operator = rule.operator?.replace(' (field)', '').trim();

        if (!field || !operator) return '';

        const left = `object.'${field}'`;

        // Field-to-field comparison
        if (rule.operator.includes('(field)') && rule.rhsField) {
          const right = `object.'${rule.rhsField}'`;
          return `${left} ${operator} ${right}`;
        }

        // IS NULL / IS NOT NULL
        if (operator === 'IS NULL' || operator === 'IS NOT NULL') {
          return `${left} ${operator}`;
        }

        // IN operator
        if (operator === 'IN') {
          if (!rule.value) return '';
          const values = rule.value
            .split(',')
            .map(v => `'${v.trim()}'`)
            .join(', ');
          return `${left} IN (${values})`;
        }

        // LIKE operator
        if (operator === 'LIKE') {
          if (!rule.value) return '';
          return `${left} LIKE '%${rule.value}%'`;
        }

        // Default case
        if (rule.value === undefined || rule.value === null || rule.value === '') return '';
        const safeVal = typeof rule.value === 'string' ? `'${rule.value}'` : rule.value;
        return `${left} ${operator} ${safeVal}`;
      }
    })
    .filter(Boolean); // remove empty rules

  return clauses.length ? clauses.join(` ${group.condition} `) : '';
}

  getSQL() {
    return this.buildWhereClause(this.rootGroup);
  }


  getAbstractedSQL() {
  return this.buildAbstractedWhereClause(this.rootGroup);
}

stripUiFields(group: RuleGroup): RuleGroup {
  return {
    type: 'group',
    condition: group.condition,
    rules: group.rules.map(rule => {
      if (rule.type === 'group') {
        return this.stripUiFields(rule); // recursive cleanup for nested groups
      } else {
        const baseRule: any = {
          type: 'rule',
          object: rule.object,
          field: rule.field,
          operator: rule.operator
        };

        if (rule.operator.includes('(field)')) {
          baseRule.rhsObject = rule.rhsObject;
          baseRule.rhsField = rule.rhsField;
        } else {
          baseRule.value = rule.value;
        }

        return baseRule;
      }
    })
  };
}
enrichUiFieldsForEdit(group: RuleGroup): void {
  group.rules.forEach(rule => {
    if (rule.type === 'group') {
      // recursively handle nested groups
      this.enrichUiFieldsForEdit(rule);
    } else {
      // LHS: populate available attributes
      rule.availableAttributes = this.selectedFieldsData
        .filter(attr => attr.object === rule.object)
        .map(attr => attr.name);

      // RHS (only for (field) operators)
      if (rule.operator.includes('(field)') && rule.rhsObject) {
        rule.rhsAvailableAttributes = this.selectedFieldsData
          .filter(attr => attr.object === rule.rhsObject)
          .map(attr => attr.name);
      } else {
        rule.rhsAvailableAttributes = [];
      }
      console.log(rule);
      
    }
  });
}

excelFileUploadForObjects(){
  const tablename= 'stageobjects'
  let selectedNameOfdns
    selectedNameOfdns = this.localStorageSettings.getSettings("dnsName")

 if (!this.SourceId || !this.getdata || this.getdata ===0) {
    this.snackbar.open("Please wait until the stage objects page loads and then try","Ok",{ duration: 5000 });
    return
    }

  console.log(selectedNameOfdns)
  let dialogRef = this.dialog.open(UploadExcelFileComponent, {
              panelClass: 'custom-dialog-container-materialFulfilment',
              width: '95%',
              height:'80%',
              maxWidth:'100vw',
              autoFocus: false,
              data: { edata:tablename,listOfSourceObjects:this.ObjectsData,dnsname:this.SourceId,stageObjectslist:this.getdata,
                globalObjectsList:this.referenceGlobalObjectsList,globalSourceObjectsList:this.referenceSourceGlobalObjectsList,
                externalObjectsList:this.referenceExternalObjectsList,libraryObjectsList:this.referenceLibraryObjectsList,objectGroupData:this.objectGroupData
              
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe(result => {
            console.log(result)
            this.spinner.start();
             if(result){
              this.excelData = result
              this.refreshGridData(); 
              }
              this.refreshGridData();
              this.spinner.stop();
          })
          
      
      }

      searchableReferenceSourceObjects(){
           if(this.referenceSourceObjectsList.length > 0){
                  var columndata = []
                var c = {
                  "objectlabel": "Object Label",
                  "objectname":"Object Name"
                } 
               columndata.push(c)
               let selectedList=[];
               if(this.selectedReferenceSourceObjectsList.length >0){
                  selectedList = this.selectedReferenceSourceObjectsList;
               }
                let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                  width: "50%",
                  autoFocus: false,
                  disableClose: true,
                  data: { 
                    edata:this.referenceSourceObjectsList,
                    page:"multiple",
                    columns:columndata,
                    selectedValue:selectedList,
                    selectedPropertyName:"objectname"
                  }
                });
                 dialogRef.afterClosed().subscribe(result => {
                console.log(result);
                if (result != undefined) {
                  console.log(result.selectedRows);
                  this.selectedReferenceSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
                 this.selectedReferenceSourceObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
                }
                })
              }
        }
getObjectGroup$(){
    this.spinner.start();
    return this.vaultObjectService.retrieveAllobjectgroup(this.localStorageSettings.getSettings("dnsName"), "Extraction Group").pipe(
      tap(res=>{
        if(res){
          this.objectGroupData = res;
        }else{
          this.objectGroupData = [];
        }
      })
    )
}
        onObjectGroupChange(event){
          this.spinner.start();
           console.log(event);
           let objectGroupName=this.objectGroupData.filter(item=>item.objectGroupId == event.value)[0].objectGroupName;
           this.reportCreationData.objectGroupName=objectGroupName;
           console.log(objectGroupName);
          this.commonService.retrieveObjectsBasedOnObjectGroupId(event.value).subscribe((res:any)=>{
          console.log(res);
          if(res.error == true){
                    // this.spinner.stop();
                    // this.listOfObjectsWithGroup=[]
                    this.snackbar.open(res.statusMessage, "OK", {
                      duration: 5000,
                    });
                  }else{
                    // this.listOfObjectsWithGroup=res
                    console.log(res);
                     this.ObjectsData = res;

                    const objects = res.map((item: any, index: number) => ({
                        id: item.objectId || index, // Assign index if id is missing
                        objectlabel: item.objectlabel || item,
                        objectname:item.objectname||item,
                        objectlabelWithEnvName:item.objectlabelWithEnvName|| item
                    }));

                    console.log("Mapped Objects for Grid:", objects);
                    this.ObjectGrid.api.setGridOption('rowData', objects);
                    this.paramstemp.api.setGridOption('rowData', []);
                  }
          
          // this.cdr.detectChanges();
          // this.refreshGridData();
          this.spinner.stop();
        })
        }
   
getSourceReferenceObjects$(){
  
    if (!this.SourceId) return of(null);
    //return this.commonService.retrieveObjectGroupObjectsbasedDns(this.SourceId).pipe(
    return this.commonService.retrieveObjectsByDNSExcludingStage(this.SourceId).pipe(
      tap(res =>{
        console.log(res);
          if(res){
            
          const objects = res.map((item: any, index: number) => ({
              id: item.id || index, // Assign index if id is missing
              objectlabel: item.objectlabel || item,
              objectname: item.objectname || ""
          }));
            this.referenceSourceObjectsList = objects;
            this.commonService.getlookupVauleByLookUpType("Vault Object Group").subscribe(result => {
                  // this.mappingTypeDataDropDown = result;
                  // console.log(this.mappingTypeDataDropDown)
                  let lookupDetails:any=result
                  let ExternalLookupValue=lookupDetails.filter(item=>item.lookupcode=="External")
                  this.referenceLibraryObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Library");
                  this.referenceGlobalObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Global");
                  let lookupValueId=ExternalLookupValue[0].lookupvalueid
                  const externalObjects = res.filter(item=>item.objecttype == lookupValueId);
                   this.referenceExternalObjectsList=externalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                let globalLookupId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                const globalObjects=res.filter(item=>item.objecttype == globalLookupId);
                this.referenceSourceGlobalObjectsList=globalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                 })
          }
      })
    )
         
  }
  getTargetReferenceObjects$(){
    if (!this.targetId) return of(null);
    return this.commonService.retrieveNonStageObjectsbasedDns(this.targetId).pipe(
      tap(res=>{
        if(res){
          console.log(res);
          
           const objects = res.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
console.log(objects);

                  this.referenceTargetObjectsList = objects;

                  let lookupValueId=this.referenceLibraryObjectsLookupValue[0].lookupvalueid
                  const LibraryObjects = res.filter(item=>item.objecttype == lookupValueId);
                   this.referenceLibraryObjectsList=LibraryObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                console.log(this.referenceLibraryObjectsList);

                 let globalLookupValueId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                  const GlobalObjects = res.filter(item=>item.objecttype == globalLookupValueId);
                  
                   this.referenceGlobalObjectsList=GlobalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
               
        }
      })
    )
  }

  searchableReferenceTargetObjects(){
       if(this.getdata.length > 0){
              var columndata = []
            var c = {
                  "datasetname": "Object Label",
                  "description":"Object Name"
                } 
           columndata.push(c)
           let selectedList=[]
           if(this.selectedReferenceTargetObjectsList.length > 0){
              selectedList=this.selectedReferenceTargetObjectsList
           }
           console.log(selectedList);
           
            let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
              width: "50%",
              autoFocus: false,
              disableClose: true,
              data: { 
                edata:this.getdata,
                page:"multiple",
                columns:columndata,
                selectedValue:selectedList,
                selectedPropertyName:"datasetname"
              }
            });
             dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if (result != undefined) {
              console.log(result.selectedRows);
              //  this.selectedReferenceSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
              //    this.selectedReferenceSourceObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
              this.selectedReferenceTargetObjectsList=result.selectedRows.map((item: any) => item.datasetname)
             this.selectedReferenceTargetObjectsListNames = result.selectedRows.map(item => item.datasetname).join(',');
               console.log();
                                                        
            }
            })
          }
    }
searchableReferenceLibraryObjects(){
     if(this.referenceLibraryObjectsList.length > 0){
            var columndata = []
          var c = {
             "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[]
         if(this.selectedReferenceLibraryObjectsList.length > 0){
          selectedList=this.selectedReferenceLibraryObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceLibraryObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceLibraryObjectsList=result.selectedRows.map((item: any) => item.objectname)
           this.selectedReferenceLibraryObjectsListNames = result.selectedRows.map(item => item.objectname).join(',');
             console.log();
                                                      
          }
          })
        }
  }
  searchableReferenceGlobalObjects(){
       if(this.referenceGlobalObjectsList.length > 0){
              var columndata = []
            var c = {
              "objectlabel": "Object Label",
              "objectname":"Object Name"
            } 
           columndata.push(c)
           let selectedList=[];
           if(this.selectedReferenceGlobalObjectsList.length >0){
              selectedList = this.selectedReferenceGlobalObjectsList;
           }
            let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
              width: "50%",
              autoFocus: false,
              disableClose: true,
              data: { 
                edata:this.referenceGlobalObjectsList,
                page:"multiple",
                columns:columndata,
                selectedValue:selectedList,
                selectedPropertyName:"objectname"
              }
            });
             dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if (result != undefined) {
              console.log(result.selectedRows);
              this.selectedReferenceGlobalObjectsList=result.selectedRows.map((item: any) => item.objectname);
             this.selectedReferenceGlobalObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
            }
            })
          }
    }

    searchableReferenceGlobalSourceObjects(){
     if(this.referenceSourceGlobalObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedReferenceGlobalSourceObjectsList.length >0){
            selectedList = this.selectedReferenceGlobalSourceObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceSourceGlobalObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceGlobalSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedReferenceGlobalSourceObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }

    searchableGlobalExternalObjects(){
       if(this.referenceExternalObjectsList.length > 0){
              var columndata = []
            var c = {
              "objectlabel": "Object Label",
              "objectname":"Object Name"
            } 
           columndata.push(c)
           let selectedList=[];
           if(this.selectedGlobalExternalObjectsList.length >0){
              selectedList = this.selectedGlobalExternalObjectsList;
           }
            let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
              width: "50%",
              autoFocus: false,
              disableClose: true,
              data: { 
                edata:this.referenceExternalObjectsList,
                page:"multiple",
                columns:columndata,
                selectedValue:selectedList,
                selectedPropertyName:"objectname"
              }
            });
             dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if (result != undefined) {
              console.log(result.selectedRows);
              this.selectedGlobalExternalObjectsList=result.selectedRows.map((item: any) => item.objectname);
             this.selectedGlobalExternalObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
            }
            })
          }
    }
retrieveMappingDetails$(){
  return this.commonService.retrieveMappingConfiguration().pipe(
    tap(response=>{
      if(response){
        if (response.error == true) {
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
          } else {
            console.log(response)
            this.mappingConfigurationData=response;
            if(this.mappingConfigurationData.length > 0){
            this.mappingConfigurationData=this.mappingConfigurationData.map(obj => ({
              ...obj,
              combined: `${obj.stageobject}_${obj.targetobject}`
            }));
            }
          }
      }
    })
  )
}
retrieveMappingTypes$(){
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    return this.valueMappingservice.retreiveMappingTypes(dnsId).pipe(
      tap(response=>{
        if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", { 
          duration: 5000,
        });
      }else{
        this.codeListData=response;
        if( this.codeListData.length > 0){
        let codeListMappingId =  this.codeListData.filter(item=>item.mappingTypeName == "Codelist_Mapping")
      }
      }

      })
    )
}
viewIcon(updatedata) {
  console.log("VIEW MODE");
  
 this.isViewAction = true;
 this.isEditMode = false;
  this.EditIcon(updatedata,true);
  setTimeout(() => {
    this.cdr.detectChanges();
    console.log("FINAL MODE:", this.isEditMode);
  }, 0);

}

  searchableTargetObjectsForRefDBObjectName(){
       if(this.referenceTargetObjectsList.length > 0){
              var columndata = []
            var c = {
              "objectlabel": "Object Label",
              "objectname":"Object Name"
            } 
           columndata.push(c)
           let selectedList=[];
           if(this.selectedRefDBObjectNameList.length >0){
              selectedList = this.selectedRefDBObjectNameList;
           }
            let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
              width: "50%",
              autoFocus: false,
              disableClose: true,
              data: { 
                edata:this.referenceTargetObjectsList,
                page:"multiple",
                columns:columndata,
                selectedValue:selectedList,
                selectedPropertyName:"objectname"
              }
            });
             dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if (result != undefined) {
              console.log(result.selectedRows);
              this.selectedRefDBObjectNameList=result.selectedRows.map((item: any) => item.objectname);
             this.selectedRefDBObjectNameListNames =result.selectedRows.map(item => item.objectname).join(',');
            }
            })
          }
    }

onExpressionChange(value: string): void {
  this.expressionDetails = value;

  this.validations_form
    .get('expressionQuery')
    ?.setValue(value);

  this.validations_form
    .get('expressionQuery')
    ?.markAsTouched();
}
    
  searchableTargetObjectsForRefDBObjectNameFetchPartials(){
       if(this.referenceTargetObjectsList.length > 0){
              var columndata = []
            var c = {
              "objectlabel": "Object Label",
              "objectname":"Object Name"
            } 
           columndata.push(c)
           let selectedList=[];
           if(this.selectedRefDBObjectNameFetchPartialsList.length >0){
              selectedList = this.selectedRefDBObjectNameFetchPartialsList;
           }
            let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
              width: "50%",
              autoFocus: false,
              disableClose: true,
              data: { 
                edata:this.referenceTargetObjectsList,
                page:"multiple",
                columns:columndata,
                selectedValue:selectedList,
                selectedPropertyName:"objectname"
              }
            });
             dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if (result != undefined) {
              console.log(result.selectedRows);
              this.selectedRefDBObjectNameFetchPartialsList=result.selectedRows.map((item: any) => item.objectname);
             this.selectedRefDBObjectNameFetchPartialsListNames =result.selectedRows.map(item => item.objectname).join(',');
            }
            })
          }
    }

}



// this is used for making the editable cell to enter only numeric values in ag grid table
function getNumericCellEditor() {


  // function isCharNumeric(charStr) {

  //   return !!/\d/.test(charStr);
  // }
  // function isKeyPressedNumeric(event) {
  //   var charCode = getCharCodeFromEvent(event);
  //   var charStr = String.fromCharCode(charCode);
  //   return isCharNumeric(charStr);
  // }

  function getCharCodeFromEvent(event) {

    event = event || window.event;
    return typeof event.which === 'undefined' ? event.keyCode : event.which;
  }
  function NumericCellEditor() { }
  NumericCellEditor.prototype.init = function (params) {
    this.focusAfterAttached = params.cellStartedEdit;
    this.eInput = document.createElement('input');
    this.eInput.style.width = '100%';
    this.eInput.style.height = '100%';

    // this.eInput.value = isCharNumeric(params.charPress)
    //   ? params.charPress
    //  : params.value;
    var that = this;

    // KeyDown event is used when the user clicks on the Control + V
    this.eInput.addEventListener('keydown', function (event) {
      if ((event.ctrlKey || event.metaKey) && event.keyCode == 86) {
        that.eInput.focus();
        if (event.preventDefault) event.preventDefault();
      }
    });

    this.eInput.addEventListener('keypress', function (event) {
      // if (!isKeyPressedNumeric(event)) {
      //   that.eInput.focus();
      //   if (event.preventDefault) event.preventDefault();
      // }


    });
  };
  NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
  };
  NumericCellEditor.prototype.afterGuiAttached = function () {
    if (this.focusAfterAttached) {
      this.eInput.focus();
      this.eInput.select();
    }
  };
  NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
  };
  NumericCellEditor.prototype.isCancelAfterEnd = function () { };
  NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
  };
  NumericCellEditor.prototype.focusIn = function () {
    var eInput = this.getGui();
    eInput.focus();
    eInput.select();
    console.log('NumericCellEditor.focusIn()');
  };
  NumericCellEditor.prototype.focusOut = function () {
    console.log('NumericCellEditor.focusOut()');
  };
  return NumericCellEditor;
}


function groupHeadersByType(headers) {
  const grouped: { [key: string]: string[] } = {};

  // Group header keys by headerKeyType
  headers.forEach((header) => {
    if (!grouped[header.headerKeyType]) {
      grouped[header.headerKeyType] = [];
    }
    grouped[header.headerKeyType].push(header.headerKey);
  });

  // Convert grouped object into the desired array format
  return Object.entries(grouped).map(([keyType, headerKeys]) => ({
    headerKey: headerKeys.join(","),
    headerKeyObject: "",
    headerKeyType: keyType,
    headerKeyAlias: ""
  }));
}
function findCommonValue(arr1: string[], arr2: string[]): string {
  // Use a Set for efficient lookups
  const set1 = new Set(arr1);

  // Iterate through the second array and check for common values
  for (const value of arr2) {
    if (set1.has(value)) {
      return value; // Return the first common value found
    }
  }

  // If no common value is found, return an empty string
  return "";
}


  
 
 